// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/components/realtorauto/RealtorAutoApp.tsx
// Source SHA-256: d25c2d262968ad14036a95803ebef47a3876d5ba636e631394e06cda1519a1e9
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
import { Check, Pencil, Minus, Plus, Printer, X, Undo2, Redo2, Bold, Italic, Search } from "lucide-react";
import { useState, useRef, useEffect, useCallback, useMemo, Fragment, Children, isValidElement, cloneElement } from "react";
import { normalizeDocumentTextLayerCustomText, normalizeExplanationTextLayerCustomText, EXPLANATION_FORM_CHECK_OVERLAYS as SHARED_EXPLANATION_FORM_CHECK_OVERLAYS, explanationCheckOverlayBelongsToForm, normalizeExplanationContractTypeOption, EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX, EXPLANATION_FORM_TEXT_OVERLAYS as SHARED_EXPLANATION_FORM_TEXT_OVERLAYS, formatExplanationObjectAddressLines, formatExplanationAddressOverlayValue, explanationCheckOverlayMatchesState, shouldSplitExplanationAddressOverlayText, formatExplanationAddressFallbackTwoLines, explanationOverlayTextIsMultiline, explanationOverlayTextFontSizePt, EXPLANATION_FORM_PAGE_WIDTH_PT, EXPLANATION_FORM_PAGE_HEIGHT_PT, explanationOverlayTextLineHeightPt, explanationOverlayNeedsWideInset, EXPLANATION_FORM_LEFT_TEXT_INSET_PX, EXPLANATION_FORM_CHECK_HIT_WIDTH, EXPLANATION_FORM_CHECK_HIT_HEIGHT, explanationOverlayIsAddressField, explanationOverlayTextMinimumFontSizePt } from "./realtorauto-explanation-form-overlays";
import { normalizeTemplateRichHtmlFromElement, escapeTemplateRichText, useAutoFitTextElement, AutomationLockedField, TemplateInlineTextEditor } from "./RealtorAutoDocumentLayerEditorModal";
import { formatRealtorAutoSquareMeterDisplay, normalizeRealtorAutoAreaUnitLabel } from "./realtorauto-area-display";
import { RealtorAutoExplanationDirectCheckPanel } from "./RealtorAutoExplanationDirectCheckPanel";
const DOCUMENT_VIEWER_BACKDROP_CLASS = 'fixed inset-0 z-[120] flex h-dvh w-screen overflow-hidden bg-slate-950';
const DOCUMENT_VIEWER_SHELL_CLASS = 'flex h-dvh max-h-dvh w-full min-w-0 flex-col overflow-hidden bg-slate-950 text-white shadow-2xl';
const DOCUMENT_VIEWER_TOOLBAR_CLASS = 'flex shrink-0 items-center justify-end gap-1 border-b border-slate-800 bg-slate-950 px-3 py-2';
const DOCUMENT_VIEWER_ICON_BUTTON_CLASS = 'inline-flex h-9 w-10 items-center justify-center rounded-lg border border-slate-700 bg-slate-900 text-white hover:bg-slate-800 hover:text-blue-200 active:bg-slate-800';
const DOCUMENT_VIEWER_SCROLL_CLASS = 'min-h-0 flex-1 overflow-scroll overscroll-contain bg-slate-950 p-3 touch-pan-x touch-pan-y touch-pinch-zoom';
function IeumViewer({
  kind,
  zoomLabel,
  children,
  onZoomOut,
  onZoomIn,
  onPrint,
  onClose,
  onWheel,
  modal = false,
  sharedModal = false,
  toolbarDataAttribute = false,
  title,
  fileName,
  pageNote
}) {
  const frameClassName = modal ? DOCUMENT_VIEWER_BACKDROP_CLASS : 'flex min-h-0 flex-1 flex-col bg-slate-950 print:bg-white';
  const shellClassName = modal ? DOCUMENT_VIEWER_SHELL_CLASS : 'flex min-h-0 flex-1 flex-col overflow-hidden bg-slate-950 text-white print:bg-white';
  const zoomLabelClassName = 'inline-flex h-9 min-w-14 items-center justify-center rounded-lg px-2 text-center text-xs font-black text-white';
  const scrollRef = useRef(null);
  useEffect(() => {
    if (!onWheel) return undefined;
    const scrollElement = scrollRef.current;
    if (!scrollElement) return undefined;
    const handleNativeWheel = event => {
      onWheel(event);
    };
    scrollElement.addEventListener('wheel', handleNativeWheel, {
      passive: false
    });
    return () => {
      scrollElement.removeEventListener('wheel', handleNativeWheel);
    };
  }, [onWheel]);
  return <div className={frameClassName} data-realtorauto-document-viewer={kind} data-document-preview-modal={modal && !sharedModal ? true : undefined} data-shared-document-preview-modal={modal && sharedModal ? true : undefined}>
      <section className={shellClassName}>
        {title || fileName || pageNote ? <div className="sr-only">
            {title ? <span>{title}</span> : null}
            {fileName ? <span>{fileName}</span> : null}
            {pageNote ? <span>{pageNote}</span> : null}
          </div> : null}
        <div className={DOCUMENT_VIEWER_TOOLBAR_CLASS} data-document-preview-mobile-toolbar={toolbarDataAttribute ? true : undefined}>
          <button type="button" onClick={onZoomOut} className={DOCUMENT_VIEWER_ICON_BUTTON_CLASS} title="축소" aria-label="축소">
            <Minus className="h-4 w-4" aria-hidden />
          </button>
          <span className={zoomLabelClassName}>{zoomLabel}</span>
          <button type="button" onClick={onZoomIn} className={DOCUMENT_VIEWER_ICON_BUTTON_CLASS} title="확대" aria-label="확대">
            <Plus className="h-4 w-4" aria-hidden />
          </button>
          <button type="button" onClick={onPrint} className={DOCUMENT_VIEWER_ICON_BUTTON_CLASS} title="인쇄" aria-label="인쇄">
            <Printer className="h-4 w-4" aria-hidden />
          </button>
          {onClose ? <button type="button" onClick={onClose} className={DOCUMENT_VIEWER_ICON_BUTTON_CLASS} title="닫기" aria-label="닫기">
              <X className="h-4 w-4" aria-hidden />
            </button> : null}
        </div>
        <div ref={scrollRef} className={DOCUMENT_VIEWER_SCROLL_CLASS}>
          {children}
        </div>
      </section>
    </div>;
}
const SIMPLIFIED_CONTRACT_CLOSING_TEXT = '본 계약을 증명하기 위하여 계약 당사자가 이의 없음을 확인하고 각각 서명․날인한다                      년     월     일';
const EXPLANATION_LEGAL_FORMS = [{
  key: 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING',
  label: 'Ⅰ 주거용 건축물',
  title: '중개대상물 확인ㆍ설명서[Ⅰ] (주거용 건축물)',
  appliesTo: '아파트, 주거용 오피스텔, 단독주택, 다세대주택',
  autoRule: 'propertyType=RESIDENTIAL',
  currentScope: true,
  sourcePath: '/legal-forms/explanation-form-i-residential-building-ko.pdf'
}, {
  key: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  label: 'Ⅱ 비주거용 건축물',
  title: '중개대상물 확인ㆍ설명서[Ⅱ] (비주거용 건축물)',
  appliesTo: '상가',
  autoRule: 'propertyType=COMMERCIAL',
  currentScope: true,
  sourcePath: '/legal-forms/explanation-form-ii-nonresidential-building-ko.pdf'
}, {
  key: 'EXPLANATION_FORM_III_LAND',
  label: 'Ⅲ 토지',
  title: '중개대상물 확인ㆍ설명서[Ⅲ] (토지)',
  appliesTo: '토지 매매ㆍ교환ㆍ임대',
  autoRule: '토지 상품군 추가 시 자동첨부',
  currentScope: false,
  sourcePath: '/legal-forms/explanation-form-iii-land-ko.pdf'
}, {
  key: 'EXPLANATION_FORM_IV_FOUNDATION',
  label: 'Ⅳ 입목ㆍ광업재단ㆍ공장재단',
  title: '중개대상물 확인ㆍ설명서[Ⅳ] (입목ㆍ광업재단ㆍ공장재단)',
  appliesTo: '입목, 광업재단, 공장재단 매매ㆍ교환ㆍ임대',
  autoRule: '특수 재단 상품군 추가 시 자동첨부',
  currentScope: false,
  sourcePath: '/legal-forms/explanation-form-iv-foundation-ko.pdf'
}];
const DEFAULT_EXPLANATION_CHECK_ITEMS = [{
  key: 'source-documents',
  section: '확인ㆍ설명 근거자료',
  label: '등기사항증명서, 전유부대장, 토지대장, 지적도, 토지이용계획확인서 대조',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '공부서류 연결/발급 결과와 계약방 주소 기준으로 자동 대조, 필요 시 중개사가 수동 보정',
  formSection: '확인ㆍ설명자료 > 확인ㆍ설명 근거자료 등'
}, {
  key: 'object-display',
  section: '대상물건 표시',
  label: '소재지, 지목, 면적, 용도, 구조, 건축물명, 대지권 표시',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '주소 검색값, 전유부대장, 토지대장, 계약방 입력값을 계약서류에 자동 반영',
  formSection: 'Ⅰ. 중개대상물의 표시'
}, {
  key: 'rights',
  section: '권리관계',
  label: '소유권, 소유권 외 권리, 근저당, 압류, 가압류, 임차권 등 권리사항',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '등기부등본 갑구/을구 분석값 기준, 실제 발급 원본 대조',
  formSection: '② 권리관계'
}, {
  key: 'legal-restrictions',
  section: '공법상 제한',
  label: '용도지역ㆍ지구, 건폐율ㆍ용적률, 허가ㆍ신고구역, 거래규제, 위반건축물 여부',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '건축물대장/토지이용계획확인 연동 예정, 미연동 시 수동 확인',
  formSection: '③ 공법상 이용제한 및 거래규제',
  options: [{
    value: 'violation',
    label: '위반건축물'
  }, {
    value: 'legal',
    label: '적법'
  }]
}, {
  key: 'lease-priority',
  section: '임대차 확인사항',
  label: '확정일자 부여현황, 전입세대확인서, 국세ㆍ지방세 납세증명서, 최우선변제금',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '임대차 계약인 경우 우선변제 관련 서류 확보 여부를 자동 체크, 미발급 항목은 중개사 확인',
  formSection: '④ 임대차 확인사항'
}, {
  key: 'lease-fixed-date-landlord-submit',
  section: '임대차 확인사항',
  label: '확정일자 부여현황 정보: 임대인 자료 제출',
  status: 'NOT_APPLICABLE',
  source: 'AUTO_OR_MANUAL',
  automation: '확정일자 부여현황 서류 확보 또는 중개사 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 확정일자 부여현황 정보'
}, {
  key: 'lease-fixed-date-view-consent',
  section: '임대차 확인사항',
  label: '확정일자 부여현황 정보: 열람 동의',
  status: 'NOT_APPLICABLE',
  source: 'AUTO_OR_MANUAL',
  automation: '확정일자 부여현황 열람 동의 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 확정일자 부여현황 정보'
}, {
  key: 'lease-fixed-date-tenant-rights',
  section: '임대차 확인사항',
  label: '확정일자 부여현황 정보: 임차인 권리 설명',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '임차인 권리 설명 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 확정일자 부여현황 정보'
}, {
  key: 'lease-tax-landlord-submit',
  section: '임대차 확인사항',
  label: '국세 및 지방세 체납정보: 임대인 자료 제출',
  status: 'NOT_APPLICABLE',
  source: 'AUTO_OR_MANUAL',
  automation: '국세 및 지방세 체납정보 자료 제출 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 국세 및 지방세 체납정보'
}, {
  key: 'lease-tax-view-consent',
  section: '임대차 확인사항',
  label: '국세 및 지방세 체납정보: 열람 동의',
  status: 'NOT_APPLICABLE',
  source: 'AUTO_OR_MANUAL',
  automation: '국세 및 지방세 체납정보 열람 동의 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 국세 및 지방세 체납정보'
}, {
  key: 'lease-tax-tenant-rights',
  section: '임대차 확인사항',
  label: '국세 및 지방세 체납정보: 임차인 권리 설명',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '국세 및 지방세 체납정보 설명 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 국세 및 지방세 체납정보'
}, {
  key: 'lease-household-confirmation',
  section: '임대차 확인사항',
  label: '전입세대 확인서',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '전입세대 확인서 확인/미확인/해당없음 선택값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 전입세대 확인서',
  selectedOption: 'not-applicable',
  options: [{
    value: 'confirmed',
    label: '확인'
  }, {
    value: 'unconfirmed',
    label: '미확인'
  }, {
    value: 'not-applicable',
    label: '해당 없음'
  }]
}, {
  key: 'lease-private-rental-type',
  section: '임대차 확인사항',
  label: '민간임대등록 유형',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '민간임대등록 여부 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 민간임대등록 여부',
  selectedOption: 'public-support',
  options: [{
    value: 'public-support',
    label: '공공지원민간임대주택'
  }]
}, {
  key: 'lease-deposit-guarantee-explanation',
  section: '임대차 확인사항',
  label: '임대보증금 보증 설명',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '임대보증금 보증 설명 확인값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 민간임대등록 여부'
}, {
  key: 'lease-renewal-claim',
  section: '임대차 확인사항',
  label: '계약갱신 요구권 행사 여부',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '계약갱신 요구권 확인/미확인/해당없음 선택값과 문서 체크박스를 동기화',
  formSection: '④ 임대차 확인사항 > 계약갱신 요구권 행사 여부',
  selectedOption: 'not-applicable',
  options: [{
    value: 'confirmed',
    label: '확인'
  }, {
    value: 'unconfirmed',
    label: '미확인'
  }, {
    value: 'not-applicable',
    label: '해당 없음'
  }]
}, {
  key: 'location-conditions',
  section: '입지조건',
  label: '도로, 대중교통, 주차장, 교육시설, 판매ㆍ의료시설, 비선호시설',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: 'API 확정값을 우선 반영하고, API로 확정되지 않은 항목만 중개사가 직접 체크',
  formSection: '입지조건/환경조건'
}, {
  key: 'location-road',
  section: '입지조건',
  label: '도로와의 관계',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '도로 폭/포장 상태 API 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 도로와의 관계',
  options: [{
    value: 'paved',
    label: '포장'
  }, {
    value: 'unpaved',
    label: '비포장'
  }]
}, {
  key: 'location-accessibility',
  section: '입지조건',
  label: '접근성',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '입지/교통 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 접근성',
  options: [{
    value: 'easy',
    label: '용이함'
  }, {
    value: 'inconvenient',
    label: '불편함'
  }]
}, {
  key: 'location-bus-mode',
  section: '입지조건',
  label: '버스 소요시간 이동수단',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '버스 정류장명/소요시간 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 대중교통',
  options: [{
    value: 'walk',
    label: '도보'
  }, {
    value: 'car',
    label: '차량'
  }]
}, {
  key: 'location-subway-mode',
  section: '입지조건',
  label: '지하철 소요시간 이동수단',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '지하철역명/소요시간 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 대중교통',
  options: [{
    value: 'walk',
    label: '도보'
  }, {
    value: 'car',
    label: '차량'
  }]
}, {
  key: 'location-parking',
  section: '입지조건',
  label: '주차장',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '건축물대장 주차정보 또는 중개사 선택값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 주차장',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exclusive',
    label: '전용주차시설'
  }, {
    value: 'common',
    label: '공동주차시설'
  }, {
    value: 'other',
    label: '그 밖의 주차시설'
  }]
}, {
  key: 'location-elementary-mode',
  section: '입지조건',
  label: '초등학교 소요시간 이동수단',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '초등학교명/소요시간 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 교육시설',
  options: [{
    value: 'walk',
    label: '도보'
  }, {
    value: 'car',
    label: '차량'
  }]
}, {
  key: 'location-middle-mode',
  section: '입지조건',
  label: '중학교 소요시간 이동수단',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '중학교명/소요시간 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 교육시설',
  options: [{
    value: 'walk',
    label: '도보'
  }, {
    value: 'car',
    label: '차량'
  }]
}, {
  key: 'location-high-mode',
  section: '입지조건',
  label: '고등학교 소요시간 이동수단',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '고등학교명/소요시간 API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑤ 입지조건 > 교육시설',
  options: [{
    value: 'walk',
    label: '도보'
  }, {
    value: 'car',
    label: '차량'
  }]
}, {
  key: 'management-fee',
  section: '관리 및 비용',
  label: '관리주체, 관리비, 포함 비목, 사용료 정산 기준',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '계약방 입력값과 확인설명서 체크값 기준으로 자동 표기, 세부 비목은 중개사 확인',
  formSection: '관리비/관리사항'
}, {
  key: 'management-security-room',
  section: '관리 및 비용',
  label: '경비실',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 기본정보 API 값 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 경비실',
  options: [{
    value: 'exists',
    label: '있음'
  }, {
    value: 'none',
    label: '없음'
  }]
}, {
  key: 'management-subject',
  section: '관리 및 비용',
  label: '관리주체',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 기본정보 API 관리방식 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리주체',
  options: [{
    value: 'entrusted',
    label: '위탁관리'
  }, {
    value: 'self',
    label: '자체관리'
  }, {
    value: 'other',
    label: '그 밖의 유형'
  }]
}, {
  key: 'management-fee-electricity',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 전기료',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 개별사용료 API 전기료 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-water',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 수도료',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 개별사용료 API 수도료 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-gas',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 가스사용료',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 개별사용료 API 가스사용료 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-heating',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 난방비',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 개별사용료 API 난방비 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-internet',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 인터넷 사용료',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 관리비 API 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-tv',
  section: '관리 및 비용',
  label: '관리비 포함 비목: TV 수신료',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '관리비 포함 비목 API 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-fee-other',
  section: '관리 및 비용',
  label: '관리비 포함 비목: 그 밖의 항목',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '관리비 포함 비목 API 항목 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 포함 비목'
}, {
  key: 'management-charge-method',
  section: '관리 및 비용',
  label: '관리비 부과방식',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: '공동주택 관리비 부과방식 API 값 또는 중개사 수동 확인값과 문서 체크박스를 동기화',
  formSection: '⑥ 관리에 관한 사항 > 관리비 부과방식',
  options: [{
    value: 'direct',
    label: '임대인이 직접 부과'
  }, {
    value: 'rules',
    label: '관리규약에 따라 부과'
  }, {
    value: 'other',
    label: '그 밖의 부과 방식'
  }]
}, {
  key: 'location-disliked-facility',
  section: '입지조건',
  label: '비선호시설(1km 이내)',
  status: 'NEEDS_CHECK',
  source: 'AUTO_OR_MANUAL',
  automation: 'POI/API 확정값 또는 중개사 직접 확인값과 문서 체크박스를 동기화',
  formSection: '⑦ 비선호시설(1km 이내)',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exists',
    label: '있음'
  }]
}, {
  key: 'facility-state',
  section: '시설ㆍ상태',
  label: '수도, 전기, 배수 등 기본 시설 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '현장 확인 및 중개사 체크',
  formSection: '내부ㆍ외부 시설물 상태'
}, {
  key: 'facility-water-damage',
  section: '내부·외부 시설물의 상태',
  label: '수도 파손 여부',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑪ 내부·외부 시설물의 상태 > 수도',
  selectedOption: 'none',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exists',
    label: '있음'
  }]
}, {
  key: 'facility-water-capacity',
  section: '내부·외부 시설물의 상태',
  label: '수도 용수량',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑪ 내부·외부 시설물의 상태 > 수도',
  selectedOption: 'normal',
  options: [{
    value: 'normal',
    label: '정상'
  }, {
    value: 'insufficient',
    label: '부족함'
  }]
}, {
  key: 'facility-electric',
  section: '내부·외부 시설물의 상태',
  label: '전기 공급상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑪ 내부·외부 시설물의 상태 > 전기',
  selectedOption: 'normal',
  options: [{
    value: 'normal',
    label: '정상'
  }, {
    value: 'repair',
    label: '교체 필요'
  }]
}, {
  key: 'facility-gas',
  section: '가스(취사용)',
  label: '취사용 가스 공급방식',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 도시가스/그 밖의 방식/해당 없음 중 선택',
  formSection: '⑪ 내부ㆍ외부 시설물의 상태 > 가스(취사용)',
  selectedOption: 'city-gas',
  options: [{
    value: 'city-gas',
    label: '도시가스'
  }, {
    value: 'other',
    label: '그 밖의 방식'
  }, {
    value: 'none',
    label: '해당 없음'
  }]
}, {
  key: 'facility-fire',
  section: '소방',
  label: '단독경보형 감지기',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 없음/있음 중 선택',
  formSection: '⑪ 내부ㆍ외부 시설물의 상태 > 소방',
  selectedOption: 'none',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exists',
    label: '있음'
  }]
}, {
  key: 'facility-heating',
  section: '난방방식 및 연료공급',
  label: '난방 공급방식 및 시설작동',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 중앙/개별/지역난방과 정상/수선 필요 여부를 선택',
  formSection: '⑪ 내부ㆍ외부 시설물의 상태 > 난방방식 및 연료공급',
  selectedOption: 'district-heating',
  options: [{
    value: 'central-heating',
    label: '중앙공급'
  }, {
    value: 'individual-heating',
    label: '개별공급'
  }, {
    value: 'district-heating',
    label: '지역난방'
  }, {
    value: 'check-needed',
    label: '확인불가'
  }]
}, {
  key: 'facility-heating-action',
  section: '난방방식 및 연료공급',
  label: '난방 시설작동 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑪ 내부·외부 시설물의 상태 > 난방방식 및 연료공급',
  selectedOption: 'normal',
  options: [{
    value: 'normal',
    label: '정상'
  }, {
    value: 'repair',
    label: '수선 필요'
  }, {
    value: 'unknown',
    label: '확인불가'
  }]
}, {
  key: 'facility-fuel',
  section: '난방방식 및 연료공급',
  label: '연료 종류',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 도시가스/기름/프로판가스/연탄/그 밖의 종류를 선택',
  formSection: '⑪ 내부ㆍ외부 시설물의 상태 > 난방방식 및 연료공급',
  selectedOption: 'city-gas',
  options: [{
    value: 'city-gas',
    label: '도시가스'
  }, {
    value: 'oil',
    label: '기름'
  }, {
    value: 'propane',
    label: '프로판가스'
  }, {
    value: 'coal',
    label: '연탄'
  }, {
    value: 'other',
    label: '그 밖의 종류'
  }]
}, {
  key: 'facility-elevator',
  section: '승강기',
  label: '승강기 유무 및 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 있음/양호, 있음/불량, 없음 중 선택',
  formSection: '⑪ 내부ㆍ외부 시설물의 상태 > 승강기',
  selectedOption: 'exists-good',
  options: [{
    value: 'exists-good',
    label: '있음/양호'
  }, {
    value: 'exists-repair',
    label: '있음/불량'
  }, {
    value: 'none',
    label: '없음'
  }]
}, {
  key: 'facility-drain',
  section: '내부·외부 시설물의 상태',
  label: '배수 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑪ 내부·외부 시설물의 상태 > 배수',
  selectedOption: 'normal',
  options: [{
    value: 'normal',
    label: '정상'
  }, {
    value: 'repair',
    label: '수선 필요'
  }]
}, {
  key: 'site-guide',
  section: '현장안내',
  label: '현장안내자',
  status: 'OK',
  source: 'MANUAL',
  automation: '신청 화면에서 개업공인중개사/소속공인중개사/중개보조원/해당 없음 중 선택',
  formSection: '⑭ 현장안내 > 현장안내자',
  selectedOption: 'licensed-broker',
  options: [{
    value: 'licensed-broker',
    label: '개업공인중개사'
  }, {
    value: 'affiliated-broker',
    label: '소속공인중개사'
  }, {
    value: 'assistant',
    label: '중개보조원'
  }, {
    value: 'none',
    label: '해당 없음'
  }]
}, {
  key: 'site-guide-notice',
  section: '현장안내',
  label: '중개보조원 신분고지 여부',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 신분고지 예/아니오와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑭ 현장안내 > 중개보조원 신분고지 여부',
  selectedOption: 'yes',
  options: [{
    value: 'yes',
    label: '예'
  }, {
    value: 'no',
    label: '아니오'
  }]
}, {
  key: 'wall-floor-papering',
  section: '벽면ㆍ바닥ㆍ도배 상태',
  label: '벽면, 바닥, 천장, 도배, 장판, 누수ㆍ균열 등 마감 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '공적서류만으로 확정하지 않고 기본값은 이상없음으로 두며, 현장 확인/의뢰인 고지로 보정',
  formSection: '내부ㆍ외부 시설물의 상태'
}, {
  key: 'wall-crack',
  section: '벽면·바닥면 및 도배 상태',
  label: '벽면 균열',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑫ 벽면·바닥면 및 도배 상태 > 벽면',
  selectedOption: 'none',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exists',
    label: '있음'
  }]
}, {
  key: 'wall-leak',
  section: '벽면·바닥면 및 도배 상태',
  label: '벽면 누수',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑫ 벽면·바닥면 및 도배 상태 > 벽면',
  selectedOption: 'none',
  options: [{
    value: 'none',
    label: '없음'
  }, {
    value: 'exists',
    label: '있음'
  }]
}, {
  key: 'floor-state',
  section: '벽면·바닥면 및 도배 상태',
  label: '바닥면 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑫ 벽면·바닥면 및 도배 상태 > 바닥면',
  selectedOption: 'clean',
  options: [{
    value: 'clean',
    label: '깨끗함'
  }, {
    value: 'normal',
    label: '보통임'
  }, {
    value: 'repair',
    label: '수리 필요'
  }]
}, {
  key: 'papering-state',
  section: '벽면·바닥면 및 도배 상태',
  label: '도배 상태',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑫ 벽면·바닥면 및 도배 상태 > 도배',
  selectedOption: 'clean',
  options: [{
    value: 'clean',
    label: '깨끗함'
  }, {
    value: 'normal',
    label: '보통임'
  }, {
    value: 'repair',
    label: '도배 필요'
  }]
}, {
  key: 'environment-conditions',
  section: '환경조건',
  label: '일조, 소음, 진동, 악취, 분진, 조망, 인접 비선호시설 등',
  status: 'OK',
  source: 'MANUAL',
  automation: '공적서류만으로 확정하지 않고 기본값은 이상없음으로 두며, 현장 확인/의뢰인 고지로 보정',
  formSection: '환경조건'
}, {
  key: 'environment-light',
  section: '환경조건',
  label: '일조량',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑬ 환경조건 > 일조량',
  selectedOption: 'normal',
  options: [{
    value: 'abundant',
    label: '풍부함'
  }, {
    value: 'normal',
    label: '보통임'
  }, {
    value: 'insufficient',
    label: '불충분'
  }]
}, {
  key: 'environment-noise',
  section: '환경조건',
  label: '소음',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑬ 환경조건 > 소음',
  selectedOption: 'normal',
  options: [{
    value: 'very-low',
    label: '아주 작음'
  }, {
    value: 'normal',
    label: '보통임'
  }, {
    value: 'severe',
    label: '심한 편임'
  }]
}, {
  key: 'environment-vibration',
  section: '환경조건',
  label: '진동',
  status: 'OK',
  source: 'MANUAL',
  automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
  formSection: '⑬ 환경조건 > 진동',
  selectedOption: 'normal',
  options: [{
    value: 'very-low',
    label: '아주 작음'
  }, {
    value: 'normal',
    label: '보통임'
  }, {
    value: 'severe',
    label: '심한 편임'
  }]
}, {
  key: 'tax-fee',
  section: '거래비용',
  label: '거래예정금액, 공시가격, 취득 시 부담 조세, 중개보수, 실비 안내',
  status: 'OK',
  source: 'AUTO_OR_MANUAL',
  automation: '계약금액 입력값 기준 계산 보조, 최종 고지는 중개사 확인',
  formSection: '거래예정금액 및 조세ㆍ중개보수'
}];
const LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY = {
  'lease-household-confirmation': 'not-applicable',
  'lease-private-rental-type': 'public-support',
  'lease-renewal-claim': 'not-applicable',
  'location-road': 'paved',
  'location-accessibility': 'easy',
  'location-bus-mode': 'walk',
  'location-subway-mode': 'walk',
  'location-parking': 'other',
  'location-elementary-mode': 'walk',
  'location-middle-mode': 'walk',
  'location-high-mode': 'walk',
  'location-disliked-facility': 'none',
  'facility-water-damage': 'none',
  'facility-water-capacity': 'normal',
  'facility-electric': 'normal',
  'facility-gas': 'city-gas',
  'facility-fire': 'none',
  'facility-heating': 'district-heating',
  'facility-heating-action': 'normal',
  'facility-fuel': 'city-gas',
  'facility-elevator': 'exists-good',
  'facility-drain': 'normal',
  'site-guide': 'licensed-broker',
  'site-guide-notice': 'yes',
  'wall-crack': 'none',
  'wall-leak': 'none',
  'floor-state': 'clean',
  'papering-state': 'clean',
  'environment-light': 'normal',
  'environment-noise': 'normal',
  'environment-vibration': 'normal'
};
const LEGACY_IMPLICIT_EXPLANATION_STATUS_KEYS = new Set(['source-documents', 'lease-priority', 'lease-fixed-date-tenant-rights', 'lease-tax-tenant-rights', 'management-fee', 'facility-state', 'wall-floor-papering', 'environment-conditions']);
const DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS = new Set([...Object.keys(LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY), 'lease-fixed-date-landlord-submit', 'lease-fixed-date-view-consent', 'lease-fixed-date-tenant-rights', 'lease-tax-landlord-submit', 'lease-tax-view-consent', 'lease-tax-tenant-rights', 'lease-deposit-guarantee-explanation', 'management-security-room', 'management-subject', 'management-fee-electricity', 'management-fee-water', 'management-fee-gas', 'management-fee-heating', 'management-fee-internet', 'management-fee-tv', 'management-fee-other', 'management-charge-method']);
const MANAGEMENT_FEE_DIRECT_CHECK_KEYS = new Set(['management-fee-electricity', 'management-fee-water', 'management-fee-gas', 'management-fee-heating', 'management-fee-internet', 'management-fee-tv', 'management-fee-other']);
const DEFAULT_MANAGEMENT_FEE_DIRECT_CHECK_KEYS = new Set(['management-fee-electricity', 'management-fee-water', 'management-fee-heating']);
const MANAGEMENT_FEE_DIRECT_CHECK_ORDER = ['management-fee-electricity', 'management-fee-water', 'management-fee-heating', 'management-fee-gas', 'management-fee-internet', 'management-fee-tv', 'management-fee-other'];
const LEASE_CONFIRMATION_BUNDLE_ITEMS = [{
  key: 'lease-fixed-date-landlord-submit'
}, {
  key: 'lease-fixed-date-view-consent'
}, {
  key: 'lease-fixed-date-tenant-rights'
}, {
  key: 'lease-tax-landlord-submit'
}, {
  key: 'lease-tax-view-consent'
}, {
  key: 'lease-tax-tenant-rights'
}, {
  key: 'lease-household-confirmation',
  defaultOption: 'not-applicable'
}, {
  key: 'lease-private-rental-type',
  defaultOption: 'public-support'
}, {
  key: 'lease-deposit-guarantee-explanation'
}, {
  key: 'lease-renewal-claim',
  defaultOption: 'not-applicable'
}];
const BASIC_FACILITY_BUNDLE_ITEMS = [{
  key: 'facility-water-damage',
  defaultOption: 'none'
}, {
  key: 'facility-water-capacity',
  defaultOption: 'normal'
}, {
  key: 'facility-electric',
  defaultOption: 'normal'
}, {
  key: 'facility-heating-action',
  defaultOption: 'normal'
}, {
  key: 'facility-drain',
  defaultOption: 'normal'
}];
const WALL_ENVIRONMENT_BUNDLE_ITEMS = [{
  key: 'wall-crack',
  defaultOption: 'none'
}, {
  key: 'wall-leak',
  defaultOption: 'none'
}, {
  key: 'floor-state'
}, {
  key: 'papering-state'
}, {
  key: 'environment-light',
  defaultOption: 'normal'
}, {
  key: 'environment-noise',
  defaultOption: 'normal'
}, {
  key: 'environment-vibration',
  defaultOption: 'normal'
}];
const GROUPED_DIRECT_CONFIRMATION_KEYS = new Set([...LEASE_CONFIRMATION_BUNDLE_ITEMS, ...BASIC_FACILITY_BUNDLE_ITEMS, ...WALL_ENVIRONMENT_BUNDLE_ITEMS].map(item => item.key));
const REMAINING_DIRECT_CONFIRMATION_BUNDLE_ID = 'remaining-direct-confirmation';
const SITE_GUIDE_DIRECT_CONFIRMATION_BUNDLE_ID = 'site-guide-direct-confirmation';
const SITE_GUIDE_DIRECT_CONFIRMATION_KEYS = new Set(['site-guide', 'site-guide-notice']);
function directConfirmationBundleIdsForCheckKey(key) {
  const ids = [];
  if (LEASE_CONFIRMATION_BUNDLE_ITEMS.some(item => item.key === key)) ids.push('lease-confirmation');
  if (BASIC_FACILITY_BUNDLE_ITEMS.some(item => item.key === key)) ids.push('facility-basic');
  if (WALL_ENVIRONMENT_BUNDLE_ITEMS.some(item => item.key === key)) ids.push('wall-environment');
  if (MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(key)) ids.push('management-fee');
  if (SITE_GUIDE_DIRECT_CONFIRMATION_KEYS.has(key)) ids.push(SITE_GUIDE_DIRECT_CONFIRMATION_BUNDLE_ID);
  if (DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(key) && !GROUPED_DIRECT_CONFIRMATION_KEYS.has(key) && !MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(key) && !SITE_GUIDE_DIRECT_CONFIRMATION_KEYS.has(key)) {
    ids.push(REMAINING_DIRECT_CONFIRMATION_BUNDLE_ID);
  }
  return ids;
}
function isRemovedSaleFooterText(value) {
  const text = value.trim();
  return text.includes('매매계약 확정 전') && text.includes('등기부등본') && text.includes('건축물대장') && text.includes('토지대장') && text.includes('계약 조건');
}
function explanationLegalFormForSelection(selection) {
  const propertyType = String(selection?.propertyType ?? '').trim().toUpperCase();
  if (propertyType === 'COMMERCIAL') return EXPLANATION_LEGAL_FORMS[1];
  if (propertyType === 'LAND') return EXPLANATION_LEGAL_FORMS[2];
  if (['FOREST', 'MINING_FOUNDATION', 'FACTORY_FOUNDATION', 'FOUNDATION'].includes(propertyType)) {
    return EXPLANATION_LEGAL_FORMS[3];
  }
  return EXPLANATION_LEGAL_FORMS[0];
}
function explanationDocumentPropertyType(form, contract) {
  const contractRecord = asRecord(contract);
  const formRecord = asRecord(form);
  const metadata = asRecord(contractRecord.metadata);
  const terms = asRecord(contractRecord.contractTerms);
  const termsInput = asRecord(terms.contractTermsInput ?? metadata.contractTermsInput);
  const templateKey = normalizeContractTemplateKey(contractRecord.contractTemplateKey ?? contractRecord.contractTemplateLabel ?? terms.contractTemplateKey ?? metadata.contractTemplateKey ?? termsInput.contractTemplateKey ?? formRecord.contractTemplateKey);
  if (templateKey === 'COMMERCIAL') return 'COMMERCIAL';
  const contractTypeText = String(contractRecord.contractType ?? contractRecord.contractTypeLabel ?? terms.contractType ?? metadata.contractType ?? formRecord.contractType ?? '').trim();
  if (contractTypeText.toUpperCase() === 'COMMERCIAL_LEASE' || /상가|비주거/u.test(contractTypeText)) return 'COMMERCIAL';
  const propertyTypeText = String(contractRecord.propertyType ?? contractRecord.propertyTypeLabel ?? terms.propertyType ?? metadata.propertyType ?? formRecord.propertyType ?? '').trim();
  if (/상가|비주거/u.test(propertyTypeText)) return 'COMMERCIAL';
  if (/주거|아파트|오피스텔|단독|다세대/u.test(propertyTypeText)) return 'RESIDENTIAL';
  return propertyTypeText;
}
function explanationDocumentContractType(form, contract) {
  const contractRecord = asRecord(contract);
  const formRecord = asRecord(form);
  const metadata = asRecord(contractRecord.metadata);
  const terms = asRecord(contractRecord.contractTerms);
  const contractType = String(contractRecord.contractType ?? terms.contractType ?? metadata.contractType ?? formRecord.contractType ?? '').trim();
  if (contractType) return contractType;
  const label = String(contractRecord.contractTypeLabel ?? terms.contractTypeLabel ?? metadata.contractTypeLabel ?? '').trim();
  return /상가/u.test(label) ? 'COMMERCIAL_LEASE' : label;
}
function explanationLegalFormKeyForSelection(formKey, selection) {
  const selectedForm = explanationLegalFormForSelection(selection);
  const key = String(formKey ?? '').trim();
  const configuredForm = EXPLANATION_LEGAL_FORMS.find(item => item.key === key);
  if (!configuredForm) return selectedForm.key;
  const propertyType = String(selection?.propertyType ?? '').trim().toUpperCase();
  if (!propertyType) return key;
  if (propertyType === 'COMMERCIAL') {
    return key === 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING' ? key : selectedForm.key;
  }
  if (propertyType === 'RESIDENTIAL') {
    return key === 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING' ? key : selectedForm.key;
  }
  return key === selectedForm.key ? key : selectedForm.key;
}
function isExplanationTemplateKey(templateKey) {
  return templateKey === 'EXPLANATION_FORM' || Boolean(templateKey && templateKey.startsWith('EXPLANATION_FORM_'));
}
function normalizeExplanationCheckStatus(value) {
  const status = String(value ?? '').trim().toUpperCase();
  if (status === 'NEEDS_CHECK' || status === 'NOT_APPLICABLE') return status;
  return 'OK';
}
function normalizeExplanationCheckOptions(value, fallback = []) {
  const rows = Array.isArray(value) ? value.map(asRecord) : fallback.map(asRecord);
  return rows.map(option => ({
    value: readText(option, 'value', ''),
    label: readText(option, 'label', '')
  })).filter(option => option.value && option.label);
}
const EXPLANATION_SOURCE_DOCUMENT_SELECTED_OPTION_VALUES = ['REGISTRY_CERTIFICATE', 'LAND_REGISTER', 'BUILDING_REGISTER', 'CADASTRAL_MAP', 'LAND_USE_PLAN'];
function normalizeExplanationSourceDocumentSelectedOption(value) {
  const selected = [];
  const add = documentType => {
    if (!selected.includes(documentType)) selected.push(documentType);
  };
  String(value ?? '').normalize('NFKC').split(/[|,\s]+/u).map(token => token.trim()).filter(Boolean).forEach(token => {
    const upper = token.toUpperCase();
    if (EXPLANATION_SOURCE_DOCUMENT_SELECTED_OPTION_VALUES.includes(upper)) {
      add(upper);
      return;
    }
    if (/등기|REGISTRY|IROS/iu.test(token)) add('REGISTRY_CERTIFICATE');
    if (/토지대장|LAND_REGISTER|LAND\s*REGISTER/iu.test(token)) add('LAND_REGISTER');
    if (/건축물대장|BUILDING_REGISTER|BUILDING\s*REGISTER/iu.test(token)) add('BUILDING_REGISTER');
    if (/지적도|CADASTRAL/iu.test(token)) add('CADASTRAL_MAP');
    if (/토지이용계획|LAND_USE_PLAN|VWorld/iu.test(token)) add('LAND_USE_PLAN');
  });
  return selected.join('|');
}
function normalizeExplanationChecks(value, fallback = DEFAULT_EXPLANATION_CHECK_ITEMS) {
  const rows = Array.isArray(value) ? value.map(asRecord) : [];
  const normalizedDefaults = fallback.map(defaultItem => {
    const record = rows.find(item => readText(item, 'key', '') === defaultItem.key) ?? asRecord(defaultItem);
    const options = defaultItem.options?.length ? normalizeExplanationCheckOptions(record.options, defaultItem.options) : [];
    const hasSelectedOption = Object.prototype.hasOwnProperty.call(record, 'selectedOption');
    const hasDefaultSelectedOption = Object.prototype.hasOwnProperty.call(defaultItem, 'selectedOption');
    const acceptsFreeSelectedOption = defaultItem.key === 'source-documents';
    const selectedOption = options.length || acceptsFreeSelectedOption ? String(hasSelectedOption ? record.selectedOption ?? '' : hasDefaultSelectedOption ? defaultItem.selectedOption ?? '' : '').trim() : '';
    const normalizedSelectedOption = acceptsFreeSelectedOption ? normalizeExplanationSourceDocumentSelectedOption(selectedOption) : options.some(option => option.value === selectedOption) ? selectedOption : hasSelectedOption && !selectedOption ? '' : '';
    const sourceValue = ['AUTO', 'MANUAL', 'AUTO_OR_MANUAL'].includes(String(record.source ?? defaultItem.source)) ? String(record.source ?? defaultItem.source) : defaultItem.source;
    const normalizedStatus = normalizeExplanationCheckStatus(record.status ?? defaultItem.status);
    const manualConfirmedAt = readText(record, 'manualConfirmedAt', '');
    const legacyImplicitOption = LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY[defaultItem.key] && normalizedSelectedOption === LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY[defaultItem.key] && !manualConfirmedAt && sourceValue !== 'AUTO';
    const legacyImplicitStatus = LEGACY_IMPLICIT_EXPLANATION_STATUS_KEYS.has(defaultItem.key) && normalizedStatus === 'OK' && !manualConfirmedAt && sourceValue !== 'AUTO';
    return {
      key: defaultItem.key,
      section: readText(record, 'section', defaultItem.section),
      label: readText(record, 'label', defaultItem.label),
      status: legacyImplicitOption || legacyImplicitStatus ? 'NEEDS_CHECK' : normalizedStatus,
      source: legacyImplicitOption || legacyImplicitStatus ? 'AUTO_OR_MANUAL' : sourceValue,
      automation: readText(record, 'automation', defaultItem.automation),
      formSection: readText(record, 'formSection', defaultItem.formSection ?? ''),
      selectedOption: options.length || acceptsFreeSelectedOption ? legacyImplicitOption ? '' : normalizedSelectedOption : undefined,
      options: options.length ? options : undefined,
      manualConfirmedAt: manualConfirmedAt || undefined
    };
  });
  const knownKeys = new Set(normalizedDefaults.map(item => item.key));
  const extraRows = rows.filter(record => {
    const key = readText(record, 'key', '');
    return key && !knownKeys.has(key);
  }).map(record => {
    const options = normalizeExplanationCheckOptions(record.options, []);
    const hasSelectedOption = Object.prototype.hasOwnProperty.call(record, 'selectedOption');
    const rawSelectedOption = String(hasSelectedOption ? record.selectedOption ?? '' : options[0]?.value ?? '').trim();
    const selectedOption = options.length && !options.some(option => option.value === rawSelectedOption) ? '' : rawSelectedOption;
    return {
      key: readText(record, 'key', ''),
      section: readText(record, 'section', '문서 체크박스'),
      label: readText(record, 'label', '문서 체크박스'),
      status: normalizeExplanationCheckStatus(record.status),
      source: ['AUTO', 'MANUAL', 'AUTO_OR_MANUAL'].includes(String(record.source ?? 'MANUAL')) ? String(record.source ?? 'MANUAL') : 'MANUAL',
      automation: readText(record, 'automation', '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화'),
      formSection: readText(record, 'formSection', ''),
      selectedOption: options.length ? selectedOption : undefined,
      options: options.length ? options : undefined,
      manualConfirmedAt: readText(record, 'manualConfirmedAt', '') || undefined
    };
  });
  return [...normalizedDefaults, ...extraRows];
}
function explanationContractTypeOptionForSelection(selection) {
  return normalizeExplanationContractTypeOption(selection?.contractType);
}
function explanationResidentialBuildingTypeOptionForSelection(selection) {
  const source = [selection?.propertyType, selection?.mainUse].map(value => String(value ?? '').normalize('NFKC')).join(' ');
  if (/오피스텔|OFFICETEL/iu.test(source)) return 'officetel';
  if (/단독|다가구|다중|HOUSE|DETACHED|SINGLEFAMILY/iu.test(source)) return 'detached';
  if (/공동|아파트|연립|다세대|APT|APARTMENT|MULTIFAMILY/iu.test(source)) return 'apartment';
  return '';
}
function explanationNonResidentialUseTypeOptionForSelection(selection) {
  const source = [selection?.propertyType, selection?.mainUse].map(value => String(value ?? '').normalize('NFKC')).join(' ');
  if (/업무|오피스|OFFICE|BUSINESS/iu.test(source)) return 'business';
  if (/상가|상업|근린생활|판매|COMMERCIAL|RETAIL|STORE/iu.test(source)) return 'commercial';
  if (/공업|공장|FACTORY|INDUSTR/iu.test(source)) return 'industrial';
  return '';
}
const SYNTHETIC_EXPLANATION_CHECK_ITEMS_BY_KEY = {
  'facility-fire-hydrant': {
    section: '내부·외부 시설물의 상태',
    label: '소화전',
    status: 'OK',
    source: 'MANUAL',
    automation: '확인설명서 문서 안쪽 소화전 체크박스와 바깥 선택값을 동일 상태로 동기화',
    formSection: '⑨ 내부·외부 시설물의 상태 > 소방 > 소화전',
    selectedOption: 'none',
    options: [{
      value: 'none',
      label: '없음'
    }, {
      value: 'exists',
      label: '있음'
    }]
  },
  'facility-emergency-bell': {
    section: '내부·외부 시설물의 상태',
    label: '비상벨',
    status: 'OK',
    source: 'MANUAL',
    automation: '확인설명서 문서 안쪽 비상벨 체크박스와 바깥 선택값을 동일 상태로 동기화',
    formSection: '⑨ 내부·외부 시설물의 상태 > 소방 > 비상벨',
    selectedOption: 'none',
    options: [{
      value: 'none',
      label: '없음'
    }, {
      value: 'exists',
      label: '있음'
    }]
  }
};
function explanationSyntheticCheckItem(field, context) {
  if (field.checkKey === 'explanation-contract-type') {
    const formKey = field.formKey ?? DEFAULT_EXPLANATION_FORM_OVERLAY_KEY;
    const options = formKey === 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING' ? [{
      value: 'sale',
      label: '매매ㆍ교환'
    }, {
      value: 'lease',
      label: '임대'
    }, {
      value: 'other',
      label: '그 밖의 경우'
    }] : [{
      value: 'sale',
      label: '매매ㆍ교환'
    }, {
      value: 'lease',
      label: '임대'
    }];
    const selectedOption = options.some(option => option.value === context?.contractTypeOption) ? context?.contractTypeOption ?? '' : '';
    return {
      key: field.checkKey,
      section: '계약 조건',
      label: '거래 형태',
      status: selectedOption ? 'OK' : 'NEEDS_CHECK',
      source: 'AUTO_OR_MANUAL',
      automation: '공인중개사법 시행규칙 확인설명서 거래 형태 기준으로 계약방 계약유형을 매매ㆍ교환/임대/그 밖의 경우에 동기화',
      formSection: '① 대상물건의 표시 > 거래 형태',
      selectedOption,
      options
    };
  }
  if (field.checkKey === 'explanation-residential-building-type') {
    const selectedOption = context?.residentialBuildingTypeOption || '';
    return {
      key: field.checkKey,
      section: '대상물건의 표시',
      label: '주택 유형',
      status: selectedOption ? 'OK' : 'NEEDS_CHECK',
      source: 'AUTO_OR_MANUAL',
      automation: '확인설명서 주택 유형 체크박스와 외부 선택값을 동일 상태로 동기화',
      formSection: '① 대상물건의 표시 > 주택 유형',
      selectedOption,
      options: [{
        value: 'detached',
        label: '단독주택'
      }, {
        value: 'apartment',
        label: '공동주택'
      }, {
        value: 'officetel',
        label: '주거용 오피스텔'
      }]
    };
  }
  if (field.checkKey === 'explanation-nonresidential-use-type') {
    const selectedOption = context?.nonResidentialUseTypeOption || '';
    return {
      key: field.checkKey,
      section: '대상물건의 표시',
      label: '상가 용도 유형',
      status: selectedOption ? 'OK' : 'NEEDS_CHECK',
      source: 'AUTO_OR_MANUAL',
      automation: '확인설명서 상가 용도 유형 체크박스와 외부 선택값을 동일 상태로 동기화',
      formSection: '① 대상물건의 표시 > 용도 유형',
      selectedOption,
      options: [{
        value: 'business',
        label: '업무용'
      }, {
        value: 'commercial',
        label: '상업용'
      }, {
        value: 'industrial',
        label: '공업용'
      }]
    };
  }
  const syntheticItem = SYNTHETIC_EXPLANATION_CHECK_ITEMS_BY_KEY[field.checkKey];
  if (syntheticItem) {
    return {
      key: field.checkKey,
      ...syntheticItem
    };
  }
  const detectedCheck = parseDetectedExplanationCheckKey(field.checkKey);
  if (detectedCheck) {
    const formLabel = explanationLegalFormLabelByKey(field.formKey ?? DEFAULT_EXPLANATION_FORM_OVERLAY_KEY);
    return {
      key: field.checkKey,
      section: '원본 PDF 체크박스',
      label: `${formLabel} ${detectedCheck.page}쪽 미연결 체크박스 ${detectedCheck.index}`,
      status: field.status ?? 'NOT_APPLICABLE',
      source: 'MANUAL',
      automation: '현재 자동입력 항목과 연결되지 않은 원본 PDF 체크박스입니다. 법정 양식 위치 보존용이며 필요할 때만 수동으로 체크합니다.',
      formSection: `${formLabel} ${detectedCheck.page}쪽 · 연결 항목 없음`
    };
  }
  return {
    key: field.checkKey,
    section: '문서 체크박스',
    label: field.label,
    status: field.status ?? 'NOT_APPLICABLE',
    source: 'MANUAL',
    automation: '확인설명서 문서 안쪽 체크박스와 바깥 선택값을 동일 상태로 동기화',
    formSection: `${field.page}쪽 ${field.label}`
  };
}
function mergeExplanationOverlayChecks(checks, overlays, context) {
  const defaultKeys = new Set(DEFAULT_EXPLANATION_CHECK_ITEMS.map(item => item.key));
  const overlayKeys = new Set(overlays.map(item => item.checkKey));
  const merged = checks.filter(item => defaultKeys.has(item.key) || overlayKeys.has(item.key));
  const existingKeys = new Set(merged.map(item => item.key));
  overlays.forEach(field => {
    if (existingKeys.has(field.checkKey)) return;
    const item = explanationSyntheticCheckItem(field, context);
    merged.push(item);
    existingKeys.add(item.key);
  });
  return merged;
}
function normalizeLanguageBackups(value) {
  const record = asRecord(value);
  return {
    ko: asRecord(record.ko),
    en: asRecord(record.en),
    other: asRecord(record.other)
  };
}
const DEFAULT_TEMPLATE_CUSTOM_TEXTS = {
  title: '',
  introPrefix: '',
  sectionProperty: '1. 부동산의 표시',
  sectionTerms: '2. 계약내용',
  purposeClauseText: '',
  purposeClausePrefix: '제 1 조 (목적) 위 부동산의 계약에 대하여',
  purposeClauseSuffix: '은 합의에 의하여 아래와 같이 지급하기로 한다.',
  receiptText: '계약시에 지불하고 영수함.',
  interimDueText: '년 월 일에 지불한다.',
  labelAddress: '소재지',
  labelLand: '토지',
  labelLandCategory: '지목',
  labelLandRight: '대지권',
  labelArea: '면적',
  labelBuilding: '건물',
  labelStructureUsage: '구조용도',
  labelFixedAmount: '월세',
  labelContractDeposit: '계약금',
  labelInterimPayment: '중도금',
  labelBalance: '잔금',
  labelMoney: '금',
  labelAddressGeneric: '주소',
  labelResidentNumber: '주민등록번호',
  labelPhone: '전화',
  labelName: '성명',
  labelAgent: '대리인',
  labelBroker: '중\n개\n업\n자',
  labelCoBroker: '공\n동\n중\n개\n인',
  labelBrokerOfficeAddress: '소재지',
  labelBrokerOfficeName: '소속',
  labelBrokerRepresentative: '대표',
  labelBrokerRegistrationNo: '등록번호',
  labelSeal: '(인)',
  labelSignatureSeal: '서명날인',
  labelLicensedBroker: '소속\n중개사',
  closingText: SIMPLIFIED_CONTRACT_CLOSING_TEXT,
  closingDateText: '년     월     일',
  promoText: '이사, 청소, 인터넷 이전은 한방에 이음하세요',
  qrText: 'QR코드 스캔으로\n간편신청하기 →'
};
const TEMPLATE_TEXT_FIELD_OPTIONS = [{
  key: 'title',
  label: '문서 제목'
}, {
  key: 'introPrefix',
  label: '상단 계약 문구'
}, {
  key: 'sectionProperty',
  label: '부동산 표시 제목'
}, {
  key: 'sectionTerms',
  label: '계약내용 제목'
}, {
  key: 'purposeClauseText',
  label: '제1조 목적 문구'
}, {
  key: 'receiptText',
  label: '계약금 지급 문구'
}, {
  key: 'interimDueText',
  label: '중도금 지급 문구'
}, {
  key: 'bodyText',
  label: '계약내용 본문'
}, {
  key: 'noticeText',
  label: '특약사항 본문'
}, {
  key: 'closingText',
  label: '서명 확인 문구'
}, {
  key: 'closingDateText',
  label: '서명 일자 문구'
}, {
  key: 'footerText',
  label: '하단 보조 문구'
}, {
  key: 'promoText',
  label: '이음 안내 문구'
}, {
  key: 'qrText',
  label: 'QR 안내 문구'
}];
const DEFAULT_TEMPLATE_FIELD_STYLES = {
  title: {
    widthPct: 100,
    fontSizePx: 23,
    color: '#000000',
    bold: true
  },
  introPrefix: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  sectionProperty: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  sectionTerms: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  purposeClauseText: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  receiptText: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000'
  },
  interimDueText: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000'
  },
  bodyText: {
    widthPct: 100,
    fontSizePx: 9,
    color: '#000000'
  },
  noticeText: {
    widthPct: 100,
    fontSizePx: 9,
    color: '#000000'
  },
  closingText: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000'
  },
  closingDateText: {
    widthPct: 100,
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  footerText: {
    widthPct: 100,
    fontSizePx: 8,
    color: '#94a3b8'
  },
  promoText: {
    widthPct: 100,
    fontSizePx: 16,
    color: '#000000',
    bold: true
  },
  qrText: {
    widthPct: 100,
    fontSizePx: 11,
    color: '#000000',
    bold: true
  },
  partyOwnerRoleLabel: {
    fontSizePx: 11,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  partyBuyerRoleLabel: {
    fontSizePx: 11,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  labelBroker: {
    fontSizePx: 11,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  labelCoBroker: {
    fontSizePx: 11,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  partyOwnerLabelResidentNumber: {
    fontSizePx: 8,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  partyOwnerAgentLabelResidentNumber: {
    fontSizePx: 8,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  partyBuyerLabelResidentNumber: {
    fontSizePx: 8,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  partyBuyerAgentLabelResidentNumber: {
    fontSizePx: 8,
    color: '#000000',
    backgroundColor: '#dff7f7',
    bold: true
  },
  brokerPrimaryLabelLicensedBroker: {
    fontSizePx: 8,
    color: '#000000',
    bold: true
  },
  brokerCoLabelLicensedBroker: {
    fontSizePx: 8,
    color: '#000000',
    bold: true
  },
  partyOwnerLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyOwnerLabelName: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyOwnerAgentLabelAddress: {
    fontSizePx: 6,
    color: '#000000',
    bold: true
  },
  partyOwnerAgentLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyOwnerAgentLabelName: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyBuyerLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyBuyerLabelName: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyBuyerAgentLabelAddress: {
    fontSizePx: 6,
    color: '#000000',
    bold: true
  },
  partyBuyerAgentLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  partyBuyerAgentLabelName: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  brokerPrimaryLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  },
  brokerCoLabelPhone: {
    fontSizePx: 10,
    color: '#000000',
    bold: true
  }
};
const TEMPLATE_TABLE_OPTIONS = [{
  key: 'property',
  label: '부동산 표시 표'
}, {
  key: 'payment',
  label: '계약내용/금액 표'
}, {
  key: 'party',
  label: '당사자/중개업자 표'
}];
const STANDARD_SIGNATURE_PARTY_COLUMN_WIDTHS = [3.4, 7.265, 2.778, 14.374, 6.957, 8.038, 5.411, 3.4, 4.789, 0.924, 4.946, 13.293, 7.108, 11.904, 5.411];
const DEFAULT_TEMPLATE_TABLE_LAYOUTS = {
  property: {
    columnWidths: [8, 9, 13, 13, 10, 15, 8, 24],
    boundaryPositions: {}
  },
  payment: {
    columnWidths: [10, 5, 13, 13, 13, 16, 15, 15],
    boundaryPositions: {}
  },
  party: {
    columnWidths: [...STANDARD_SIGNATURE_PARTY_COLUMN_WIDTHS],
    boundaryPositions: {}
  }
};
const TEMPLATE_BOUNDARY_API_LABELS = {
  property: ['property.sectionLabelToAddress', 'property.addressToLandCategory', 'property.landCategoryToLandArea', 'property.landAreaToBuildingStructure', 'property.buildingStructureToBuildingUse', 'property.buildingUseToExclusiveArea', 'property.exclusiveAreaToLandRight'],
  payment: ['payment.amountLabelToCurrency', 'payment.currencyToPrimaryAmount', 'payment.primaryAmountToSchedule', 'payment.scheduleToDueDate', 'payment.dueDateToBalance', 'payment.balanceToMemo', 'payment.memoToEnd'],
  party: ['party.roleToAddress', 'party.addressLabelToAddress', 'party.ownerResidentValueToPhone', 'party.ownerPhoneToName', 'party.ownerNameToSeal', 'party.primaryBrokerToJointBroker', 'party.jointBrokerLabelToValue', 'party.jointBrokerValueToRegistration', 'party.jointBrokerRegistrationToSeal', 'party.jointBrokerSealToCoLabel', 'party.coBrokerLabelToValue', 'party.coBrokerValueToLicensedBroker', 'party.coBrokerLicensedBrokerToSeal', 'party.signatureEnd']
};
const PUBLIC_DEFAULT_REALTOR_ID = (process.env.NEXT_PUBLIC_REALTORAUTO_DEFAULT_REALTOR_ID || '').trim();
const PUBLIC_REALTORAUTO_BASE_PATH = (process.env.NEXT_PUBLIC_REALTORAUTO_BASE_PATH || '/realtorauto').replace(/\/+$/, '') || '/realtorauto';
function publicRealtorAutoRoute(path = '') {
  return `${PUBLIC_REALTORAUTO_BASE_PATH}${path}`;
}
const EXPLANATION_LEGAL_FORM_RENDERED_PAGE_CONFIG = {
  EXPLANATION_FORM_I_RESIDENTIAL_BUILDING: {
    slug: 'explanation-form-i-residential-building-ko',
    pages: 6
  },
  EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING: {
    slug: 'explanation-form-ii-nonresidential-building-ko',
    pages: 4
  }
};
const EXPLANATION_LEGAL_FORM_RENDERED_ASSET_VERSION = '20260812a';
function legalFormRenderedPageImages(legalFormKey) {
  const config = EXPLANATION_LEGAL_FORM_RENDERED_PAGE_CONFIG[legalFormKey];
  if (!config) return [];
  return Array.from({
    length: config.pages
  }, (_, index) => `${publicRealtorAutoRoute(`/legal-forms/rendered/${config.slug}-page-${index + 1}.png`)}?v=${EXPLANATION_LEGAL_FORM_RENDERED_ASSET_VERSION}`);
}
const EXPLANATION_FORM_TEXT_OVERLAYS = SHARED_EXPLANATION_FORM_TEXT_OVERLAYS;
const EXPLANATION_FORM_CHECK_PAGE_WIDTH = EXPLANATION_FORM_PAGE_WIDTH_PT;
const EXPLANATION_FORM_CHECK_PAGE_HEIGHT = EXPLANATION_FORM_PAGE_HEIGHT_PT;
const EXPLANATION_FORM_PREVIEW_PX_PER_PT = EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX / EXPLANATION_FORM_CHECK_PAGE_WIDTH;
const EXPLANATION_FORM_PREVIEW_BASE_HEIGHT_PX = EXPLANATION_FORM_CHECK_PAGE_HEIGHT * EXPLANATION_FORM_PREVIEW_PX_PER_PT;
const DEFAULT_EXPLANATION_FORM_OVERLAY_KEY = 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING';
const EXPLANATION_CHECK_STATUS_LABELS = {
  OK: '이상없음',
  NEEDS_CHECK: '확인필요',
  NOT_APPLICABLE: '해당없음'
};
const RAW_EXPLANATION_CHECK_STATUS_LABELS = {
  OK: '체크',
  NEEDS_CHECK: '확인필요',
  NOT_APPLICABLE: '해제'
};
function parseDetectedExplanationCheckKey(key) {
  const match = key.match(/^(residential|nonresidential)-detected-p(\d+)-(\d+)$/u);
  if (!match) return null;
  return {
    formPrefix: match[1],
    page: Number(match[2]),
    index: Number(match[3])
  };
}
function isDetectedExplanationCheckKey(key) {
  return Boolean(parseDetectedExplanationCheckKey(key));
}
function explanationLegalFormLabelByKey(formKey) {
  return EXPLANATION_LEGAL_FORMS.find(item => item.key === formKey)?.label ?? '확인설명서';
}
function explanationCheckConnectionLabel(item) {
  if (!item) return '연결 항목 없음';
  if (isDetectedExplanationCheckKey(item.key)) return '연결 항목 없음 - 원본 PDF 체크박스만 수동 표시';
  return [item.formSection, item.label].filter(Boolean).join(' / ') || item.label;
}
function explanationCheckOverlayTitle(field, item) {
  const formLabel = explanationLegalFormLabelByKey(field.formKey ?? DEFAULT_EXPLANATION_FORM_OVERLAY_KEY);
  const valueLabel = field.optionValue ? `선택값: ${field.label}` : `체크값: ${field.status ? EXPLANATION_CHECK_STATUS_LABELS[field.status] : field.label}`;
  return `${valueLabel}\n연결 항목: ${explanationCheckConnectionLabel(item)}\n양식 위치: ${formLabel} ${field.page}쪽`;
}
function clampNumber(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
function explanationOverlayHeightPx(heightPercent, zoom) {
  return heightPercent / 100 * EXPLANATION_FORM_PREVIEW_BASE_HEIGHT_PX * zoom;
}
function shouldSplitExplanationAddressOverlay(field, text, zoom) {
  void zoom;
  return shouldSplitExplanationAddressOverlayText(field, text);
}
function formatPreviewExplanationOverlayValue(field, value, zoom) {
  const normalized = formatExplanationAddressOverlayValue(field, value);
  if (shouldSplitExplanationAddressOverlay(field, normalized, zoom)) {
    return formatExplanationAddressFallbackTwoLines(normalized);
  }
  return normalized;
}
function explanationCheckMarkSizePx(zoom) {
  return clampNumber(18 * zoom, 15, 28);
}
function explanationTextOverlayBelongsToForm(field, formKey) {
  if (field.formKey) return field.formKey === formKey;
  if (field.page === 4 && (formKey === 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING' || formKey === 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING')) {
    return true;
  }
  return DEFAULT_EXPLANATION_FORM_OVERLAY_KEY === formKey;
}
const EXPLANATION_FORM_CHECK_OVERLAYS = SHARED_EXPLANATION_FORM_CHECK_OVERLAYS;
function effectiveRealtorId(value) {
  return String(value || PUBLIC_DEFAULT_REALTOR_ID).trim();
}
function buildMemberQrImageUrl(realtorIdInput) {
  const realtorId = String(realtorIdInput || '').trim();
  return realtorId ? publicRealtorAutoRoute(`/api/realtorauto/member-qrcodes/${encodeURIComponent(realtorId)}/?public=1`) : '';
}
function normalizeDocumentDownloadPath(rawPath) {
  const path = String(rawPath || '').trim();
  if (!path) return '';
  const normalizedFilePath = ensureFileDownloadTrailingSlash(path);
  if (/^(https?:)?\/\//i.test(path)) return normalizedFilePath;
  if (path.startsWith(`${PUBLIC_REALTORAUTO_BASE_PATH}/api/`)) return normalizedFilePath;
  if (path.startsWith('/api/')) return ensureFileDownloadTrailingSlash(`${PUBLIC_REALTORAUTO_BASE_PATH}${path}`);
  if (path.startsWith('api/')) return ensureFileDownloadTrailingSlash(`${PUBLIC_REALTORAUTO_BASE_PATH}/${path}`);
  return path;
}
function ensureFileDownloadTrailingSlash(path) {
  const suffixIndex = path.search(/[?#]/u);
  const basePath = suffixIndex >= 0 ? path.slice(0, suffixIndex) : path;
  const suffix = suffixIndex >= 0 ? path.slice(suffixIndex) : '';
  if (/\/api\/files\/[^/?#]+\/download$/u.test(basePath)) return `${basePath}/${suffix}`;
  return path;
}
function normalizeAddressUnitText(value) {
  return String(value ?? '').normalize('NFKC').replace(/(^|\s)제\s*(\d)\s+(\d{2})\s*(동)(?=\s|$)/gu, '$1$2$3$4').replace(/(^|\s)제\s*\d+\s+(\d{3,4})\s*(호|호실)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(\d)\s+(\d{2})\s*(동)(?=\s|$)/gu, '$1$2$3$4').replace(/(^|\s)제\s*(\d+)\s*(동|호|호실|층)(?=\s|$)/gu, '$1$2$3').replace(/\s+/gu, ' ').trim();
}
function normalizeDisplayOnlyAddressText(value) {
  return normalizeAddressUnitText(value).replace(/(^|\s)제\s*((?:\d\s*)+(?:[0-9A-Za-z()[\]-]\s*)*(?:동|층|호실|호))(?=\s|$|\]|[),.])/gu, (_match, prefix, unit) => {
    return `${prefix}${unit.replace(/\s+/gu, '')}`;
  }).replace(/(^|\s)제\s*([0-9A-Za-z가-힣()[\]-]+(?:동|층|호실|호))(?=\s|$|\]|[),.])/gu, '$1$2').replace(/([0-9A-Za-z가-힣])제\s*((?:\d\s*)+(?:[0-9A-Za-z()[\]-]\s*)*(?:동|층|호실|호))(?=\s|$|\]|[),.])/gu, (_match, prefix, unit) => {
    return `${prefix}${unit.replace(/\s+/gu, '')}`;
  }).replace(/\s+/gu, ' ').trim();
}
function repairSplitKoreanRegionName(value) {
  return value.replace(/(^|\s)(서울)\s+(특별시)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(부산|대구|인천|광주|대전|울산)\s+(광역시)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(세종)\s+(특별자치시)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(강원|전북|제주)\s+(특별자치도)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(경기|강원|제주)\s+(도)(?=\s|$)/gu, '$1$2$3').replace(/(^|\s)(충청|전라|경상)\s*(북|남)\s+(도)(?=\s|$)/gu, '$1$2$3$4').replace(/(^|\s)(충북|충남|전북|전남|경북|경남)\s+(도)(?=\s|$)/gu, '$1$2$3');
}
function compactSplitRoadBranchNumber(value) {
  return value.replace(/((?:대로|로))\s*((?:\d\s*){1,5})(?:번\s*길|번길)(?=\s+\d)/gu, (_match, suffix, digits) => {
    return `${suffix}${digits.replace(/\s+/gu, '')}번길`;
  }).replace(/((?:대로|로))\s*((?:\d\s*){1,5})길(?=\s+\d)/gu, (_match, suffix, digits) => {
    return `${suffix}${digits.replace(/\s+/gu, '')}길`;
  });
}
function repairSplitJibunLotNumber(value) {
  return value.replace(/((?:^|\s)[가-힣A-Za-z0-9·._-]+(?:동|읍|면|리|가))\s+(\d{1,4})\s+(0\d{1,4})(?=\s|$)/gu, (_match, prefix, head, tail) => `${prefix} ${head}${tail}`);
}
function repairSplitKoreanRoadName(value) {
  let next = repairSplitKoreanRegionName(String(value ?? '').normalize('NFKC').replace(/\s+/gu, ' ').trim());
  if (!next) return '';
  for (let index = 0; index < 12; index += 1) {
    const before = next;
    next = compactSplitRoadBranchNumber(next).replace(/([가-힣]+)\s+(대로|로|길)(?=\s*(?:\d|$))/gu, '$1$2').replace(/(^|\s)([가-힣]+)\s+([가-힣]+(?:대로|로|길))(?=\s*(?:\d|$))/gu, (_match, prefix, head, tail) => {
      if (/(?:특별시|광역시|특별자치시|특별자치도|자치도|도|시|군|구|읍|면|동|리)$/u.test(head)) {
        return `${prefix}${head} ${tail}`;
      }
      return `${prefix}${head}${tail}`;
    }).replace(/((?:대로|로))\s+(\d{1,5})(번길|길)(?=\s+\d)/gu, '$1$2$3').replace(/\s+/gu, ' ').trim();
    if (next === before) break;
  }
  return next.replace(/\s+/gu, ' ').trim();
}
function repairSplitRoadBranchNumber(value) {
  return repairSplitJibunLotNumber(repairSplitKoreanRoadName(value)).replace(/((?:대로|로))\s+(\d{1,3})\s+(\d{1,3}번길)(?=\s+\d)/gu, '$1$2$3').replace(/((?:대로|로))\s+(\d{1,3})\s+(\d{1,3}길)(?=\s+\d)/gu, '$1$2$3').replace(/\s+/gu, ' ').trim();
}
function compactAddressDisplayText(value) {
  return repairSplitRoadBranchNumber(normalizeDisplayOnlyAddressText(value)).replace(/\s+/g, '');
}
function contractAddressCompareKey(value) {
  return compactAddressDisplayText(value).replace(/\d+층/gu, '').toLowerCase();
}
function addressTailHasUnitSignal(value) {
  return /(?:\d+\s*(?:동|호|호실|층)|[A-Za-z가-힣]+\s*\d+\s*(?:동|호|호실|층)|[A-Za-z가-힣0-9]+(?:동|호|호실|층))/u.test(value);
}
function addressTailLooksLikeRepeatedBuilding(value) {
  const clean = normalizeAddressUnitText(value).replace(/\s+\d+층$/u, '').trim();
  if (clean.length < 3 || clean.split(/\s+/u).length > 3) return false;
  if (!/[A-Za-z가-힣]/u.test(clean)) return false;
  return !/(?:시|군|구|읍|면|리|동)\s*\d/u.test(clean);
}
function collapseRepeatedAddressTail(value) {
  const normalized = normalizeAddressUnitText(value);
  if (!normalized) return '';
  const tokens = normalized.split(/\s+/u).filter(Boolean);
  if (tokens.length < 4) return normalized;
  for (let index = 1; index < tokens.length; index += 1) {
    const prefix = tokens.slice(0, index).join(' ');
    const tail = tokens.slice(index).join(' ');
    const tailKey = contractAddressCompareKey(tail);
    if (tailKey.length < 4) continue;
    if (!addressTailHasUnitSignal(tail) && !addressTailLooksLikeRepeatedBuilding(tail)) continue;
    if (contractAddressCompareKey(prefix).includes(tailKey)) {
      return collapseRepeatedAddressTail(prefix);
    }
  }
  return normalized;
}
const KOREAN_REGION_NAME_PATTERN = '(?:\\uC11C\\uC6B8\\uD2B9\\uBCC4\\uC2DC|\\uBD80\\uC0B0\\uAD11\\uC5ED\\uC2DC|\\uB300\\uAD6C\\uAD11\\uC5ED\\uC2DC|\\uC778\\uCC9C\\uAD11\\uC5ED\\uC2DC|\\uAD11\\uC8FC\\uAD11\\uC5ED\\uC2DC|\\uB300\\uC804\\uAD11\\uC5ED\\uC2DC|\\uC6B8\\uC0B0\\uAD11\\uC5ED\\uC2DC|\\uC138\\uC885\\uD2B9\\uBCC4\\uC790\\uCE58\\uC2DC|\\uACBD\\uAE30\\uB3C4|\\uAC15\\uC6D0\\uD2B9\\uBCC4\\uC790\\uCE58\\uB3C4|\\uAC15\\uC6D0\\uB3C4|\\uCDA9\\uCCAD\\uBD81\\uB3C4|\\uCDA9\\uCCAD\\uB0A8\\uB3C4|\\uC804\\uB77C\\uB0A8\\uB3C4|\\uC804\\uBD81\\uD2B9\\uBCC4\\uC790\\uCE58\\uB3C4|\\uC804\\uB77C\\uBD81\\uB3C4|\\uACBD\\uC0C1\\uBD81\\uB3C4|\\uACBD\\uC0C1\\uB0A8\\uB3C4|\\uC81C\\uC8FC\\uD2B9\\uBCC4\\uC790\\uCE58\\uB3C4)';
function trimMixedAddressLine(address) {
  let next = String(address || '').trim();
  if (!next) return '';
  const bracketIndex = next.indexOf('[');
  if (bracketIndex > 0) next = next.slice(0, bracketIndex).trim();
  const regionPattern = new RegExp(KOREAN_REGION_NAME_PATTERN, 'gu');
  const starts = [...next.matchAll(regionPattern)].map(match => match.index ?? -1).filter(index => index >= 0);
  if (starts.length >= 2 && starts[0] === 0 && starts[1] > 0) {
    next = next.slice(0, starts[1]).trim();
  }
  return next;
}
function cleanAddressDetailPart(part) {
  const value = normalizeAddressUnitText(part);
  if (!value || value.startsWith('[')) return '';
  if (new RegExp(KOREAN_REGION_NAME_PATTERN, 'u').test(value)) return '';
  return trimMixedAddressLine(value);
}
function stripAddressUnitPrefix(part, suffix) {
  const value = normalizeAddressUnitText(cleanAddressDetailPart(part)).replace(/^\s*제\s*/u, '').replace(/\s+/g, '');
  if (!value) return '';
  return value.endsWith(suffix) ? value : `${value}${suffix}`;
}
const ADDRESS_UNIT_DONG = '\uB3D9';
const ADDRESS_UNIT_HO = '\uD638';
const ADDRESS_UNIT_JE = '\uC81C';
function removeAddressDongPrefixFromHo(hoPart, dongPart) {
  const ho = normalizeContractBoardExplicitUnitPart(hoPart, ADDRESS_UNIT_HO) || stripAddressUnitPrefix(hoPart, ADDRESS_UNIT_HO);
  const dong = normalizeContractBoardExplicitUnitPart(dongPart, ADDRESS_UNIT_DONG) || stripAddressUnitPrefix(dongPart, ADDRESS_UNIT_DONG);
  if (!ho || !dong) return ho;
  const compactHo = compactAddressDisplayText(ho).replace(new RegExp(`^${ADDRESS_UNIT_JE}`, 'u'), '');
  const compactDong = compactAddressDisplayText(dong).replace(new RegExp(`^${ADDRESS_UNIT_JE}`, 'u'), '');
  const dongNumber = compactDong.replace(new RegExp(`${ADDRESS_UNIT_DONG}$`, 'u'), '');
  const patterns = [new RegExp(`^${escapeRegExp(compactDong)}(.+)$`, 'u'), dongNumber ? new RegExp(`^${escapeRegExp(dongNumber)}${ADDRESS_UNIT_DONG}(.+)$`, 'u') : null].filter(pattern => Boolean(pattern));
  for (const pattern of patterns) {
    const match = compactHo.match(pattern);
    const remainder = String(match?.[1] || '').trim();
    if (remainder && /\d/u.test(remainder)) {
      return stripAddressUnitPrefix(remainder, ADDRESS_UNIT_HO);
    }
  }
  return ho;
}
function appendAddressDetailParts(address, parts) {
  let next = trimMixedAddressLine(String(address || '').trim());
  if (!next) return '';
  for (const part of parts) {
    const value = cleanAddressDetailPart(part);
    if (!value) continue;
    if (compactAddressDisplayText(next).includes(compactAddressDisplayText(value))) continue;
    next = `${next} ${value}`.trim();
  }
  return next;
}
function canonicalAddressLookupBaseLine(item) {
  return normalizeContractAddressDisplayText(item.roadBaseAddress || item.roadAddress || item.jibunBaseAddress || item.jibunAddress || '');
}
function canonicalAddressLookupUnitLine(item) {
  return normalizeContractAddressDisplayText([normalizeContractBoardBuildingNameCandidate(item.buildingName), normalizeContractBoardExplicitUnitPart(item.buildingDong, ADDRESS_UNIT_DONG), removeAddressDongPrefixFromHo(item.ho, item.buildingDong)].filter(Boolean).join(' '));
}
function canonicalAddressLookupSelectedAddress(item, fallbackAddress = '') {
  const baseLine = canonicalAddressLookupBaseLine(item);
  const unitLine = canonicalAddressLookupUnitLine(item);
  const canonical = appendAddressDetailParts(baseLine, [unitLine, item.detailAddress]);
  return normalizeContractAddressDisplayText(canonical || fallbackAddress || item.selectedAddress || item.displayAddress || item.roadAddress || item.jibunAddress);
}
const CONTRACT_TYPE_LABELS = {
  JEONSE: '전세',
  SALE: '매매',
  MONTHLY_RENT: '월세',
  COMMERCIAL_LEASE: '상가 월세'
};
const PROPERTY_TYPE_LABELS = {
  RESIDENTIAL: '주거',
  COMMERCIAL: '상가'
};
const CONTRACT_METHOD_LABELS = {
  ONLINE: '온라인 계약',
  OFFLINE: '대면 계약'
};
const CONTRACT_TEMPLATE_OPTIONS = [{
  key: 'SALE',
  label: '매매계약서',
  filePrefix: '매매계약서',
  description: '매도인과 매수인 사이의 소유권 이전 계약 양식',
  typeKey: 'RESIDENTIAL',
  typeLabel: '주거',
  documentTitle: '부동산 매매계약서',
  layoutSummary: '매매대금, 계약금, 잔금일, 소유권 이전, 등기 이전 조건을 크게 배치합니다.',
  requiredSections: ['부동산의 표시', '매매대금 및 지급일', '소유권 이전', '특약사항', '당사자 서명']
}, {
  key: 'JEONSE',
  label: '전세계약서',
  filePrefix: '전세계약서',
  description: '전세 보증금과 입주/명도 조건 중심의 임대차 양식',
  typeKey: 'RESIDENTIAL',
  typeLabel: '주거',
  documentTitle: '부동산 전세계약서',
  layoutSummary: '보증금, 계약금, 입주일, 전입/확정일자 안내를 문서 전면에 배치합니다.',
  requiredSections: ['부동산의 표시', '보증금 및 지급일', '임대차 기간', '권리관계 확인', '당사자 서명']
}, {
  key: 'MONTHLY_RENT',
  label: '월세계약서',
  filePrefix: '월세계약서',
  description: '보증금과 월차임이 함께 들어가는 주거 임대차 양식',
  typeKey: 'RESIDENTIAL',
  typeLabel: '주거',
  documentTitle: '부동산 월세계약서',
  layoutSummary: '보증금, 월차임, 납부일, 관리비, 입주일을 큼직한 입력 영역으로 둡니다.',
  requiredSections: ['부동산의 표시', '보증금/월차임', '납부일 및 연체 기준', '임대차 기간', '당사자 서명']
}, {
  key: 'COMMERCIAL',
  label: '상가계약서',
  filePrefix: '상가계약서',
  description: '상가 월세 또는 매매 계약에 맞춘 영업용 부동산 양식',
  typeKey: 'COMMERCIAL',
  typeLabel: '상가',
  documentTitle: '상가 부동산계약서',
  layoutSummary: '권리금, 업종, 인도일, 시설물 승계, 상가 특약을 한 화면 전체 폭으로 다룹니다.',
  requiredSections: ['상가의 표시', '보증금/매매대금', '권리금', '시설물 및 영업권', '당사자 서명']
}, {
  key: 'LEASE',
  label: '임대차계약서',
  filePrefix: '임대차계약서',
  description: '전세/월세 공통 조건을 다루는 표준 임대차 양식',
  typeKey: 'GENERAL',
  typeLabel: '공통',
  documentTitle: '부동산 임대차계약서',
  layoutSummary: '임대차 기간, 차임 또는 보증금, 목적물 표시, 특약을 공통 틀로 배치합니다.',
  requiredSections: ['부동산의 표시', '임대차 조건', '지급 조건', '특약사항', '당사자 서명']
}, {
  key: 'OTHER',
  label: '기타 계약서',
  filePrefix: '기타_계약서',
  description: '표준 상품 외 예외 계약을 임시로 처리하는 일반 양식',
  typeKey: 'GENERAL',
  typeLabel: '기타',
  documentTitle: '기타 부동산계약서',
  layoutSummary: '계약 목적과 당사자 합의사항을 자유 입력 영역 중심으로 배치합니다.',
  requiredSections: ['계약 목적', '목적물 표시', '계약 조건', '특약사항', '당사자 서명']
}];
function normalizeContractTemplateKey(value) {
  const key = String(value ?? '').trim().toUpperCase();
  return CONTRACT_TEMPLATE_OPTIONS.some(option => option.key === key) ? key : null;
}
function contractTemplateEditorKey(key) {
  return `CONTRACT_${key}`;
}
const DOCUMENT_TYPE_LABELS = {
  REGISTRY_CERTIFICATE: '등기부등본',
  BUILDING_REGISTER: '건축물대장(전유부/전유공용)',
  LAND_REGISTER: '토지대장',
  LAND_RIGHT_REGISTER: '디지털트윈국토 대지권정보',
  CADASTRAL_MAP: '지적도',
  LAND_USE_PLAN: '토지이용계획확인서',
  TRUST_REGISTER: '신탁원부',
  USER_UPLOAD: '업로드 문서',
  OTHER: '기타 문서',
  CONTRACT: '계약서',
  EXPLANATION_FORM: '확인설명서',
  PARTY_NOTICE: '당사자 유의사항'
};
const CRITICAL_NOTICE_PATTERNS = [/소유(?:자|주).{0,8}불일치|소유권.{0,8}불일치/iu, /용도.{0,8}불일치|용도.{0,8}위반|위반\s*건축물/iu, /압류|가압류|가처분|가등기|경매|권리제한/iu, /신탁|처분권|수탁자|위탁자/iu];
const CRITICAL_NOTICE_TASK_CODES = new Set(['OWNER_MISMATCH', 'TRUST_REGISTRATION', 'SEIZURE_AUCTION_REVIEW']);
const DEFAULT_TEMPLATE_DRAFTS = {
  CONTRACT: {
    bodyText: '제 2 조 (임대차기간) 임대차기간은 계약서에 기재한 개시일부터 종료일까지로 한다.\n' + '제 3 조 (보증금 및 차임) 임차인은 계약금, 잔금, 차임을 약정한 지급일과 방법에 따라 지급한다.\n' + '제 4 조 (인도와 사용) 임대인은 잔금 수령과 동시에 목적물을 인도하고, 임차인은 약정한 용도로 선량하게 사용한다.\n' + '제 5 조 (수선 및 원상회복) 통상적인 사용에 따른 손모를 제외하고 수선, 관리, 원상회복 범위는 특약에 따른다.\n' + '제 6 조 (계약해제 및 손해배상) 당사자 일방이 약정을 위반하면 상대방은 서면 최고 후 계약을 해제하고 손해배상을 청구할 수 있다.',
    noticeText: '계약 당사자는 소재지, 동/호수, 면적, 계약금액, 지급일, 입주일과 특약사항을 서명 전 직접 확인해야 합니다.\n근저당권, 전세권, 압류, 가압류 등 권리관계는 등기부등본 갑구·을구를 기준으로 확인해야 합니다.',
    footerText: '계약 확정 전 공부서류 원본과 계약서 내용을 대조하세요.',
    reason: ''
  },
  CONTRACT_SALE: {
    bodyText: '제 2 조 (소유권 이전과 인도) 매도인은 잔금 수령과 동시에 소유권이전등기에 필요한 서류를 매수인에게 교부하고 목적물을 인도한다.\n' + '제 3 조 (제한물권 말소) 매도인은 잔금일까지 근저당권, 전세권, 압류 등 매수인의 권리행사를 제한하는 권리를 말소한다. 승계하기로 한 권리는 특약에 명시한다.\n' + '제 4 조 (제세공과금) 인도일 전까지 발생한 공과금과 제세공과금은 매도인이, 인도일 이후 발생분은 매수인이 부담한다.\n' + '제 5 조 (계약해제 및 손해배상) 당사자 일방이 채무를 이행하지 않는 경우 상대방은 서면 최고 후 계약을 해제하고 손해배상을 청구할 수 있다.\n' + '제 6 조 (중개보수) 중개보수는 관련 법령과 약정에 따라 계약 체결 시 지급한다.',
    noticeText: '1. 등기부등본 갑구·을구, 건축물대장, 토지대장을 계약일 현재 기준으로 확인한다.\n2. 잔금 전 권리변동이 발생하면 즉시 상대방과 중개업자에게 고지한다.\n3. 대출, 근저당, 임차권 등 승계 또는 말소 조건은 본 특약에 명확히 기재한다.',
    footerText: '',
    reason: ''
  },
  CONTRACT_JEONSE: {
    bodyText: '제 2 조 (임대차기간) 임대차기간은 계약서에 기재한 입주일 또는 개시일부터 종료일까지로 한다.\n' + '제 3 조 (보증금 지급) 임차인은 계약금과 잔금을 약정일에 지급하고, 임대인은 잔금 수령과 동시에 목적물을 인도한다.\n' + '제 4 조 (전입신고와 확정일자) 임차인은 입주 후 전입신고와 확정일자 등 대항력 및 우선변제권 확보 절차를 확인한다.\n' + '제 5 조 (보증금 반환) 임대인은 임대차 종료 및 목적물 반환과 동시에 보증금을 반환한다. 미납 공과금과 원상회복 비용은 정산할 수 있다.\n' + '제 6 조 (권리관계 고지) 임대인은 선순위 권리, 체납, 제한사항 등 보증금 회수에 영향을 줄 수 있는 사항을 고지한다.',
    noticeText: '1. 등기부등본 갑구·을구의 선순위 권리와 보증금 회수 위험을 확인한다.\n2. 입주, 전입신고, 확정일자 진행 일정을 당사자가 확인한다.\n3. 관리비, 수선, 원상회복, 보증금 반환 계좌와 기한은 특약에 적는다.',
    footerText: '전세계약 확정 전 선순위 권리, 전입/확정일자, 보증금 반환 조건을 확인하세요.',
    reason: ''
  },
  CONTRACT_MONTHLY_RENT: {
    bodyText: '제 2 조 (임대차기간) 임대차기간은 계약서에 기재한 개시일부터 종료일까지로 한다.\n' + '제 3 조 (보증금과 월차임) 임차인은 보증금, 월차임, 납부일, 지급방법을 준수하고 임대인은 잔금 수령과 동시에 목적물을 인도한다.\n' + '제 4 조 (관리비 및 사용료) 관리비, 전기·수도·가스·인터넷 등 사용료의 부담과 정산 기준은 약정 또는 특약에 따른다.\n' + '제 5 조 (연체 및 해지) 월차임 연체, 무단 전대, 용도 변경 등 약정 위반이 있으면 법령과 약정에 따라 해지 또는 손해배상을 청구할 수 있다.\n' + '제 6 조 (원상회복) 임차인은 임대차 종료 시 통상손모를 제외하고 목적물을 원상회복하여 반환한다.',
    noticeText: '1. 월차임 납부일, 납부계좌, 연체 시 처리 기준을 명확히 기재한다.\n2. 관리비 포함 항목과 별도 사용료 정산 기준을 기재한다.\n3. 수선 책임, 반려동물, 전대, 원상회복 범위 등 생활 특약을 확인한다.',
    footerText: '월세계약 확정 전 월차임, 관리비, 연체 기준, 원상회복 범위를 확인하세요.',
    reason: ''
  },
  CONTRACT_COMMERCIAL: {
    bodyText: '제 2 조 (상가 목적물과 용도) 당사자는 영업용 부동산의 소재, 면적, 업종, 시설물 범위와 용도 제한을 확인하고 계약한다.\n' + '제 3 조 (보증금·월차임·매매대금·권리금) 지급금액, 지급일, 지급방법을 명확히 하며 권리금이 없거나 별도 계약인 경우 특약에 적는다.\n' + '제 4 조 (관리비·부가세·시설물) 관리비 세부내역, 부가세 부담, 시설물 승계·철거·수선 책임을 특약에 기재한다.\n' + '제 5 조 (영업허가와 공법상 제한) 임차인 또는 매수인은 영업허가, 업종 제한, 건축물 용도, 위반건축물 여부를 확인한다.\n' + '제 6 조 (원상회복과 명도) 계약 종료 시 시설물, 간판, 인테리어의 원상회복 범위와 명도 기준은 특약에 따른다.',
    noticeText: '1. 상가 월세인 경우 권리금 유무, 금액, 지급일, 반환 또는 포기 조건을 명확히 적는다.\n2. 업종 제한, 영업허가, 시설물 인수인계, 부가세와 관리비 부담을 확인한다.\n3. 상가는 월세 또는 매매 조건으로만 작성하며, 전세 조건은 선택하지 않는다.',
    footerText: '상가계약 확정 전 권리금, 업종 제한, 시설물 승계, 관리비와 부가세 부담을 확인하세요.',
    reason: ''
  },
  CONTRACT_LEASE: {
    bodyText: '제 2 조 (임대차기간) 임대차기간은 계약서에 기재한 개시일부터 종료일까지로 한다.\n' + '제 3 조 (보증금 및 차임) 보증금, 계약금, 잔금, 차임, 관리비와 지급일은 계약서 기재 내용에 따른다.\n' + '제 4 조 (목적물 인도와 사용) 임대인은 잔금 수령과 동시에 목적물을 인도하고, 임차인은 약정 용도에 맞게 사용한다.\n' + '제 5 조 (수선 및 관리) 주요 수선과 통상 관리의 부담 기준은 법령, 거래 관행 및 특약에 따른다.\n' + '제 6 조 (반환 및 정산) 임대차 종료 시 목적물 반환, 보증금 반환, 미납금과 원상회복 비용을 정산한다.',
    noticeText: '1. 보증금, 월차임, 관리비, 입주일, 반환일을 확인한다.\n2. 등기부등본 권리관계와 건축물대장 표시사항을 계약일 기준으로 대조한다.\n3. 수선, 원상회복, 사용 제한, 전대 금지 등 추가 조건을 명확히 기재한다.',
    footerText: '임대차계약 확정 전 권리관계, 임대차 기간, 보증금 반환 조건을 확인하세요.',
    reason: ''
  },
  CONTRACT_OTHER: {
    bodyText: '제 2 조 (계약 목적) 본 계약의 목적, 목적물, 권리 이전 또는 사용 범위를 명확히 정한다.\n' + '제 3 조 (대금 및 지급) 계약금액, 지급일, 지급방법, 지연 시 처리 기준은 계약서와 특약에 따른다.\n' + '제 4 조 (당사자의 의무) 각 당사자는 제공할 서류, 인도할 물건, 협조할 절차를 성실히 이행한다.\n' + '제 5 조 (계약 변경 및 해제) 계약 변경은 서면 합의로 하며, 위반 시 해제 및 손해배상 기준은 특약에 따른다.\n' + '제 6 조 (기타) 본 계약에 없는 사항은 관계 법령과 당사자 합의에 따른다.',
    noticeText: '1. 일반 양식으로 처리하기 어려운 목적, 조건, 서류, 일정은 특약에 구체적으로 적는다.\n2. 권리관계와 공부서류 확인이 필요한 경우 첨부 문서와 확인 기준일을 기재한다.\n3. 전자서명 전 당사자에게 계약 목적과 불이행 시 책임을 설명한다.',
    footerText: '기타 계약은 목적과 권리의무가 불명확하지 않도록 특약을 충분히 작성하세요.',
    reason: ''
  },
  EXPLANATION_FORM: {
    bodyText: '',
    noticeText: '중개대상물 확인ㆍ설명서는 법정 원본 PDF 양식을 그대로 사용합니다. 화면의 체크값은 원본 양식에 덮어쓸 데이터 레이어로 별도 저장합니다.',
    footerText: '현 취급상품은 주거용 건축물 Ⅰ 또는 비주거용 건축물 Ⅱ 서식을 자동 첨부합니다.',
    reason: '',
    explanationFormKey: 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING',
    explanationChecks: DEFAULT_EXPLANATION_CHECK_ITEMS,
    languageBackups: {
      ko: {
        source: 'legal-form-original',
        editable: false
      },
      en: {
        reserved: true
      },
      other: {
        reserved: true
      }
    }
  },
  PARTY_NOTICE: {
    bodyText: '서명 전 계약금, 보증금, 잔금, 월차임, 권리금, 지급일과 특약사항을 다시 확인해 주세요.\n온라인 계약은 본인 명의 연락처로 받은 링크에서 문서를 열람한 뒤 전자서명합니다.',
    noticeText: '구두 약속은 문서에 기재된 특약사항으로 반영된 경우에만 계약 내용으로 확인합니다.\n임대차 신고, 확정일자, 전입신고 등 후속 절차는 계약 유형과 당사자 상황에 맞게 확인합니다.',
    footerText: '당사자 유의사항은 계약서 양식이 아닌 서명 전 안내 전용 문서입니다.',
    reason: '',
    customTexts: {
      ...DEFAULT_TEMPLATE_CUSTOM_TEXTS,
      title: '전자계약 당사자 유의사항'
    }
  }
};
const TEMPLATE_EDITOR_CATEGORIES = [{
  key: 'CONTRACT_FORMS',
  label: '계약서',
  description: '매매, 전세, 월세, 상가처럼 목적별 계약서 원본 양식'
}, {
  key: 'SUPPORTING_DOCUMENTS',
  label: '안내/검토 문서',
  description: '확인설명서, 당사자 유의사항'
}];
const TEMPLATE_EDITOR_ITEMS = [...CONTRACT_TEMPLATE_OPTIONS.map(option => ({
  key: contractTemplateEditorKey(option.key),
  categoryKey: 'CONTRACT_FORMS',
  label: option.label,
  description: option.description,
  documentTitle: option.documentTitle,
  layoutSummary: option.layoutSummary,
  requiredSections: option.requiredSections,
  fallbackDraftKey: contractTemplateEditorKey(option.key)
})), {
  key: 'EXPLANATION_FORM',
  categoryKey: 'SUPPORTING_DOCUMENTS',
  label: '중개대상물 확인설명서',
  description: '법정 원본 PDF 양식을 그대로 쓰고 계약방 유형에 맞게 자동 첨부하는 문서',
  documentTitle: '중개대상물 확인ㆍ설명서 법정 원본',
  layoutSummary: '별지 제20호 Ⅰ~Ⅳ 원본을 보관하고, 현 상품군은 주거용 Ⅰ·비주거용 Ⅱ만 자동 사용합니다.',
  requiredSections: ['법정 원본 PDF', '자동 첨부 분류', '자동/수동 체크값', '언어 백업 예약'],
  fallbackDraftKey: 'EXPLANATION_FORM'
}, {
  key: 'PARTY_NOTICE',
  categoryKey: 'SUPPORTING_DOCUMENTS',
  label: '당사자 유의사항',
  description: '온라인 서명 전 임대인/임차인 또는 매도인/매수인이 확인할 안내문',
  documentTitle: '전자계약 당사자 유의사항',
  layoutSummary: '서명 절차, 본인서명, 문서 열람, 특약 확인, 서명 후 보관 안내를 크게 배치합니다.',
  requiredSections: ['본인서명 절차', '문서 열람', '특약 확인', '서명 완료', '보관 안내'],
  fallbackDraftKey: 'PARTY_NOTICE'
}];
const TEMPLATE_EDITOR_ITEM_BY_KEY = TEMPLATE_EDITOR_ITEMS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});
function getTemplateDraftFallback(templateKey) {
  const item = TEMPLATE_EDITOR_ITEM_BY_KEY[templateKey];
  return DEFAULT_TEMPLATE_DRAFTS[item?.fallbackDraftKey ?? templateKey] ?? DEFAULT_TEMPLATE_DRAFTS.CONTRACT;
}
function resolveTemplateEditorLabel(templateKey) {
  return TEMPLATE_EDITOR_ITEM_BY_KEY[templateKey]?.label ?? resolveDocumentTypeLabel(templateKey);
}
const DOCUMENT_READY_STATUSES = new Set(['ISSUED', 'MATCHED', 'ANALYZED', 'LOCKED', 'FINAL', 'ARCHIVED', 'TEXT_LAYER_READY']);
function digitsOnly(value, maxLength) {
  return String(value || '').replace(/\D/g, '').slice(0, maxLength);
}
function formatResidentNumber(value) {
  const digits = digitsOnly(value, 13);
  if (!digits) return '';
  if (digits.length <= 5) return digits;
  if (digits.length === 6) return `${digits.slice(0, 2)}년 ${digits.slice(2, 4)}월 ${digits.slice(4, 6)}일`;
  if (digits.length === 7) return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  if (digits.length === 8) return `${digits.slice(0, 4)}년 ${digits.slice(4, 6)}월 ${digits.slice(6, 8)}일`;
  return `${digits.slice(0, 6)}-${digits.slice(6)}`;
}
function formatPhoneNumber(value) {
  const digits = digitsOnly(value, 11);
  if (!digits) return '';
  if (digits.length === 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  if (digits.startsWith('02')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    return `${digits.slice(0, 2)}-${digits.slice(2, -4)}-${digits.slice(-4)}`;
  }
  if (digits.length === 9) return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, -4)}-${digits.slice(-4)}`;
}
const CONTRACT_PERIOD_YEAR_OPTIONS = [{
  value: 'ONE_YEAR',
  label: '1년',
  years: 1
}, {
  value: 'TWO_YEARS',
  label: '2년',
  years: 2
}, {
  value: 'THREE_YEARS',
  label: '3년',
  years: 3
}, {
  value: 'FOUR_YEARS',
  label: '4년',
  years: 4
}, {
  value: 'FIVE_YEARS',
  label: '5년',
  years: 5
}];
const DIRECT_CONTRACT_PERIOD_TYPE = 'SHORT';
function contractPeriodFixedYears(type) {
  const normalizedType = String(type || '').trim().toUpperCase();
  return CONTRACT_PERIOD_YEAR_OPTIONS.find(option => option.value === normalizedType)?.years ?? null;
}
function isDirectContractPeriodType(type) {
  return String(type || '').trim().toUpperCase() === DIRECT_CONTRACT_PERIOD_TYPE;
}
function isSaleContract(form) {
  return form.contractType === 'SALE';
}
function isMonthlyContract(form) {
  return form.contractType === 'MONTHLY_RENT' || form.contractType === 'COMMERCIAL_LEASE';
}
function isCommercialMonthlyContract(form) {
  return form.propertyType === 'COMMERCIAL' && form.contractType === 'COMMERCIAL_LEASE';
}
function amountToManwonDisplay(value) {
  const text = String(value ?? '').trim();
  if (!text) return '';
  const normalized = text.replace(/\s*만원\s*$/u, '').trim();
  const numeric = normalized.replace(/,/gu, '');
  const formatted = /^\d+$/u.test(numeric) && numeric ? Number(numeric).toLocaleString('ko-KR') : normalized;
  return formatted ? `${formatted}만원` : '';
}
function amountToManwonInput(value) {
  return String(value ?? '').replace(/\s*만원\s*$/u, '').trim();
}
function contractActualTransactionAmountDisplay(form, terms) {
  const contractType = String(form?.contractType || terms?.contractType || '').toUpperCase();
  const saleAmount = amountToManwonDisplay(firstExplanationAutoText(form?.salePriceAmount, readExplanationAutoText(terms ?? {}, 'salePriceAmount', 'saleAmount')));
  const depositAmount = amountToManwonDisplay(firstExplanationAutoText(form?.depositAmount, readExplanationAutoText(terms ?? {}, 'depositAmount')));
  const monthlyRentAmount = amountToManwonDisplay(firstExplanationAutoText(form?.monthlyRentAmount, readExplanationAutoText(terms ?? {}, 'monthlyRentAmount')));
  if (contractType === 'SALE') return saleAmount ? `매매가액 ${saleAmount}` : '';
  if (contractType === 'JEONSE') return depositAmount ? `전세금액 ${depositAmount}` : '';
  const parts = [depositAmount ? `보증금 ${depositAmount}` : '', monthlyRentAmount ? `월세 ${monthlyRentAmount}` : ''].filter(Boolean);
  return parts.join(' / ');
}
function sanitizeLandUsePlanDesignationText(value) {
  const text = firstExplanationAutoText(value).normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text) return '';
  return text.split(/[,;/|·ㆍ]+/u).map(part => part.replace(/(?:광로|대로|중로|소로)\s*\d+\s*류?(?:\s*\([^)]*\))*/gu, '').replace(/(?:도시계획시설|도로시설|도시계획도로|도로구역|도로)(?:\s*\([^)]*\))*/gu, '').replace(/(?:철도|공원|주차장|학교|하천|광장|유수지|공공공지|자동차정류장|공항|항만)(?:\s*\([^)]*\))*/gu, '').replace(/\s{2,}/gu, ' ').trim()).filter(Boolean).filter((part, index, parts) => parts.indexOf(part) === index).join(', ');
}
function toDateInputValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
function dateInputToKoreanText(value) {
  const [year, month, day] = String(value || '').split('-');
  if (!year || !month || !day) return String(value || '').trim();
  return `${year}년 ${month}월 ${day}일`;
}
function dateInputToCompactText(value) {
  const [year, month, day] = String(value || '').split('-');
  if (!year || !month || !day) return String(value || '').trim();
  return `${year}. ${month.padStart(2, '0')}. ${day.padStart(2, '0')}`;
}
function dateTextToInputValue(value) {
  const source = String(value || '').trim();
  const inputDate = source.match(/(\d{4})-(\d{1,2})-(\d{1,2})/u);
  const koreanDate = source.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/u);
  const match = inputDate ?? koreanDate;
  if (!match) return source;
  const [, year, month, day] = match;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}
function addYearsToDateInput(value, years) {
  const start = value ? new Date(`${value}T00:00:00`) : new Date();
  if (Number.isNaN(start.getTime())) return '';
  const end = new Date(start);
  end.setFullYear(end.getFullYear() + years);
  return toDateInputValue(end);
}
function addMonthsToDateInput(value, months) {
  const start = value ? new Date(`${value}T00:00:00`) : new Date();
  if (Number.isNaN(start.getTime())) return '';
  const end = new Date(start);
  end.setMonth(end.getMonth() + months);
  return toDateInputValue(end);
}
function contractPeriodLabel(type, months, contractDate = '', contractStartDate = '', contractEndDate = '') {
  const startDate = dateTextToInputValue(contractStartDate || contractDate || toDateInputValue(new Date()));
  const directEndDate = dateTextToInputValue(contractEndDate);
  const fixedYears = contractPeriodFixedYears(type);
  if (fixedYears) {
    const endDate = addYearsToDateInput(startDate, fixedYears);
    return `${dateInputToCompactText(startDate)} 부터 ${dateInputToCompactText(endDate)} 까지`;
  }
  if (isDirectContractPeriodType(type)) {
    if (directEndDate) return `${dateInputToCompactText(startDate)} 부터 ${dateInputToCompactText(directEndDate)} 까지`;
    const value = String(months ?? '').trim();
    const monthCount = Number(value);
    if (Number.isFinite(monthCount) && monthCount > 0) {
      const endDate = addMonthsToDateInput(startDate, monthCount);
      return `${dateInputToCompactText(startDate)} 부터 ${dateInputToCompactText(endDate)} 까지`;
    }
    return '직접입력';
  }
  const endDate = addYearsToDateInput(startDate, 2);
  return `${dateInputToCompactText(startDate)} 부터 ${dateInputToCompactText(endDate)} 까지`;
}
function rentPaymentLabel(timing, day) {
  const paymentTiming = String(timing || '후불').trim() || '후불';
  const paymentDay = String(day || '').trim();
  return paymentDay ? `월세는 매월 ${paymentDay}일에 ${paymentTiming}로 지불한다.` : '';
}
function balanceDatePaymentLabel(value) {
  const paymentDate = dateInputToKoreanText(value);
  return paymentDate ? `잔금은 ${paymentDate}에 지불하기로 하며, 동의 없는 파기 시 계약금은 반환하지 않는다.` : '';
}
function todayKoreanDateText() {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('ko-KR', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  const parts = Object.fromEntries(formatter.formatToParts(now).map(part => [part.type, part.value]));
  return `${parts.year ?? now.getFullYear()}년 ${parts.month ?? '  '}월 ${parts.day ?? '  '}일`;
}
function looksLikeAuthTokenDisplayText(value) {
  const text = value.normalize('NFKC').trim();
  if (!text) return false;
  if (/^Bearer\s+/iu.test(text)) return true;
  if (/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/u.test(text) && text.length >= 40) return true;
  if (/^(eyJ|ya29\.|sk-|xox|gh[opsu]_)/iu.test(text)) return true;
  return /^[A-Za-z0-9._~+/=-]{80,}$/u.test(text) && /[.=/_-]/u.test(text) && !/[가-힣\s@]/u.test(text);
}
function looksLikeOpaqueRealtorId(value) {
  return looksLikeAuthTokenDisplayText(value) || /^[A-Za-z0-9_-]{18,}$/u.test(value) && !/[가-힣\s@.]/u.test(value);
}
function cleanRealtorProfileText(value, maxLength = 255) {
  const text = String(value ?? '').normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text || text.includes('\uFFFD') || looksLikeAuthTokenDisplayText(text) || looksLikeOpaqueRealtorId(text) || looksLikeBrokenKoreanPlaceholderText(text)) return '';
  return text.slice(0, maxLength);
}
function cleanRealtorSessionUid(value, maxLength = 255) {
  const text = String(value ?? '').normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text || text.includes('\uFFFD') || looksLikeAuthTokenDisplayText(text)) return '';
  return text.slice(0, maxLength);
}
function looksLikeBrokenKoreanPlaceholderText(value) {
  const text = value.normalize('NFKC').trim();
  if (!text) return false;
  const compact = text.replace(/\s+/gu, '');
  if (/^\?+$/u.test(compact)) return true;
  const meaningful = compact.replace(/[0-9A-Za-z.,:;'"()[\]{}<>/\\|+\-_=~`!@#$%^&*]+/gu, '');
  if (meaningful && /^\?+$/u.test(meaningful)) return true;
  const mojibakeSignalCount = (compact.match(/[怨以묎컻щТ뚮챸깅줉踰덊샇꾪솕二쇱냼洹濡듭씤]/gu) ?? []).length;
  if (mojibakeSignalCount >= 2) return true;
  const latinMojibakeCount = (compact.match(/[ÃÂÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/gu) ?? []).length;
  if (!/[가-힣]/u.test(compact) && latinMojibakeCount >= 2) return true;
  const questionCount = (compact.match(/\?/gu) ?? []).length;
  return !/[가-힣]/u.test(compact) && questionCount >= 2 && questionCount / Math.max(compact.length, 1) >= 0.25;
}
function cleanRealtorRegistrationNoText(value, maxLength = 80) {
  const text = String(value ?? '').normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text || text.includes('\uFFFD')) return '';
  return text.slice(0, maxLength);
}
function normalizeRealtorAutoProfile(realtorId, source) {
  const id = effectiveRealtorId(realtorId || source?.id);
  return {
    id,
    uid: cleanRealtorSessionUid(source?.uid) || cleanRealtorSessionUid(realtorId) || cleanRealtorSessionUid(id),
    representativeName: cleanRealtorProfileText(source?.representativeName, 120) || '대표 성명',
    officeName: cleanRealtorProfileText(source?.officeName, 180) || '공인중개사 사무소명',
    officeAddress: cleanRealtorProfileText(source?.officeAddress, 255) || '공인중개사 사무소 주소',
    registrationNo: cleanRealtorRegistrationNoText(source?.registrationNo, 80) || '등록번호',
    phone: cleanRealtorProfileText(source?.phone, 80) || '전화',
    licensedBrokerName: cleanRealtorProfileText(source?.licensedBrokerName, 120) || '소속공인중개사 성명',
    licensedBrokerPhone: cleanRealtorProfileText(source?.licensedBrokerPhone, 80)
  };
}
function buildDisplayAddress(form) {
  const address = collapseRepeatedAddressTail(form.address.trim());
  return address;
}
function readStoredText(record, key) {
  const value = record[key];
  return value === undefined || value === null ? '' : String(value).trim();
}
function normalizeStoredAddressLookup(value) {
  const record = asRecord(value);
  const displayAddress = readStoredText(record, 'displayAddress') || readStoredText(record, 'display_address');
  const selectedAddress = displayAddress || readStoredText(record, 'selectedAddress') || readStoredText(record, 'roadAddress') || readStoredText(record, 'jibunAddress');
  if (!selectedAddress) return null;
  const candidateToken = readStoredText(record, 'candidateToken') || readStoredText(record, 'candidate_token') || readStoredText(record, 'token');
  const catalogId = (readStoredText(record, 'catalogId') || readStoredText(record, 'catalog_id')).replace(/^sql_/u, '');
  const selectedCatalogId = (readStoredText(record, 'selectedCatalogId') || readStoredText(record, 'selected_catalog_id')).replace(/^sql_/u, '');
  const registryIndexKey = readStoredText(record, 'registryIndexKey') || readStoredText(record, 'registry_index_key') || readStoredText(record, 'registryUniqueNoFingerprint') || readStoredText(record, 'registry_unique_no_fingerprint');
  const registryUniqueNoHash = readStoredText(record, 'registryUniqueNoHash') || readStoredText(record, 'registry_unique_no_hash') || readStoredText(record, 'uniqueNoHash') || readStoredText(record, 'unique_no_hash');
  const id = readStoredText(record, 'id') || readStoredText(record, 'candidateId') || readStoredText(record, 'candidate_id') || candidateToken || registryIndexKey || catalogId || selectedCatalogId;
  return {
    id,
    candidateToken,
    registryUniqueNoHash,
    registry_unique_no_hash: registryUniqueNoHash,
    uniqueNoHash: registryUniqueNoHash,
    unique_no_hash: registryUniqueNoHash,
    registryIndexKey,
    registryUniqueNoFingerprint: registryIndexKey,
    registryUniqueNo: '',
    registry_unique_no: '',
    roadAddress: readStoredText(record, 'roadAddress'),
    jibunAddress: readStoredText(record, 'jibunAddress'),
    catalogId,
    selectedCatalogId,
    zipNo: readStoredText(record, 'zipNo'),
    buildingName: readStoredText(record, 'buildingName'),
    roadNameCode: readStoredText(record, 'roadNameCode'),
    adminCode: readStoredText(record, 'adminCode'),
    bcode: readStoredText(record, 'bcode'),
    sigunguCode: readStoredText(record, 'sigunguCode'),
    selectedAddress,
    provider: readStoredText(record, 'provider') || 'registry-address-catalog',
    displayAddress,
    roadBaseAddress: readStoredText(record, 'roadBaseAddress') || readStoredText(record, 'road_base_address'),
    jibunBaseAddress: readStoredText(record, 'jibunBaseAddress') || readStoredText(record, 'jibun_base_address'),
    registrySearchAddress: readStoredText(record, 'registrySearchAddress'),
    detailAddress: readStoredText(record, 'detailAddress'),
    catalogSource: readStoredText(record, 'catalogSource'),
    buildingDong: readStoredText(record, 'buildingDong') || readStoredText(record, 'building_dong'),
    floor: readStoredText(record, 'floor'),
    ho: readStoredText(record, 'ho') || readStoredText(record, 'hoName') || readStoredText(record, 'ho_name'),
    sourceRequestId: readStoredText(record, 'sourceRequestId') || readStoredText(record, 'source_request_id'),
    addressSourceKey: readStoredText(record, 'addressSourceKey') || readStoredText(record, 'address_source_key'),
    addressApiBundleKey: readStoredText(record, 'addressApiBundleKey') || readStoredText(record, 'address_api_bundle_key'),
    addressSourceQueuedAt: readStoredText(record, 'addressSourceQueuedAt') || readStoredText(record, 'address_source_queued_at')
  };
}
function collapseRedundantAddressUnitTail(value) {
  return normalizeDisplayOnlyAddressText(value).replace(/(\d+)\s*동\s+(\d+)\s*(?:호|호실)\s+\1\s+\2(?=\s|$)/gu, '$1동 $2호').replace(/(\d+)\s*층\s+(\d+)\s*(?:호|호실)\s+\1\s+\2(?=\s|$)/gu, '$1층 $2호').replace(/(\d+)\s*(?:호|호실)\s+\1(?=\s|$)/gu, '$1호').replace(/\s+/gu, ' ').trim();
}
function compactAddressUnitNumberText(value) {
  return normalizeDisplayOnlyAddressText(value).replace(/(^|\s)제\s*/gu, '$1').replace(/(\d+)\s*(?:동|층|호실|호)/gu, '$1').replace(/\s+/gu, '').toLowerCase();
}
function normalizeContractAddressDisplayText(value) {
  return collapseRedundantAddressUnitTail(collapseRepeatedAddressTail(repairSplitRoadBranchNumber(normalizeDisplayOnlyAddressText(value))));
}
const CONTRACT_BOARD_USAGE_LABEL_PATTERN = /(?:^|\s)(?:제?\s*[12]\s*종\s*)?근린생활시설(?:\s*(?:제?\s*)?[12]\s*종)?(?=\s|$)/gu;
const CONTRACT_BOARD_PRIMARY_REGION_PATTERN = /(?:서울특별시|서울시|인천광역시|인천시|경기도|강원특별자치도|강원도|충청북도|충북|충청남도|충남|전북특별자치도|전라북도|전북|전라남도|전남|경상북도|경북|경상남도|경남|대전광역시|대전시|대구광역시|대구시|부산광역시|부산시|울산광역시|울산시|광주광역시|광주시|세종특별자치시|세종시|제주특별자치도|제주도)/u;
const CONTRACT_BOARD_NON_ADDRESS_SUFFIX_PATTERN = /\s+(?:\[?REDACTED_REGISTRY_UNIQUE_NO\]?\s*)?(?:QA\d+(?:-\d+)?\s+)?(?:COM|RES)-(?:SALE|JEONSE|MONTHLY)(?:\s+(?:\[?REDACTED_REGISTRY_UNIQUE_NO\]?|\d{8}-\d{6}))*\s*$/iu;
function stripContractBoardUsageLabelText(value) {
  return normalizeContractAddressDisplayText(value).replace(CONTRACT_BOARD_USAGE_LABEL_PATTERN, ' ').replace(/\s+/gu, ' ').trim();
}
function removeContractBoardFloorText(value) {
  return stripContractBoardUsageLabelText(value).replace(/(?:지하|지상)?\d+\s*층/gu, ' ').replace(/\s+/gu, ' ').trim();
}
function stripContractBoardNonAddressSuffix(value) {
  let next = stripContractBoardEdgeBrackets(removeContractBoardFloorText(normalizeContractAddressDisplayText(value)));
  for (let index = 0; index < 3; index += 1) {
    const stripped = next.replace(CONTRACT_BOARD_NON_ADDRESS_SUFFIX_PATTERN, '').replace(/\s+/gu, ' ').trim();
    if (stripped === next) break;
    next = stripped;
  }
  return next;
}
function isContractBoardJibunOnlyText(value) {
  return /^[가-힣]+(?:읍|면|동|리)\s+\d+(?:-\d+)?$/u.test(normalizeContractAddressDisplayText(value));
}
function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function stripContractBoardEdgeBrackets(value) {
  return String(value || '').replace(/^[\s\[\](){}<>]+/u, '').replace(/[\s\[\](){}<>]+$/u, '').trim();
}
function contractBoardPrimaryRegionIndex(value) {
  const match = CONTRACT_BOARD_PRIMARY_REGION_PATTERN.exec(String(value || ''));
  return typeof match?.index === 'number' ? match.index : -1;
}
function normalizeContractBoardExplicitUnitPart(part, suffix) {
  const unit = stripAddressUnitPrefix(part, suffix);
  if (!unit) return '';
  const mixed = unit.match(new RegExp(`^[가-힣]+([0-9A-Za-z-]*\\d[0-9A-Za-z-]*${suffix})$`, 'u'));
  return mixed?.[1] || unit;
}
function cleanLoadedAddressText(value) {
  const text = normalizeContractAddressDisplayText(value).replace(/^-$/u, '').trim();
  if (!text || text.includes('\uFFFD') || looksLikeBrokenKoreanPlaceholderText(text)) return '';
  return text;
}
function getContractRoomName(contract) {
  const raw = [contract.roomName, contract.title, getContractAddress(contract), contract.id].map(value => cleanLoadedAddressText(value)).find(Boolean) || '';
  const parts = raw.split(/\s+-\s+/u);
  if (parts.length > 1) {
    return [normalizeContractAddressDisplayText(parts[0]), ...parts.slice(1).map(part => String(part || '').trim()).filter(Boolean)].filter(Boolean).join(' - ');
  }
  return normalizeContractAddressDisplayText(raw);
}
function getContractRawAddressTextValues(contract) {
  const metadata = asRecord(contract.metadata);
  const lookup = asRecord(metadata.addressLookup);
  const normalizedLookup = normalizeStoredAddressLookup(metadata.addressLookup);
  const canonicalLookupAddress = normalizedLookup ? canonicalAddressLookupSelectedAddress(normalizedLookup) : '';
  const terms = asRecord(contract.contractTerms);
  const termsInput = asRecord(terms.contractTermsInput ?? metadata.contractTermsInput);
  return [canonicalLookupAddress, lookup.roadAddress, lookup.jibunAddress, metadata.displayAddress, metadata.addressDisplay, lookup.displayAddress, lookup.selectedAddress, metadata.addressInput, contract.address, termsInput.addressInput].map(value => cleanLoadedAddressText(value)).filter(Boolean);
}
function getContractAddress(contract) {
  const metadata = asRecord(contract.metadata);
  const lookup = asRecord(metadata.addressLookup);
  const baseAddress = getContractRawAddressTextValues(contract).find(Boolean) ?? '';
  const detail = normalizeContractAddressDisplayText(metadata.addressDetail ?? lookup.detailAddress ?? '').replace(/^-$/u, '');
  const displayBaseAddress = normalizeContractAddressDisplayText(baseAddress);
  if (!displayBaseAddress || !detail) return displayBaseAddress;
  const compactDetail = compactAddressDisplayText(detail);
  const unitNumberDetail = compactAddressUnitNumberText(detail);
  const detailAlreadyIncluded = compactAddressDisplayText(displayBaseAddress).includes(compactDetail) || unitNumberDetail.length >= 3 && addressTailHasUnitSignal(displayBaseAddress) && compactAddressUnitNumberText(displayBaseAddress).includes(unitNumberDetail);
  const address = detailAlreadyIncluded ? displayBaseAddress : `${displayBaseAddress} ${detail}`;
  return normalizeContractAddressDisplayText(address);
}
function normalizeContractBoardBuildingNameCandidate(value) {
  let building = stripContractBoardNonAddressSuffix(value);
  const regionIndex = contractBoardPrimaryRegionIndex(building);
  if (regionIndex > 0) building = building.slice(0, regionIndex).trim();
  const unitMixedBuilding = building.match(/^.*?호\s+(.+)$/u);
  if (unitMixedBuilding?.[1]) building = unitMixedBuilding[1];
  building = stripContractBoardUsageLabelText(building).replace(/\s+(?:제\s*)?[0-9A-Za-z-]*\d[0-9A-Za-z-]*\s*동\s+(?:제\s*)?[0-9A-Za-z-]*\d[0-9A-Za-z-]*\s*호\s*$/u, '').replace(/\s+(?:제\s*)?[0-9A-Za-z-]*\d[0-9A-Za-z-]*\s*호\s*$/u, '').replace(/\s+(?:제\s*)?[0-9A-Za-z-]*\d[0-9A-Za-z-]*\s*동\s*$/u, '').replace(/^\d+\s*동\s*/u, '').replace(/^\d+\s*호\s*/u, '').replace(/\s+/gu, ' ').trim();
  const buildingParts = building.split(/\s+/u).filter(Boolean);
  if (buildingParts.length === 2 && buildingParts[0].startsWith(buildingParts[1]) && buildingParts[1].length >= 2) {
    building = buildingParts[0];
  }
  if (isContractBoardJibunOnlyText(building)) return '';
  if (contractBoardPrimaryRegionIndex(building) === 0) return '';
  if (/(?:REDACTED_REGISTRY_UNIQUE_NO|COM-(?:SALE|JEONSE|MONTHLY)|RES-(?:SALE|JEONSE|MONTHLY))/iu.test(building)) return '';
  return normalizeContractAddressDisplayText(building);
}
function readFirstContractText(records, keys) {
  for (const record of records) {
    for (const key of keys) {
      const value = String(record[key] ?? '').trim().replace(/^-$/u, '');
      if (value) return value;
    }
  }
  return '';
}
function normalizeBrokerageFeeText(value) {
  return normalizeExplanationTextLayerCustomText('ef_p4_brokerage_fee_max', value);
}
function firstRoundedBrokerageFeeText(...values) {
  for (const value of values) {
    const text = normalizeBrokerageFeeText(value);
    if (text) return text;
  }
  return '';
}
function isNonCriticalNoticeValue(value) {
  const text = value.normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text) return false;
  const unresolvedRisk = /불일치|불법|미\s*완료|미\s*시정|미\s*조치|조치\s*중|진행\s*중|위반(?![^,;.\n]*없음)|압류(?![^,;.\n]*(?:없음|말소|해제|취소))|가압류(?![^,;.\n]*(?:없음|말소|해제|취소))|가처분(?![^,;.\n]*(?:없음|말소|해제|취소))|경매(?![^,;.\n]*(?:없음|말소|해제|취소))|신탁(?![^,;.\n]*(?:없음|말소|해제|취소))|권리제한(?![^,;.\n]*없음)/u.test(text);
  if (unresolvedRisk) return false;
  return /해당\s*없음|없음|활성\s*항목\s*없음|유효한\s*.*없음|정상|적법|말소|해제|취소|해소|완료/u.test(text);
}
function isCriticalNoticeText(value) {
  if (isNonCriticalNoticeValue(value)) return false;
  return CRITICAL_NOTICE_PATTERNS.some(pattern => pattern.test(value));
}
function pushUniqueCriticalNoticeRow(rows, row) {
  const label = row.label.trim();
  const value = row.value.trim();
  if (!label || !value || value === '확인 대기' || isNonCriticalNoticeValue(value)) return;
  const key = `${label}|${value}`;
  if (!rows.some(item => `${item.label}|${item.value}` === key)) rows.push({
    label,
    value
  });
}
function getContractCriticalNoticeRows(contract, registryReviewTasks = []) {
  if (!contract) return [];
  const rows = [];
  registryReviewTasks.forEach(task => {
    const code = readText(task, 'code', '').trim().toUpperCase();
    const severity = readText(task, 'severity', '').trim().toUpperCase();
    const text = [readText(task, 'title', ''), readText(task, 'reason', ''), readText(task, 'registryValue', ''), readText(task, 'contractValue', ''), readText(task, 'action', '')].filter(Boolean).join(' ');
    if (severity !== 'HIGH_RISK' && !CRITICAL_NOTICE_TASK_CODES.has(code) && !isCriticalNoticeText(text)) return;
    pushUniqueCriticalNoticeRow(rows, {
      label: readText(task, 'title', '크리티컬 유의사항'),
      value: readFirstContractText([task], ['reason', 'registryValue', 'action']) || text
    });
  });
  const metadata = asRecord(contract.metadata);
  const progressSummary = asRecord(contract.progressSummary);
  const automationFields = asRecord(progressSummary.automationFields);
  const registry = asRecord(progressSummary.registry);
  const registryPrefill = asRecord(metadata.registryPdfPrefill);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const registryPdfPrefill = asRecord(metadata.registryPdfPrefill);
  const registryPdfAutomation = asRecord(metadata.registryPdfAutomation);
  const records = [registryPrefill, registryPdfPrefill, registryPdfAutomation, automationFieldMap, automationFields, registry, metadata, progressSummary];
  [{
    label: '소유주 불일치',
    value: readFirstContractText(records, ['ownerMismatchSummary', 'ownerMismatch', 'registryOwnerMismatchSummary', 'ownerNameMismatchSummary'])
  }, {
    label: '용도 불일치',
    value: readFirstContractText(records, ['usageMismatchSummary', 'useMismatchSummary', 'purposeMismatchSummary', 'buildingUseMismatchSummary', 'mainUseMismatchSummary'])
  }, {
    label: '압류/권리제한',
    value: readFirstContractText(records, ['seizureSummary', 'attachmentSummary', 'registrySeizureSummary', 'activeRestrictionSummary', 'registryRiskSummary', 'riskSummary'])
  }].forEach(row => {
    if (row.value && isCriticalNoticeText(row.value)) pushUniqueCriticalNoticeRow(rows, row);
  });
  return rows.slice(0, 6);
}
function asRecord(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}
function asRecordArray(value) {
  return Array.isArray(value) ? value.filter(item => Boolean(item) && typeof item === 'object' && !Array.isArray(item)) : [];
}
const DOCUMENT_AUTOMATION_EMPTY_FIELD_VALUES = new Set(['관련내용없음', '직접확인필요', '확인필요', '값없음', '없음', '미확인', '조회실패', '조회오류', '오류']);
function normalizeDocumentAutomationLookupText(value) {
  return String(value ?? '').normalize('NFKC').replace(/[\s_./:(){}[\]-]+/gu, '').trim().toLowerCase();
}
function documentAutomationFieldHasUsableValue(field) {
  const value = readText(field, 'value', '') || readText(field, 'displayValue', '');
  if (!value.trim()) return false;
  return !isInvalidAutomationApiChipValue(value) && !DOCUMENT_AUTOMATION_EMPTY_FIELD_VALUES.has(normalizeDocumentAutomationLookupText(value));
}
function documentAutomationAccessModeFromText(value) {
  const text = String(value ?? '').normalize('NFKC').trim();
  if (!text) return '';
  if (/(?:\uCC28\uB7C9|\uC790\uB3D9\uCC28|\bcar\b|\bvehicle\b)/iu.test(text)) return 'car';
  if (/(?:\uB3C4\uBCF4|\uBCF4\uD589|\bwalk\b|\bwalking\b)/iu.test(text)) return 'walk';
  if (/(?:\uD574\uB2F9\s*\uC5C6\uC74C|\uC5C6\uC74C|\bnone\b|\bnot[_ -]?applicable\b)/iu.test(text)) return 'none';
  return '';
}
function mergeDocumentAutomationFields(primaryFields, fallbackFields) {
  if (!fallbackFields.length) return primaryFields;
  const mergedByKey = new Map();
  const addField = (field, replaceEmpty) => {
    const key = readText(field, 'key', '').trim();
    if (!key) return;
    const existing = mergedByKey.get(key);
    if (!existing || replaceEmpty && !documentAutomationFieldHasUsableValue(existing)) {
      mergedByKey.set(key, field);
    }
  };
  primaryFields.forEach(field => addField(field, false));
  fallbackFields.forEach(field => addField(field, true));
  return Array.from(mergedByKey.values());
}
function documentSnapshotAutomationFieldMap(snapshot) {
  const automationApiDisplay = asRecord(snapshot.automationApiDisplay);
  const fields = asRecordArray(snapshot.automationFields);
  const apiSources = asRecordArray(snapshot.automationApiSources);
  const registryReviewTasks = asRecordArray(snapshot.registryReviewTasks);
  const summary = asRecord(snapshot.automationFieldSummary);
  const hasAutomationReadModel = fields.length > 0 || apiSources.length > 0 || asRecordArray(automationApiDisplay.fieldChips).length > 0 || registryReviewTasks.length > 0 || Object.keys(summary).length > 0;
  if (!hasAutomationReadModel) return null;
  return {
    fields,
    apiSources,
    automationApiDisplay,
    registryReviewTasks,
    summary
  };
}
function contractWithDocumentSnapshotAutomation(contract, snapshot) {
  if (!contract) return null;
  const snapshotAutomationFieldMap = documentSnapshotAutomationFieldMap(snapshot);
  if (!snapshotAutomationFieldMap) return contract;
  const metadata = asRecord(contract.metadata);
  const existingAutomationFieldMap = asRecord(metadata.automationFieldMap);
  const existingAutomationApiDisplay = asRecord(existingAutomationFieldMap.automationApiDisplay);
  const existingFields = asRecordArray(existingAutomationFieldMap.fields);
  const snapshotFields = asRecordArray(snapshotAutomationFieldMap.fields);
  const mergedFields = mergeDocumentAutomationFields(existingFields, snapshotFields);
  const snapshotApiSources = asRecordArray(snapshotAutomationFieldMap.apiSources);
  const snapshotAutomationApiDisplay = asRecord(snapshotAutomationFieldMap.automationApiDisplay);
  const snapshotRegistryReviewTasks = asRecordArray(snapshotAutomationFieldMap.registryReviewTasks);
  const snapshotSummary = asRecord(snapshotAutomationFieldMap.summary);
  const nextAutomationFieldMap = {
    ...existingAutomationFieldMap,
    ...(mergedFields.length ? {
      fields: mergedFields
    } : {}),
    ...(snapshotApiSources.length ? {
      apiSources: snapshotApiSources
    } : {}),
    ...(Object.keys(snapshotAutomationApiDisplay).length ? {
      automationApiDisplay: {
        ...existingAutomationApiDisplay,
        ...snapshotAutomationApiDisplay
      }
    } : {}),
    ...(snapshotRegistryReviewTasks.length ? {
      registryReviewTasks: snapshotRegistryReviewTasks
    } : {}),
    ...(Object.keys(snapshotSummary).length ? {
      summary: {
        ...asRecord(existingAutomationFieldMap.summary),
        ...snapshotSummary
      }
    } : {})
  };
  const progressSummary = asRecord(contract.progressSummary);
  const nextProgressSummary = Object.keys(snapshotSummary).length ? {
    ...progressSummary,
    automationFields: {
      ...asRecord(progressSummary.automationFields),
      ...snapshotSummary
    }
  } : progressSummary;
  return {
    ...contract,
    metadata: {
      ...metadata,
      automationFieldMap: nextAutomationFieldMap
    },
    progressSummary: nextProgressSummary
  };
}
function readText(record, key, fallback = '-') {
  const value = record[key];
  return value === undefined || value === null || value === '' ? fallback : String(value);
}
function previewValue(value, fallback = '계약방 저장값 자동입력') {
  const text = String(value ?? '').trim();
  return text || fallback;
}
function textLayerCustomText(draft, key, fallback) {
  const value = draft.customTexts?.[key];
  if (typeof value === 'string') return value;
  return fallback ?? readText(DEFAULT_TEMPLATE_CUSTOM_TEXTS, key, '');
}
const EXPLANATION_AUTO_TEXT_PLACEHOLDERS = new Set(['대표 성명', '공인중개사 사무소명', '공인중개사 사무소 주소', '등록번호', '전화', '소속공인중개사 성명']);
function cleanExplanationAutoText(value, maxLength = 255) {
  const text = cleanRealtorProfileText(value, maxLength);
  return EXPLANATION_AUTO_TEXT_PLACEHOLDERS.has(text) ? '' : text;
}
function firstExplanationAutoText(...values) {
  for (const value of values) {
    const text = cleanExplanationAutoText(value);
    if (text) return text;
  }
  return '';
}
function firstNumericValue(value) {
  const match = String(value ?? '').replace(/,/g, '').match(/-?\d+(?:\.\d+)?/u);
  if (!match) return null;
  const parsed = Number(match[0]);
  return Number.isFinite(parsed) ? parsed : null;
}
function formatSquareMeterDisplay(value) {
  return formatRealtorAutoSquareMeterDisplay(value);
}
function normalizeExplanationSquareMeterText(value) {
  const text = cleanExplanationAutoText(value);
  if (!text) return '';
  const unitNormalized = normalizeRealtorAutoAreaUnitLabel(text, '');
  if (/(?:m²|평)/u.test(unitNormalized)) return unitNormalized;
  const parsed = firstNumericValue(unitNormalized);
  return parsed !== null ? formatSquareMeterDisplay(parsed) : unitNormalized;
}
function normalizePlainExplanationSquareMeterText(value) {
  const text = cleanExplanationAutoText(value);
  if (!text) return '';
  const unitNormalized = normalizeRealtorAutoAreaUnitLabel(text, '');
  if (/(?:m²|평)/u.test(unitNormalized)) return unitNormalized;
  const numericOnly = unitNormalized.replace(/,/g, '').trim();
  if (!/^-?\d+(?:\.\d+)?$/u.test(numericOnly)) return unitNormalized;
  const parsed = Number(numericOnly);
  return Number.isFinite(parsed) ? formatSquareMeterDisplay(parsed) : unitNormalized;
}
function firstExplanationAreaAutoText(...values) {
  for (const value of values) {
    const text = normalizeExplanationSquareMeterText(value);
    if (text) return text;
  }
  return '';
}
function parseSiteRightRatio(value) {
  const match = String(value ?? '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]+)?)\s*\/\s*([0-9]+(?:\.[0-9]+)?)/u);
  if (!match) return null;
  const owned = Number(match[1]);
  const total = Number(match[2]);
  if (!Number.isFinite(owned) || !Number.isFinite(total) || total <= 0) return null;
  return {
    owned,
    total
  };
}
function formatSiteRightDisplay(siteRightArea, siteRightRatio) {
  const ratio = parseSiteRightRatio(siteRightRatio);
  const ownedArea = firstNumericValue(siteRightArea) ?? ratio?.owned ?? null;
  if (ratio && ownedArea !== null) {
    return `${formatSquareMeterDisplay(ratio.total)} 중 ${formatSquareMeterDisplay(ownedArea)}`;
  }
  if (ownedArea !== null) return formatSquareMeterDisplay(ownedArea);
  return '';
}
function readExplanationAutoText(record, ...keys) {
  for (const key of keys) {
    const text = cleanExplanationAutoText(record[key]);
    if (text) return text;
  }
  return '';
}
function readExplanationAutoIdentifierText(record, ...keys) {
  for (const key of keys) {
    const text = cleanExplanationAutoText(cleanRealtorRegistrationNoText(record[key]));
    if (text) return text;
  }
  return '';
}
function firstExplanationAutoIdentifierText(...values) {
  for (const value of values) {
    const text = cleanExplanationAutoText(cleanRealtorRegistrationNoText(value));
    if (text) return text;
  }
  return '';
}
function normalizeExplanationAutoCompareText(value, maxLength = 255) {
  return cleanExplanationAutoText(value, maxLength).normalize('NFKC').replace(/\s+/gu, ' ').trim().toLowerCase();
}
function normalizeExplanationPersonCompareText(value) {
  return cleanExplanationAutoText(value, 120).normalize('NFKC').replace(/\s+/gu, '').trim().toLowerCase();
}
function isSameExplanationAutoTextValue(left, right) {
  const normalizedLeft = normalizeExplanationAutoCompareText(left);
  const normalizedRight = normalizeExplanationAutoCompareText(right);
  return Boolean(normalizedLeft && normalizedRight && normalizedLeft === normalizedRight);
}
function isSameExplanationPersonName(left, right) {
  const normalizedLeft = normalizeExplanationPersonCompareText(left);
  const normalizedRight = normalizeExplanationPersonCompareText(right);
  return Boolean(normalizedLeft && normalizedRight && normalizedLeft === normalizedRight);
}
function realtorRepresentativeAutoText(realtor, realtorProfile) {
  return firstExplanationAutoText(readExplanationAutoText(realtor, 'representativeName', 'name'), realtorProfile?.representativeName, readExplanationAutoText(realtor, 'realtorName'));
}
function realtorManagerAutoText(realtor, realtorProfile, options) {
  const representativeName = realtorRepresentativeAutoText(realtor, realtorProfile);
  const managerName = firstExplanationAutoText(readExplanationAutoText(realtor, 'licensedBrokerName', 'affiliatedBrokerName', 'managerName', 'realtorName'), realtorProfile?.licensedBrokerName);
  if (!managerName) return options?.fallbackToRepresentative ? representativeName : '';
  if (representativeName && isSameExplanationPersonName(managerName, representativeName)) {
    return options?.fallbackToRepresentative ? representativeName : '';
  }
  return managerName;
}
function realtorOfficeAutoText(realtor, realtorProfile) {
  return firstExplanationAutoText(readExplanationAutoText(realtor, 'officeName', 'agencyName'), realtorProfile?.officeName);
}
function explanationPartyRecord(contract, role) {
  const metadata = asRecord(contract?.metadata);
  const partySummary = asRecord(contract?.partySummary);
  const partyInput = asRecord(metadata.partyInput);
  const aliases = role === 'lessorOrSeller' ? ['lessorOrSeller', 'lessor', 'seller', 'owner', 'landlord'] : ['lesseeOrBuyer', 'lessee', 'buyer', 'tenant'];
  for (const key of aliases) {
    const input = asRecord(partyInput[key]);
    if (Object.keys(input).length) return input;
  }
  for (const key of aliases) {
    const summary = asRecord(partySummary[key]);
    if (Object.keys(summary).length) return summary;
  }
  return {};
}
function explanationAutomationFields(contract) {
  const metadata = asRecord(contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  return asRecordArray(automationFieldMap.fields);
}
function explanationAutomationFieldValue(contract, ...keysOrLabels) {
  const metadata = asRecord(contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const automationSummary = asRecord(automationFieldMap.summary);
  const automationFieldsRecord = asRecord(metadata.automationFields);
  const contractTerms = asRecord(contract?.contractTerms);
  const fields = explanationAutomationFields(contract);
  for (const target of keysOrLabels) {
    const normalizedTarget = target.trim();
    if (!normalizedTarget) continue;
    const field = fields.find(item => readText(item, 'key', '').trim() === normalizedTarget || readText(item, 'label', '').trim() === normalizedTarget);
    const value = readExplanationAutoText(field ?? {}, 'value', 'displayValue', 'text');
    if (value) return value;
  }
  for (const target of keysOrLabels) {
    const normalizedTarget = target.trim();
    if (!normalizedTarget) continue;
    const value = firstExplanationAutoText(readExplanationAutoText(automationSummary, normalizedTarget), readExplanationAutoText(automationFieldsRecord, normalizedTarget), readExplanationAutoText(metadata, normalizedTarget), readExplanationAutoText(contractTerms, normalizedTarget));
    if (value) return value;
  }
  return '';
}
const MANAGEMENT_API_OPTION_CHECK_KEYS = new Set(['management-security-room', 'management-subject', 'management-charge-method']);
const MANAGEMENT_API_FEE_FIELD_KEYS_BY_CHECK_KEY = {
  'management-fee-electricity': ['apartmentElectricityCost', '전기료'],
  'management-fee-water': ['apartmentWaterCost', '수도료'],
  'management-fee-gas': ['apartmentGasCost', '가스사용료'],
  'management-fee-heating': ['apartmentHeatCost', '난방비'],
  'management-fee-internet': ['apartmentInternetCost', 'internetCost', 'managementInternetCost', '인터넷 사용료']
};
const MANAGEMENT_CHARGE_METHOD_FIELD_KEYS = ['apartmentChargeMethod', 'managementChargeMethod', 'manageChargeMethod', 'chargeMethod', 'costChargeMethod', 'manageCostChargeMethod', 'managementFeeChargeMethod', 'codeChgNm', 'codeAccNm', 'levyMethod', '관리비 부과방식'];
function isPendingAutomationText(value) {
  return !value || value === '-' || /(?:입력|등록|확인|연결|조회)\s*대기$/u.test(value) || /^(?:대기|미확인)$/u.test(value);
}
function managementAutomationReadyValue(contract, ...keysOrLabels) {
  const value = explanationAutomationFieldValue(contract, ...keysOrLabels).trim();
  return isPendingAutomationText(value) ? '' : value;
}
function isManagementApiCheckKey(checkKey) {
  return MANAGEMENT_API_OPTION_CHECK_KEYS.has(checkKey) || Boolean(MANAGEMENT_API_FEE_FIELD_KEYS_BY_CHECK_KEY[checkKey]);
}
function managementAutomationOptionForCheck(contract, checkKey) {
  if (checkKey === 'management-subject') {
    const text = managementAutomationReadyValue(contract, 'apartmentManagementType', '관리방식');
    if (/위탁/u.test(text)) return 'entrusted';
    if (/자치|자체/u.test(text)) return 'self';
    if (text) return 'other';
  }
  if (checkKey === 'management-security-room') {
    const text = managementAutomationReadyValue(contract, 'apartmentSecurityManagement', '경비관리');
    if (/없음|미운영|무인/u.test(text) || /(?:^|[^0-9])0\s*(?:명|건|개|$)/u.test(text)) return 'none';
    if (text) return 'exists';
  }
  if (checkKey === 'management-charge-method') {
    const text = managementAutomationReadyValue(contract, ...MANAGEMENT_CHARGE_METHOD_FIELD_KEYS);
    if (/직접|임대인/u.test(text)) return 'direct';
    if (/관리규약|규약|고지|관리비|관리주체|부과/u.test(text)) return 'rules';
    if (text) return 'other';
  }
  return '';
}
function managementAutomationStatusForCheck(contract, checkKey) {
  if (MANAGEMENT_API_OPTION_CHECK_KEYS.has(checkKey)) return managementAutomationOptionForCheck(contract, checkKey) ? 'OK' : '';
  const fieldKeys = MANAGEMENT_API_FEE_FIELD_KEYS_BY_CHECK_KEY[checkKey];
  return fieldKeys && managementAutomationReadyValue(contract, ...fieldKeys) ? 'OK' : '';
}
const LAND_USE_REGULATION_CHECK_KEYS = new Set(['legal-land-transaction-permit-zone', 'legal-land-speculation-area', 'legal-house-speculation-area', 'legal-overheated-speculation-district']);
function regulationTextIsAffirmative(...values) {
  const text = values.map(value => String(value ?? '').normalize('NFKC').trim()).filter(Boolean).join(' ');
  if (!text) return false;
  if (/해당\s*없음|미\s*해당|비\s*해당|아님|제외|없음|false|^n(?:o)?$/iu.test(text)) return false;
  return /해당|지정|구역|지역|대상|true|^y(?:es)?$|^1$/iu.test(text);
}
function restrictionHasLandTransactionPermitZone(value) {
  const text = String(value ?? '').normalize('NFKC').replace(/\s+/gu, '');
  return /토지거래(?:계약에관한)?허가구역/iu.test(text) || /토지거래.*허가구역/iu.test(text);
}
function explanationLandUseRegulationRestrictionText(contract) {
  return explanationAutomationFieldValue(contract, 'landUsePlanRestriction', '공법상 이용제한/거래규제', '토지이용계획 제한', '거래규제');
}
function explanationLandUseRegulationAutoStatusForCheck(contract, checkKey) {
  const restrictionText = explanationLandUseRegulationRestrictionText(contract);
  if (checkKey === 'legal-land-transaction-permit-zone') {
    return regulationTextIsAffirmative(explanationAutomationFieldValue(contract, 'landTransactionPermitZone', '토지거래허가구역'), restrictionHasLandTransactionPermitZone(restrictionText) ? restrictionText : '') ? 'OK' : '';
  }
  if (checkKey === 'legal-overheated-speculation-district') {
    return regulationTextIsAffirmative(explanationAutomationFieldValue(contract, 'overheatedSpeculationDistrict', '투기과열지구'), /투기과열/u.test(restrictionText) ? restrictionText : '') ? 'OK' : '';
  }
  const propertyText = [contract?.propertyType, asRecord(contract?.contractTerms).propertyType, explanationAutomationFieldValue(contract, 'mainUse', '용도/주용도')].map(value => String(value ?? '').normalize('NFKC')).join(' ');
  const landOnly = /(?:^|[^A-Z])LAND(?:[^A-Z]|$)|토지|대지|임야|(?:^|\s)(?:전|답|대|잡종지)(?:\s|$)/iu.test(propertyText) && !/건축|건물|주택|아파트|오피스텔|상가/iu.test(propertyText);
  if (checkKey === 'legal-land-speculation-area') {
    const explicitLand = /토지\s*투기지역/u.test(restrictionText);
    const generic = /투기지역/u.test(restrictionText) && !/투기과열/u.test(restrictionText);
    return regulationTextIsAffirmative(explicitLand || landOnly && generic ? restrictionText : '') ? 'OK' : '';
  }
  if (checkKey === 'legal-house-speculation-area') {
    const direct = explanationAutomationFieldValue(contract, 'speculationArea', '투기지역');
    const explicitHouse = /주택\s*투기지역|투기지역\s*지정/u.test(restrictionText);
    const generic = /투기지역/u.test(restrictionText) && !/투기과열|토지\s*투기지역/u.test(restrictionText);
    return regulationTextIsAffirmative(direct, explicitHouse || !landOnly && generic ? restrictionText : '') ? 'OK' : '';
  }
  return '';
}
function isDirectConfirmedCheckItem(item) {
  return item?.source === 'MANUAL' && item.status !== 'NEEDS_CHECK';
}
function needsDirectConfirmationCheck(item, contract) {
  if (!item || !DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(item.key)) return false;
  if (isDirectConfirmedCheckItem(item)) return false;
  if (managementAutomationStatusForCheck(contract, item.key) === 'OK') return false;
  const autoOption = explanationAutoOptionForCheck(contract, item.key);
  if (autoOption && item.key !== 'location-road') return false;
  if (item.options?.length && item.source === 'MANUAL' && item.selectedOption && item.status === 'OK') return false;
  return true;
}
const EXPLANATION_SOURCE_DOCUMENT_TYPE_BY_OVERLAY_ID = {
  'p1-source-registry-certificate': 'REGISTRY_CERTIFICATE',
  'p1-source-land-register': 'LAND_REGISTER',
  'p1-source-building-register': 'BUILDING_REGISTER',
  'p1-source-cadastral-map': 'CADASTRAL_MAP',
  'p1-source-land-use-plan': 'LAND_USE_PLAN',
  'p1-nonresidential-source-registry-certificate': 'REGISTRY_CERTIFICATE',
  'p1-nonresidential-source-land-register': 'LAND_REGISTER',
  'p1-nonresidential-source-building-register': 'BUILDING_REGISTER',
  'p1-nonresidential-source-cadastral-map': 'CADASTRAL_MAP',
  'p1-nonresidential-source-land-use-plan': 'LAND_USE_PLAN'
};
const EXPLANATION_SOURCE_DOCUMENT_TYPES = [{
  type: 'REGISTRY_CERTIFICATE',
  label: '등기사항증명서'
}, {
  type: 'LAND_REGISTER',
  label: '토지대장'
}, {
  type: 'BUILDING_REGISTER',
  label: '건축물대장'
}, {
  type: 'CADASTRAL_MAP',
  label: '지적도'
}, {
  type: 'LAND_USE_PLAN',
  label: '토지이용계획확인서'
}];
const EXPLANATION_SOURCE_DOCUMENT_FIELD_KEYS_BY_TYPE = {
  BUILDING_REGISTER: new Set(['approvalDate', 'buildingCoverageRatio', 'buildingHeightM', 'buildingName', 'commonArea', 'contractArea', 'elevatorAvailability', 'elevatorTotalCount', 'exclusiveArea', 'familyCount', 'floorAreaRatio', 'floorUnit', 'groundFloorCount', 'householdCount', 'mainUse', 'parkingIndoorMechanicalCount', 'parkingIndoorSelfCount', 'parkingOutdoorMechanicalCount', 'parkingOutdoorSelfCount', 'parkingTotalCount', 'structure', 'undergroundFloorCount', 'violationBuilding']),
  LAND_REGISTER: new Set(['landArea', 'landCategory', 'landRightClosedStatus', 'siteRightArea', 'siteRightRatio']),
  LAND_USE_PLAN: new Set(['buildingCoverageLimit', 'cityCountyPlanFacility', 'floorAreaRatioLimit', 'landTransactionPermitZone', 'landUsePlanDistrict', 'landUsePlanRegion', 'landUsePlanRestriction', 'landUsePlanZone', 'overheatedSpeculationDistrict', 'speculationArea']),
  CADASTRAL_MAP: new Set(['cadastralMap', 'cadastralMapScale', 'parcelBoundaryStatus'])
};
function explanationSourceDocumentTypeSelectedSet(item) {
  return new Set(String(item?.selectedOption ?? '').split(/[|,\s]+/u).map(value => value.trim().toUpperCase()).filter(Boolean));
}
function explanationSourceDocumentTypeSelectedText(types) {
  return EXPLANATION_SOURCE_DOCUMENT_TYPES.map(item => item.type).filter(type => types.has(type)).join('|');
}
function explanationSourceDocumentTypeMatchesText(documentType, value) {
  const text = String(value ?? '').normalize('NFKC');
  if (!text.trim()) return false;
  if (documentType === 'REGISTRY_CERTIFICATE') return /등기|REGISTRY|IROS/iu.test(text);
  if (documentType === 'LAND_REGISTER') return /토지\s*대장|토지특성|토지임야|LAND_REGISTER|LAND\s*REGISTER/iu.test(text);
  if (documentType === 'BUILDING_REGISTER') return /건축물\s*대장|전유부|전유공용|BUILDING_REGISTER|BUILDING\s*REGISTER/iu.test(text);
  if (documentType === 'CADASTRAL_MAP') return /지적도|CADASTRAL/iu.test(text);
  if (documentType === 'LAND_USE_PLAN') return /토지이용계획|용도지역|용도지구|용도구역|LAND_USE_PLAN|VWorld/iu.test(text);
  return false;
}
function explanationSourceDocumentTypeMatchesFieldKey(documentType, key) {
  return Boolean(EXPLANATION_SOURCE_DOCUMENT_FIELD_KEYS_BY_TYPE[documentType]?.has(key));
}
function explanationAutomationApiSourceHasUsableResult(source) {
  const status = readText(source, 'status', '').trim().toUpperCase();
  const rowCount = Number(readText(source, 'rowCount', '0')) || 0;
  const totalCount = Number(readText(source, 'totalCount', '0')) || 0;
  if (['READY', 'COMPLETE', 'COMPLETED', 'OK', 'SOURCE_READY', 'SOURCE_READY_WITH_REVIEW'].includes(status)) return true;
  if (rowCount > 0 || totalCount > 0) return true;
  return asRecordArray(source.filledFields).some(field => documentAutomationFieldHasUsableValue(field));
}
function explanationSourceDocumentTypeUsedByAutomationSource(contract, documentType) {
  const metadata = asRecord(contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  return asRecordArray(automationFieldMap.apiSources).some(source => {
    if (!explanationAutomationApiSourceHasUsableResult(source)) return false;
    const filledFields = asRecordArray(source.filledFields);
    if (filledFields.some(field => {
      const value = readExplanationAutoText(field, 'value', 'displayValue', 'text');
      return Boolean(value && explanationSourceDocumentTypeMatchesFieldKey(documentType, readText(field, 'key', '').trim()));
    })) {
      return true;
    }
    return explanationSourceDocumentTypeMatchesText(documentType, [readText(source, 'key', ''), readText(source, 'label', ''), readText(source, 'provider', ''), readText(source, 'documentType', ''), readText(source, 'documentTypeLabel', ''), readText(source, 'endpoint', '')].join(' '));
  });
}
function explanationSourceDocumentTypeUsedByAutomationDisplayCompletion(contract, documentType) {
  if (documentType !== 'LAND_USE_PLAN') return false;
  const metadata = asRecord(contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const summary = asRecord(automationFieldMap.summary);
  const display = asRecord(automationFieldMap.automationApiDisplay);
  const progress = asRecord(display.progress);
  const apiSourcesTotal = Number(summary.apiSourcesTotal ?? 0) || 0;
  const apiSourcesSettled = Math.max(Number(summary.apiSourcesReadyCount ?? 0) || 0, Number(summary.apiSourcesSettledCount ?? 0) || 0);
  const displayTotal = Number(progress.totalCount ?? 0) || 0;
  const displaySettled = Math.max(Number(progress.readyCount ?? 0) || 0, Number(progress.settledCount ?? 0) || 0);
  const fields = explanationAutomationFields(contract);
  const hasLandRegisterField = fields.some(field => explanationSourceDocumentTypeMatchesFieldKey('LAND_REGISTER', readText(field, 'key', '').trim()));
  const hasBuildingRegisterField = fields.some(field => explanationSourceDocumentTypeMatchesFieldKey('BUILDING_REGISTER', readText(field, 'key', '').trim()));
  return hasLandRegisterField && hasBuildingRegisterField && (apiSourcesTotal >= 4 && apiSourcesSettled >= apiSourcesTotal || displayTotal >= 12 && displaySettled >= displayTotal);
}
function explanationSourceDocumentTypeUsedByAutomation(contract, documentType) {
  const fieldUsed = explanationAutomationFields(contract).some(field => {
    const value = readExplanationAutoText(field, 'value', 'displayValue', 'text');
    if (!value) return false;
    if (explanationSourceDocumentTypeMatchesFieldKey(documentType, readText(field, 'key', '').trim())) return true;
    return explanationSourceDocumentTypeMatchesText(documentType, [readText(field, 'apiSource', ''), readText(field, 'sourceLabel', ''), readText(field, 'sourceDetail', ''), readText(field, 'documentType', ''), readText(field, 'documentTypeLabel', ''), readText(field, 'provider', '')].join(' '));
  });
  return fieldUsed || explanationSourceDocumentTypeUsedByAutomationSource(contract, documentType) || explanationSourceDocumentTypeUsedByAutomationDisplayCompletion(contract, documentType);
}
function explanationSourceDocumentTypeIsActive(field, item, officialDocuments, contract) {
  const documentType = explanationSourceDocumentType(field);
  if (!documentType) return false;
  if (documentType === 'REGISTRY_CERTIFICATE') {
    return hasOfficialDocumentType(officialDocuments, documentType) || explanationSourceDocumentTypeSelectedSet(item).has(documentType);
  }
  return hasOfficialDocumentType(officialDocuments, documentType) || explanationSourceDocumentTypeUsedByAutomation(contract, documentType) || explanationSourceDocumentTypeSelectedSet(item).has(documentType);
}
const LOCATION_MODE_CHECK_KIND_BY_KEY = {
  'location-bus-mode': 'bus',
  'location-subway-mode': 'subway',
  'location-elementary-mode': 'elementary',
  'location-middle-mode': 'middle',
  'location-high-mode': 'high'
};
const LOCATION_MODE_FIELD_KEYS_BY_CHECK_KEY = {
  'location-bus-mode': {
    name: 'busStopName',
    minutes: 'busMinutes',
    access: 'busAccess'
  },
  'location-subway-mode': {
    name: 'subwayStationName',
    minutes: 'subwayMinutes',
    access: 'subwayAccess'
  },
  'location-elementary-mode': {
    name: 'elementarySchoolName',
    minutes: 'elementaryMinutes',
    access: 'elementaryAccess'
  },
  'location-middle-mode': {
    name: 'middleSchoolName',
    minutes: 'middleMinutes',
    access: 'middleAccess'
  },
  'location-high-mode': {
    name: 'highSchoolName',
    minutes: 'highMinutes',
    access: 'highAccess'
  }
};
function normalizeLocationAccessModeValue(...values) {
  const text = values.map(value => String(value ?? '').normalize('NFKC').trim()).filter(Boolean).join(' ');
  const normalizedMode = documentAutomationAccessModeFromText(text);
  if (normalizedMode) return normalizedMode;
  if (/차량|자동차|\bcar\b/iu.test(text)) return 'car';
  if (/도보|보행|\bwalk\b/iu.test(text)) return 'walk';
  if (/해당\s*없음|서비스권\s*외|지하철\s*없음|\bnone\b|\bnot[_ -]?applicable\b/iu.test(text)) return 'none';
  return '';
}
const ROAD_PAVEMENT_FIELD_KEYS = ['roadPavement', 'roadPaved', 'pavement', 'pavementStatus', 'roadSurface', 'roadSurfaceType', '도로포장여부', '포장여부'];
function normalizeRoadPavementOption(...values) {
  const text = values.map(value => String(value ?? '').normalize('NFKC').trim()).filter(Boolean).join(' ');
  if (!text) return '';
  if (/비\s*포장|unpaved|unsealed|gravel|dirt/iu.test(text)) return 'unpaved';
  if (/포장|paved|asphalt|아스팔트|콘크리트|concrete/iu.test(text)) return 'paved';
  return '';
}
function officialDocumentMatchesType(document, documentType) {
  const normalizedType = readText(document, 'documentType', readText(document, 'document_type', '')).trim().toUpperCase();
  return normalizedType === documentType && documentIsReadable(document);
}
function hasOfficialDocumentType(officialDocuments, documentType) {
  return Boolean(officialDocuments?.some(document => officialDocumentMatchesType(document, documentType)));
}
function explanationSourceDocumentType(field) {
  return EXPLANATION_SOURCE_DOCUMENT_TYPE_BY_OVERLAY_ID[field.id] ?? '';
}
function explanationViolationStatusOptionFromText(value) {
  const text = String(value ?? '').normalize('NFKC').trim();
  if (!text) return '';
  if (/미\s*완료|미\s*시정|미\s*조치|진행\s*중|조치\s*중/iu.test(text)) return 'violation';
  if (/해당\s*없음|없음|적법|해제|말소|취소|철거|시정\s*완료|정비\s*완료|조치\s*완료|처리\s*완료|종결|해소|제외|정상|^(N|NO|FALSE|0)$/iu.test(text)) {
    return 'legal';
  }
  if (/위반|불법|무허가|시정명령|이행강제|^(Y|YES|TRUE|1)$/iu.test(text)) return 'violation';
  return '';
}
function explanationViolationText(contract) {
  return explanationAutomationFieldValue(contract, 'violationBuilding', '위반건축물 여부');
}
function explanationViolationStatusOption(contract) {
  return explanationViolationStatusOptionFromText(explanationViolationText(contract));
}
function locationAutomationSelectedForKind(contract, kind) {
  const metadata = asRecord(contract?.metadata);
  const cache = asRecord(metadata.locationAutomation);
  const selected = asRecord(asRecord(asRecord(cache.results)[kind]).selected);
  if (Object.keys(selected).length) return selected;
  return [...asRecordArray(cache.items), ...asRecordArray(cache.rows)].find(item => readText(item, 'kind', '').trim() === kind) ?? {};
}
function locationAutomationSelectedIsNotApplicable(selected) {
  return Boolean(selected.notApplicable) || normalizeLocationAccessModeValue(readText(selected, 'accessMode', ''), readText(selected, 'sourceLabel', ''), readText(selected, 'sourceDetail', '')) === 'none';
}
function explanationLocationAutoOptionForCheck(contract, key) {
  const kind = LOCATION_MODE_CHECK_KIND_BY_KEY[key];
  if (!kind) return '';
  const selected = locationAutomationSelectedForKind(contract, kind);
  if (locationAutomationSelectedIsNotApplicable(selected)) return 'none';
  const accessMode = normalizeLocationAccessModeValue(readText(selected, 'accessMode', ''), readText(selected, 'sourceLabel', ''), readText(selected, 'sourceDetail', ''));
  const name = readText(selected, 'name', '').trim();
  const minutes = readText(selected, 'accessMinutes', '').trim();
  if (accessMode && name && minutes) return accessMode;
  const fieldKeys = LOCATION_MODE_FIELD_KEYS_BY_CHECK_KEY[key];
  if (!fieldKeys) return '';
  const fields = explanationAutomationFields(contract);
  const fieldByKey = new Map(fields.map(field => [readText(field, 'key', '').trim(), field]));
  const nameField = fieldByKey.get(fieldKeys.name) ?? {};
  const minutesField = fieldByKey.get(fieldKeys.minutes) ?? {};
  const accessField = fieldByKey.get(fieldKeys.access) ?? {};
  const inferredMode = normalizeLocationAccessModeValue(readExplanationAutoText(accessField, 'value', 'displayValue', 'text'), readText(accessField, 'sourceLabel', ''), readText(accessField, 'sourceDetail', ''), readText(minutesField, 'sourceLabel', ''), readText(minutesField, 'sourceDetail', ''), readText(nameField, 'sourceLabel', ''), readText(nameField, 'sourceDetail', ''));
  const hasName = readExplanationAutoText(nameField, 'value', 'displayValue', 'text');
  const hasMinutes = readExplanationAutoText(minutesField, 'value', 'displayValue', 'text');
  return inferredMode && hasName && hasMinutes ? inferredMode : '';
}
function explanationRoadAutoOptionForCheck(contract) {
  const metadata = asRecord(contract?.metadata);
  const roadAutomation = asRecord(metadata.roadAutomation ?? metadata.roadRelation ?? metadata.roadInfo ?? metadata.kakaoRoad);
  const fields = explanationAutomationFields(contract);
  const fieldByKey = new Map(fields.map(field => [readText(field, 'key', '').trim(), field]));
  const explicitOption = normalizeRoadPavementOption(...ROAD_PAVEMENT_FIELD_KEYS.flatMap(key => [roadAutomation[key], readExplanationAutoText(fieldByKey.get(key) ?? {}, 'value', 'displayValue', 'text')]));
  return explicitOption || 'paved';
}
function explanationAccessibilityAutoOptionForCheck(contract) {
  const busOption = explanationLocationAutoOptionForCheck(contract, 'location-bus-mode');
  const subwayOption = explanationLocationAutoOptionForCheck(contract, 'location-subway-mode');
  return busOption === 'walk' || subwayOption === 'walk' ? 'easy' : '';
}
const EXPLANATION_PARKING_AUTO_VALUE_KEYS = ['parkingIndoorSelfCount', 'parkingOutdoorSelfCount', 'parkingIndoorMechanicalCount', 'parkingOutdoorMechanicalCount', 'parkingTotalCount', 'parkingTypeSummary', 'parkingLocationSummary', 'parkingOtherDetail', 'parkingTotalArea', 'parkingOwnArea', 'parkingAreaShare', 'parkingAreaShareConversion', 'parkingAreaShareBasis'];
const EXPLANATION_PARKING_AUTO_COUNT_KEYS = new Set(['parkingIndoorSelfCount', 'parkingOutdoorSelfCount', 'parkingIndoorMechanicalCount', 'parkingOutdoorMechanicalCount', 'parkingTotalCount']);
function hasMeaningfulParkingAutomationValue(key, value) {
  const text = cleanExplanationAutoText(value);
  if (!text || text === '-') return false;
  if (/(?:대기|확인\s*필요|직접확인|미확인)/u.test(text)) return false;
  if (!EXPLANATION_PARKING_AUTO_COUNT_KEYS.has(key)) return true;
  const parsed = firstNumericValue(text);
  return parsed !== null && parsed > 0;
}
function explanationParkingAutoOptionForCheck(contract) {
  const metadata = asRecord(contract?.metadata);
  const hasParkingValue = EXPLANATION_PARKING_AUTO_VALUE_KEYS.some(key => hasMeaningfulParkingAutomationValue(key, explanationAutomationFieldValue(contract, key)) || hasMeaningfulParkingAutomationValue(key, readExplanationAutoText(metadata, key)));
  return hasParkingValue ? 'other' : '';
}
function explanationAutoOptionForCheck(contract, key) {
  if (key === 'legal-restrictions') return explanationViolationStatusOption(contract);
  if (key === 'location-road') return explanationRoadAutoOptionForCheck(contract);
  if (key === 'location-accessibility') return explanationAccessibilityAutoOptionForCheck(contract);
  if (key === 'location-parking') return explanationParkingAutoOptionForCheck(contract);
  return explanationLocationAutoOptionForCheck(contract, key);
}
function explanationDateParts(value) {
  const source = String(value ?? '').trim();
  const match = source.match(/(\d{4})\D*(\d{1,2})?\D*(\d{1,2})?/u);
  return {
    year: match?.[1] ?? '',
    month: match?.[2] ? String(Number(match[2])) : '',
    day: match?.[3] ? String(Number(match[3])) : ''
  };
}
function explanationYearText(value) {
  const source = String(value ?? '').trim();
  return source.match(/\d{4}/u)?.[0] ?? source;
}
function explanationApprovalDateCandidateText(value) {
  const source = String(value ?? '').trim();
  const match = source.match(/(\d{4})\D*(\d{1,2})?\D*(\d{1,2})?/u);
  if (!match?.[1]) return source ? `사용승인일\n${source}` : '';
  const year = match[1];
  const month = match[2] ? String(Number(match[2])).padStart(2, '0') : '';
  const day = match[3] ? String(Number(match[3])).padStart(2, '0') : '';
  const dateText = month && day ? `${year}.${month}.${day}` : month ? `${year}.${month}` : year;
  return `사용승인일\n${dateText}`;
}
function explanationCompletionYearOrApprovalDateText(completionSource, approvalSource) {
  const completionYear = explanationYearText(completionSource);
  if (/^(19|20)\d{2}$/u.test(completionYear)) return completionYear;
  return explanationApprovalDateCandidateText(approvalSource);
}
function explanationApprovalYear(contract) {
  const source = explanationAutomationFieldValue(contract, 'approvalDate', 'useApprovalDate', '사용승인일', '준공년도');
  const year = Number(explanationYearText(source));
  return Number.isFinite(year) && year > 1900 ? year : 0;
}
function explanationIsNewerThanYears(contract, years) {
  const year = explanationApprovalYear(contract);
  if (!year) return false;
  return new Date().getFullYear() - year <= years;
}
function buildExplanationFormAutoTextDefaults({
  form,
  contract,
  realtorProfile
}) {
  const metadata = asRecord(contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const automationSummary = asRecord(automationFieldMap.summary);
  const addressLookup = asRecord(metadata.addressLookup);
  const terms = asRecord(contract?.contractTerms);
  const management = asRecord(metadata.managementFee ?? metadata.management ?? terms.managementFee ?? terms.management);
  const facility = asRecord(metadata.facilityCondition ?? metadata.facilityConditions ?? metadata.explanationFacility);
  const lessor = explanationPartyRecord(contract, 'lessorOrSeller');
  const lessee = explanationPartyRecord(contract, 'lesseeOrBuyer');
  const realtor = asRecord(metadata.realtorInfo ?? metadata.realtor ?? metadata.broker);
  const coBroker = asRecord(metadata.coBrokerInfo ?? metadata.coBroker ?? metadata.jointBroker ?? metadata.coRealtor);
  const realtorRepresentativeName = realtorRepresentativeAutoText(realtor, realtorProfile);
  const realtorManagerName = realtorManagerAutoText(realtor, realtorProfile, {
    fallbackToRepresentative: true
  });
  const realtorAffiliatedBrokerName = realtorManagerAutoText(realtor, realtorProfile);
  const realtorOfficeName = realtorOfficeAutoText(realtor, realtorProfile);
  const automationText = (...keysOrLabels) => explanationAutomationFieldValue(contract, ...keysOrLabels);
  const contractAddress = contract ? getContractAddress(contract) : '';
  const isMarketTargetExplanation = Boolean(readExplanationAutoText(metadata, 'marketTargetListingId'));
  const marketTargetAddressBase = firstExplanationAutoText(readExplanationAutoText(automationSummary, 'addressBase'), readExplanationAutoText(metadata, 'addressBase'));
  const contractDateParts = explanationDateParts(firstExplanationAutoText(form?.contractDate, readExplanationAutoText(terms, 'contractDate'), contract?.createdAt));
  const transactionAmountFallback = contractActualTransactionAmountDisplay(form, terms);
  const objectAddressText = firstExplanationAutoText(form?.address, marketTargetAddressBase, isMarketTargetExplanation ? '' : automationText('location', 'addressBase'), isMarketTargetExplanation ? '' : contractAddress);
  const objectBuildingText = firstExplanationAutoText(automationText('buildingName'), readExplanationAutoText(automationSummary, 'buildingName', 'building_name', 'complexName'), readExplanationAutoText(addressLookup, 'buildingName', 'bldNm', 'buldNm'), readExplanationAutoText(metadata, 'buildingName'));
  const objectUnitText = firstExplanationAutoText(automationText('floorUnit'), readExplanationAutoText(automationSummary, 'floorUnit', 'floor_unit', 'unitLabel'), readExplanationAutoText(addressLookup, 'floorUnit', 'buildingUnit', 'unitText', 'dongHo', 'ho'), readExplanationAutoText(metadata, 'floorUnit', 'buildingUnit', 'dongHo', 'ho'));
  const violationBuildingText = automationText('violationBuilding');
  const violationBuildingStatusOption = explanationViolationStatusOptionFromText(violationBuildingText);
  const landRightReviewText = automationText('registryReviewTaskSummary');
  const registryLandOtherRightsText = /대지권|별도등기|토지/u.test(landRightReviewText) ? landRightReviewText : '';
  const siteRightAreaAutoText = firstExplanationAreaAutoText(automationText('siteRightArea'), readExplanationAutoText(automationSummary, 'siteRightArea', 'landRightArea', 'landRightAreaM2', 'land_right_area_m2'), readExplanationAutoText(metadata, 'siteRightArea', 'landRightArea', 'landRightAreaM2', 'land_right_area_m2'));
  const siteRightRatioAutoText = firstExplanationAutoText(automationText('siteRightRatio'), readExplanationAutoText(automationSummary, 'siteRightRatio', 'landRightRatio', 'land_right_ratio'), readExplanationAutoText(metadata, 'siteRightRatio', 'landRightRatio', 'land_right_ratio'));
  const completionYearSource = firstExplanationAutoText(automationText('completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'), readExplanationAutoText(automationSummary, 'completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'), readExplanationAutoText(metadata, 'completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'));
  const approvalDateSource = firstExplanationAutoText(automationText('approvalDate', 'useApprovalDate', '사용승인일'), readExplanationAutoText(automationSummary, 'approvalDate', 'useApprovalDate', 'useAprDay', 'useAplDate', '사용승인일'), readExplanationAutoText(metadata, 'approvalDate', 'useApprovalDate', 'useAprDay', 'useAplDate', '사용승인일'));
  const defaults = {
    ef_p1_location: formatExplanationObjectAddressLines(objectAddressText, objectBuildingText, objectUnitText),
    ef_p1_land_area: firstExplanationAreaAutoText(automationText('landArea'), readExplanationAutoText(automationSummary, 'landArea', 'landAreaM2', 'land_area_m2'), readExplanationAutoText(metadata, 'landArea', 'landAreaM2', 'land_area_m2')),
    ef_p1_land_category: firstExplanationAutoText(automationText('landCategory'), readExplanationAutoText(automationSummary, 'landCategory', 'land_category'), readExplanationAutoText(metadata, 'landCategory', 'land_category')),
    ef_p1_land_use_status: firstExplanationAutoText(readExplanationAutoText(metadata, 'actualUse', 'landUseStatus'), readExplanationAutoText(automationSummary, 'actualUse', 'landUseStatus', 'mainUse', 'buildingUseRaw'), automationText('mainUse')),
    ef_p1_exclusive_area: firstExplanationAreaAutoText(automationText('exclusiveArea'), readExplanationAutoText(automationSummary, 'exclusiveArea', 'exclusiveAreaSquareMeters', 'exclusive_area_m2'), readExplanationAutoText(metadata, 'exclusiveArea', 'exclusiveAreaSquareMeters', 'exclusiveAreaLabel', 'exclusive_area_m2')),
    ef_p1_site_right_area: firstExplanationAutoText(siteRightAreaAutoText && siteRightRatioAutoText ? formatSiteRightDisplay(siteRightAreaAutoText, siteRightRatioAutoText) : '', siteRightAreaAutoText, automationText('registryLandRightSummary')),
    ef_p1_approval_year: explanationCompletionYearOrApprovalDateText(completionYearSource, approvalDateSource),
    ef_p1_main_use_building: firstExplanationAutoText(automationText('mainUse'), readExplanationAutoText(automationSummary, 'mainUse', 'buildingUseRaw', 'building_use_raw'), readExplanationAutoText(metadata, 'mainUse', 'buildingUseRaw', 'building_use_raw')),
    ef_p1_main_use_actual: firstExplanationAutoText(readExplanationAutoText(metadata, 'actualUse'), readExplanationAutoText(automationSummary, 'actualUse', 'mainUse', 'buildingUseRaw'), automationText('mainUse')),
    ef_p1_structure: firstExplanationAutoText(automationText('structure', '구조'), readExplanationAutoText(automationSummary, 'structure', 'structureName', 'strctCdNm', 'strctNm'), readExplanationAutoText(metadata, 'structure', 'structureName', 'strctCdNm', 'strctNm')),
    ef_p1_direction_basis_left_value: firstExplanationAutoText(automationText('directionBasis'), readExplanationAutoText(metadata, 'directionBasis')),
    ef_p1_seismic_design: firstExplanationAutoText(automationText('seismicDesign'), readExplanationAutoText(metadata, 'seismicDesign')),
    ef_p1_violation_content: violationBuildingStatusOption === 'violation' ? violationBuildingText : '',
    ef_p1_registry_owner: firstExplanationAutoText(siteRightAreaAutoText, normalizePlainExplanationSquareMeterText(automationText('registryLandRightSummary')), normalizePlainExplanationSquareMeterText(automationText('siteRightArea'))),
    ef_p1_registry_other_rights: registryLandOtherRightsText,
    ef_p1_registry_land_right: automationText('registryGapguSummary'),
    ef_p1_registry_restriction: firstExplanationAutoText(automationText('registryEulguSummary'), automationText('registryRiskSummary'), automationText('registryReviewTaskSummary'), automationText('ownerMortgage')),
    ef_p1_land_use_region: sanitizeLandUsePlanDesignationText(automationText('landUsePlanRegion')),
    ef_p1_land_use_district: sanitizeLandUsePlanDesignationText(automationText('landUsePlanDistrict')),
    ef_p1_building_coverage_limit: firstExplanationAutoText(automationText('buildingCoverageLimit'), readExplanationAutoText(metadata, 'buildingCoverageLimit')),
    ef_p1_floor_area_ratio_limit: firstExplanationAutoText(automationText('floorAreaRatioLimit'), readExplanationAutoText(metadata, 'floorAreaRatioLimit')),
    ef_p1_land_use_zone: sanitizeLandUsePlanDesignationText(automationText('landUsePlanZone')),
    ef_p1_city_county_plan_facility: firstExplanationAutoText(automationText('cityCountyPlanFacility'), readExplanationAutoText(metadata, 'cityCountyPlanFacility')),
    ef_p1_land_use_extra_restriction: automationText('landUsePlanRestriction'),
    ef_p2_small_tenant_amount_limit: firstExplanationAutoText(readExplanationAutoText(metadata, 'smallTenantAmountLimit', 'leaseSmallTenantAmountLimit')),
    ef_p2_priority_repayment_amount: firstExplanationAutoText(readExplanationAutoText(metadata, 'priorityRepaymentAmount', 'leasePriorityRepaymentAmount')),
    ef_p2_road_width_a: firstExplanationAutoText(automationText('roadWidthA'), readExplanationAutoText(metadata, 'roadWidthA')),
    ef_p2_road_width_b: firstExplanationAutoText(automationText('roadWidthB'), readExplanationAutoText(metadata, 'roadWidthB')),
    ef_p2_bus_stop_name: firstExplanationAutoText(automationText('busStopName'), readExplanationAutoText(metadata, 'busStopName')),
    ef_p2_bus_minutes: firstExplanationAutoText(automationText('busMinutes'), readExplanationAutoText(metadata, 'busMinutes')),
    ef_p2_subway_station_name: firstExplanationAutoText(automationText('subwayStationName'), readExplanationAutoText(metadata, 'subwayStationName')),
    ef_p2_subway_minutes: firstExplanationAutoText(automationText('subwayMinutes'), readExplanationAutoText(metadata, 'subwayMinutes')),
    ef_p2_parking_other_detail: firstExplanationAutoText(automationText('parkingOtherDetail', 'parkingTotalCount', 'totalParkingLabel', '주차', '총 주차대수'), automationText('parkingTypeSummary'), automationText('parkingLocationSummary'), readExplanationAutoText(metadata, 'parkingOtherDetail')),
    ef_p2_elementary_school_name: firstExplanationAutoText(automationText('elementarySchoolName'), readExplanationAutoText(metadata, 'elementarySchoolName')),
    ef_p2_elementary_minutes: firstExplanationAutoText(automationText('elementaryMinutes'), readExplanationAutoText(metadata, 'elementaryMinutes')),
    ef_p2_middle_school_name: firstExplanationAutoText(automationText('middleSchoolName'), readExplanationAutoText(metadata, 'middleSchoolName')),
    ef_p2_middle_minutes: firstExplanationAutoText(automationText('middleMinutes'), readExplanationAutoText(metadata, 'middleMinutes')),
    ef_p2_high_school_name: firstExplanationAutoText(automationText('highSchoolName'), readExplanationAutoText(metadata, 'highSchoolName')),
    ef_p2_high_minutes: firstExplanationAutoText(automationText('highMinutes'), readExplanationAutoText(metadata, 'highMinutes')),
    ef_p2_lease_confirm_lessor_role: firstExplanationAutoText(form?.lessorOrSellerName, lessor.name),
    ef_p2_lease_confirm_lessee_role: firstExplanationAutoText(form?.lesseeOrBuyerName, lessee.name),
    ef_p2_lease_confirm_realtor_role_1: realtorManagerName,
    ef_p2_lease_confirm_realtor_role_2: firstExplanationAutoText(form?.coBrokerOfficeName, readExplanationAutoText(coBroker, 'officeName', 'agencyName'), form?.coBrokerManagerName, readExplanationAutoText(coBroker, 'managerName', 'licensedBrokerName', 'affiliatedBrokerName'), form?.coBrokerRepresentativeName, readExplanationAutoText(coBroker, 'representativeName', 'name', 'realtorName')),
    ef_p2_disliked_facility_detail: firstExplanationAutoText(automationText('dislikedFacilityDetail'), readExplanationAutoText(metadata, 'dislikedFacilityDetail')),
    ef_p2_transaction_amount: transactionAmountFallback,
    ef_p2_public_land_price: firstExplanationAutoText(automationText('publicLandPrice'), readExplanationAutoText(metadata, 'publicLandPrice')),
    ef_p2_building_price: firstExplanationAutoText(automationText('buildingPrice'), readExplanationAutoText(metadata, 'buildingPrice')),
    ef_p2_acquisition_tax_rate: automationText('acquisitionTaxRate'),
    ef_p2_rural_special_tax_rate: automationText('ruralSpecialTaxRate'),
    ef_p2_local_education_tax_rate: automationText('localEducationTaxRate'),
    ef_p2_management_fee_amount: firstExplanationAutoText(automationText('managementFeeAmount', 'maintenanceFeeAmount', '관리비'), readExplanationAutoText(management, 'amount', 'managementFeeAmount', 'feeAmount'), readExplanationAutoText(terms, 'managementFeeAmount', 'maintenanceFeeAmount', 'managementFee', 'maintenanceFee')),
    ef_p2_management_fee_other_item_detail: readExplanationAutoText(management, 'otherItemDetail', 'managementFeeOtherItemDetail', 'includedOtherItems'),
    ef_p2_management_charge_other_detail: readExplanationAutoText(management, 'chargeOtherDetail', 'managementChargeOtherDetail', 'chargeMethodOtherDetail') || (managementAutomationOptionForCheck(contract, 'management-charge-method') === 'other' ? automationText('apartmentChargeMethod') : ''),
    ef_p3_water_damage_location: readExplanationAutoText(facility, 'waterDamageLocation'),
    ef_p3_water_capacity_location: readExplanationAutoText(facility, 'waterCapacityLocation'),
    ef_p3_electric_repair_part: readExplanationAutoText(facility, 'electricRepairPart'),
    ef_p3_gas_other_method: readExplanationAutoText(facility, 'gasOtherMethod'),
    ef_p3_fire_detector_quantity: readExplanationAutoText(facility, 'fireDetectorQuantity'),
    ef_p3_heating_repair_detail: readExplanationAutoText(facility, 'heatingRepairDetail'),
    ef_p3_heating_service_life: readExplanationAutoText(facility, 'heatingServiceLife'),
    ef_p3_fuel_other_detail: readExplanationAutoText(facility, 'fuelOtherDetail'),
    ef_p3_drain_repair_location: readExplanationAutoText(facility, 'drainRepairLocation'),
    ef_p3_wall_crack_location: readExplanationAutoText(facility, 'wallCrackLocation'),
    ef_p3_wall_leak_location: readExplanationAutoText(facility, 'wallLeakLocation'),
    ef_p3_floor_repair_location: readExplanationAutoText(facility, 'floorRepairLocation'),
    ef_p3_light_insufficient_reason: readExplanationAutoText(facility, 'lightInsufficientReason'),
    ef_p4_brokerage_fee_max: firstRoundedBrokerageFeeText(automationText('brokerageFeeMax')),
    ef_p4_expense_fee: readExplanationAutoText(terms, 'expenseFee', 'actualExpenseFee'),
    ef_p4_total_fee: firstExplanationAutoText(automationText('totalFee'), readExplanationAutoText(terms, 'totalFee', 'brokerageTotalFee')),
    ef_p4_brokerage_formula: automationText('brokerageFeeBasis'),
    ef_p4_expense_formula: readExplanationAutoText(terms, 'expenseFormula', 'actualExpenseFormula'),
    ef_p4_payment_timing: firstExplanationAutoText(readExplanationAutoText(terms, 'brokeragePaymentTiming', 'feePaymentTiming'), readExplanationAutoText(metadata, 'brokeragePaymentTiming', 'feePaymentTiming')),
    ef_p4_date_year: contractDateParts.year,
    ef_p4_date_month: contractDateParts.month,
    ef_p4_date_day: contractDateParts.day,
    ef_p4_lessor_address: firstExplanationAutoText(form?.lessorOrSellerAddress, lessor.address),
    ef_p4_lessor_name: firstExplanationAutoText(form?.lessorOrSellerName, lessor.name),
    ef_p4_lessor_rrn: firstExplanationAutoText(form?.lessorOrSellerResidentNumber, lessor.residentRegistrationNo, lessor.residentNumber, lessor.rrn, lessor.registrationNo),
    ef_p4_lessor_phone: firstExplanationAutoText(form?.lessorOrSellerPhone, lessor.phone, lessor.contact, lessor.mobilePhone),
    ef_p4_lessee_address: firstExplanationAutoText(form?.lesseeOrBuyerAddress, lessee.address),
    ef_p4_lessee_name: firstExplanationAutoText(form?.lesseeOrBuyerName, lessee.name),
    ef_p4_lessee_rrn: firstExplanationAutoText(form?.lesseeOrBuyerResidentNumber, lessee.residentRegistrationNo, lessee.residentNumber, lessee.rrn, lessee.registrationNo),
    ef_p4_lessee_phone: firstExplanationAutoText(form?.lesseeOrBuyerPhone, lessee.phone, lessee.contact, lessee.mobilePhone),
    ef_p4_realtor_registration_no: firstExplanationAutoIdentifierText(readExplanationAutoIdentifierText(realtor, 'registrationNo', 'registration_no', 'licenseNo', 'license_no', 'brokerRegistrationNo'), cleanRealtorRegistrationNoText(realtorProfile?.registrationNo)),
    ef_p4_realtor_representative: realtorRepresentativeName,
    ef_p4_realtor_office_name: realtorOfficeName,
    ef_p4_realtor_affiliated_broker: realtorAffiliatedBrokerName,
    ef_p4_realtor_office_address: firstExplanationAutoText(readExplanationAutoText(realtor, 'officeAddress', 'address'), realtorProfile?.officeAddress),
    ef_p4_realtor_phone: firstExplanationAutoText(readExplanationAutoText(realtor, 'phone', 'contactPhone', 'mobilePhone'), realtorProfile?.phone),
    ef_p4_co_realtor_registration_no: firstExplanationAutoIdentifierText(cleanRealtorRegistrationNoText(form?.coBrokerRegistrationNo), readExplanationAutoIdentifierText(coBroker, 'registrationNo', 'registration_no', 'licenseNo', 'license_no', 'brokerRegistrationNo')),
    ef_p4_co_realtor_representative: firstExplanationAutoText(form?.coBrokerRepresentativeName, readExplanationAutoText(coBroker, 'representativeName', 'name', 'realtorName')),
    ef_p4_co_realtor_office_name: firstExplanationAutoText(form?.coBrokerOfficeName, readExplanationAutoText(coBroker, 'officeName', 'agencyName')),
    ef_p4_co_realtor_affiliated_broker: firstExplanationAutoText(form?.coBrokerManagerName, readExplanationAutoText(coBroker, 'managerName', 'licensedBrokerName', 'affiliatedBrokerName')),
    ef_p4_co_realtor_office_address: firstExplanationAutoText(form?.coBrokerOfficeAddress, readExplanationAutoText(coBroker, 'officeAddress', 'address')),
    ef_p4_co_realtor_phone: firstExplanationAutoText(form?.coBrokerPhone, readExplanationAutoText(coBroker, 'phone', 'contactPhone', 'mobilePhone'))
  };
  const overlayByKey = new Map(EXPLANATION_FORM_TEXT_OVERLAYS.map(field => [field.key, field]));
  return Object.fromEntries(Object.entries(defaults).map(([key, value]) => {
    const field = overlayByKey.get(key);
    return [key, field ? formatExplanationAddressOverlayValue(field, value) : value];
  }).filter(([, value]) => value));
}
const EXPLANATION_FORM_AUTO_REFRESH_TEXT_KEYS = new Set(['ef_p1_location', 'ef_p1_land_area', 'ef_p1_land_category', 'ef_p1_land_use_status', 'ef_p1_exclusive_area', 'ef_p1_site_right_area', 'ef_p1_approval_year', 'ef_p1_main_use_building', 'ef_p1_main_use_actual', 'ef_p1_structure', 'ef_p1_direction_basis_left_value', 'ef_p1_seismic_design', 'ef_p1_registry_owner', 'ef_p1_registry_other_rights', 'ef_p1_registry_land_right', 'ef_p1_registry_restriction', 'ef_p1_land_use_region', 'ef_p1_land_use_district', 'ef_p1_building_coverage_limit', 'ef_p1_floor_area_ratio_limit', 'ef_p1_land_use_zone', 'ef_p1_city_county_plan_facility', 'ef_p1_land_use_extra_restriction', 'ef_p2_road_width_a', 'ef_p2_road_width_b', 'ef_p2_bus_stop_name', 'ef_p2_bus_minutes', 'ef_p2_subway_station_name', 'ef_p2_subway_minutes', 'ef_p2_parking_other_detail', 'ef_p2_elementary_school_name', 'ef_p2_elementary_minutes', 'ef_p2_middle_school_name', 'ef_p2_middle_minutes', 'ef_p2_high_school_name', 'ef_p2_high_minutes', 'ef_p2_public_land_price', 'ef_p2_building_price', 'ef_p2_acquisition_tax_rate', 'ef_p2_rural_special_tax_rate', 'ef_p2_local_education_tax_rate', 'ef_p2_management_fee_amount', 'ef_p2_management_fee_other_item_detail', 'ef_p2_management_charge_other_detail', 'ef_p4_brokerage_fee_max', 'ef_p4_total_fee', 'ef_p4_brokerage_formula']);
function isExplanationAutoTextPlaceholder(value) {
  const text = normalizeExplanationAutoCompareText(value, 80).replace(/\s+/gu, '');
  if (!text) return true;
  return /^(?:-|—|n\/a|null|undefined|없음|값없음|자동값없음|확인필요|직접확인|직접확인필요|미확인|조회대기|입력대기|등록대기|연결대기)$/iu.test(text);
}
function shouldRefreshExplanationAutoTextCustomValue(key, customText, autoText) {
  const normalizedAutoText = normalizeExplanationTextLayerCustomText(key, autoText);
  if (!normalizedAutoText.trim()) return false;
  const normalizedCustomText = normalizeExplanationTextLayerCustomText(key, customText);
  if (!normalizedCustomText.trim()) return false;
  return EXPLANATION_FORM_AUTO_REFRESH_TEXT_KEYS.has(key) && isExplanationAutoTextPlaceholder(normalizedCustomText);
}
function resolveExplanationFormOverlayTextValue(draft, autoTextDefaults, key, autoTextRepairs) {
  const hasCustomValue = Object.prototype.hasOwnProperty.call(draft.customTexts ?? {}, key);
  const customValue = draft.customTexts?.[key];
  let customText = typeof customValue === 'string' ? customValue : '';
  if (hasCustomValue) {
    const repair = autoTextRepairs?.[key];
    if (repair?.staleValues.some(staleValue => isSameExplanationAutoTextValue(customText, staleValue))) {
      customText = repair.value;
    } else if (shouldRefreshExplanationAutoTextCustomValue(key, customText, autoTextDefaults[key])) {
      customText = autoTextDefaults[key] ?? '';
    }
  }
  if (hasCustomValue) return normalizeExplanationTextLayerCustomText(key, customText);
  return autoTextDefaults[key] ?? customText;
}
function buildExplanationFormAutoTextRepairs(params) {
  const metadata = asRecord(params.contract?.metadata);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const automationSummary = asRecord(automationFieldMap.summary);
  const realtor = asRecord(metadata.realtorInfo ?? metadata.realtor ?? metadata.broker);
  const realtorProfile = params.realtorProfile;
  const oldOfficeName = realtorOfficeAutoText(realtor, realtorProfile);
  const representativeName = realtorRepresentativeAutoText(realtor, realtorProfile);
  const rawManagerName = firstExplanationAutoText(readExplanationAutoText(realtor, 'licensedBrokerName', 'affiliatedBrokerName', 'managerName', 'realtorName'), realtorProfile?.licensedBrokerName);
  const completionYearSource = firstExplanationAutoText(explanationAutomationFieldValue(params.contract, 'completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'), readExplanationAutoText(automationSummary, 'completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'), readExplanationAutoText(metadata, 'completionYear', 'completion_year', 'constructionYear', 'construction_year', '준공년도'));
  const approvalDateSource = firstExplanationAutoText(explanationAutomationFieldValue(params.contract, 'approvalDate', 'useApprovalDate', '사용승인일'), readExplanationAutoText(automationSummary, 'approvalDate', 'useApprovalDate', 'useAprDay', 'useAplDate', '사용승인일'), readExplanationAutoText(metadata, 'approvalDate', 'useApprovalDate', 'useAprDay', 'useAplDate', '사용승인일'));
  const approvalYearOnly = explanationYearText(approvalDateSource);
  const approvalYearRepairText = explanationCompletionYearOrApprovalDateText(completionYearSource, approvalDateSource);
  return {
    ef_p1_approval_year: {
      value: approvalYearRepairText,
      staleValues: approvalYearRepairText && approvalYearRepairText !== approvalYearOnly ? [approvalYearOnly] : []
    },
    ef_p2_lease_confirm_realtor_role_1: {
      value: realtorManagerAutoText(realtor, realtorProfile, {
        fallbackToRepresentative: true
      }),
      staleValues: [oldOfficeName]
    },
    ef_p4_realtor_affiliated_broker: {
      value: realtorManagerAutoText(realtor, realtorProfile),
      staleValues: [representativeName, rawManagerName].filter(Boolean)
    }
  };
}
function textLayerRichText(draft, key, fallback) {
  const value = draft.richTexts?.[key];
  if (typeof value === 'string') return value;
  return escapeTemplateRichText(textLayerCustomText(draft, key, fallback));
}
function updateTextLayerCustomText(draft, key, value) {
  const normalizedValue = sanitizeTemplateCustomText(key, value);
  return {
    ...draft,
    customTexts: {
      ...draft.customTexts,
      [key]: normalizedValue
    }
  };
}
function updateTextLayerRichText(draft, key, html, text) {
  const normalizedText = key === 'noticeText' ? stripSpecialTermsHeading(text) : text;
  const normalizedHtml = normalizedText === text ? html : escapeTemplateRichText(normalizedText);
  return {
    ...draft,
    ...(key === 'bodyText' ? {
      bodyText: normalizedText
    } : {}),
    ...(key === 'noticeText' ? {
      noticeText: normalizedText
    } : {}),
    customTexts: {
      ...draft.customTexts,
      [key]: normalizedText
    },
    richTexts: {
      ...draft.richTexts,
      [key]: normalizedHtml
    }
  };
}
function clampTemplateNumber(value, fallback, min, max) {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return fallback;
  return Math.min(max, Math.max(min, numberValue));
}
function sanitizeTemplateColor(value, fallback = '#000000') {
  const color = String(value ?? '').trim();
  return /^#[0-9a-fA-F]{6}$/u.test(color) ? color : fallback;
}
function sanitizeOptionalTemplateColor(value, fallback) {
  const color = String(value ?? '').trim();
  if (/^#[0-9a-fA-F]{6}$/u.test(color)) return color;
  return fallback && /^#[0-9a-fA-F]{6}$/u.test(fallback) ? fallback : undefined;
}
function normalizeTemplateFieldStyle(key, value, fallback) {
  const record = asRecord(value);
  const defaultStyle = fallback ?? DEFAULT_TEMPLATE_FIELD_STYLES[key] ?? {};
  return {
    widthPct: clampTemplateNumber(record.widthPct ?? record.width_pct, defaultStyle.widthPct ?? 100, 35, 100),
    letterSpacingPx: clampTemplateNumber(record.letterSpacingPx ?? record.letter_spacing_px, defaultStyle.letterSpacingPx ?? 0, -4, 4),
    fontSizePx: clampTemplateNumber(record.fontSizePx ?? record.font_size_px, defaultStyle.fontSizePx ?? 10, 7, 24),
    color: sanitizeTemplateColor(record.color, defaultStyle.color ?? '#000000'),
    backgroundColor: sanitizeOptionalTemplateColor(record.backgroundColor ?? record.background_color, defaultStyle.backgroundColor),
    bold: typeof record.bold === 'boolean' ? record.bold : Boolean(defaultStyle.bold),
    italic: typeof record.italic === 'boolean' ? record.italic : Boolean(defaultStyle.italic)
  };
}
function normalizeTemplateFieldStyles(value, fallback) {
  const record = asRecord(value);
  const source = {
    ...DEFAULT_TEMPLATE_FIELD_STYLES,
    ...(fallback ?? {})
  };
  return Object.entries(source).reduce((acc, [key, defaultStyle]) => {
    acc[key] = normalizeTemplateFieldStyle(key, record[key], defaultStyle);
    return acc;
  }, {});
}
function textLayerFieldStyle(draft, key) {
  return normalizeTemplateFieldStyle(key, draft.fieldStyles?.[key], DEFAULT_TEMPLATE_FIELD_STYLES[key]);
}
function updateTextLayerFieldStyle(draft, key, patch) {
  return {
    ...draft,
    fieldStyles: {
      ...draft.fieldStyles,
      [key]: normalizeTemplateFieldStyle(key, {
        ...textLayerFieldStyle(draft, key),
        ...patch
      })
    }
  };
}
function templateFieldInlineStyle(style, includeWidth = true) {
  const inlineStyle = {
    fontSize: `${style.fontSizePx ?? 10}px`,
    color: style.color ?? '#000000',
    letterSpacing: `${style.letterSpacingPx ?? 0}px`,
    fontWeight: style.bold ? 800 : undefined,
    fontStyle: style.italic ? 'italic' : undefined,
    backgroundColor: style.backgroundColor
  };
  if (includeWidth) {
    inlineStyle.width = `${style.widthPct ?? 100}%`;
    inlineStyle.maxWidth = '100%';
  }
  return inlineStyle;
}
function normalizeColumnWidths(value, fallback) {
  const minWidth = fallback.some(fallbackWidth => Number(fallbackWidth) < 3) ? 0.1 : 3;
  const source = Array.isArray(value) && value.length === fallback.length && !isLegacyPartyColumnWidths(value, fallback) ? value : fallback;
  const fixed = fallback.map((fallbackWidth, index) => clampTemplateNumber(source[index], fallbackWidth, minWidth, 80));
  const sum = fixed.reduce((total, width) => total + width, 0) || 100;
  return fixed.map(width => Number((width / sum * 100).toFixed(3)));
}
function isLegacyPartyColumnWidths(value, fallback) {
  if (fallback.length !== 16 || value.length !== 16) return false;
  const legacySets = [[3.5, 6.5, 5.5, 8.5, 8.5, 7, 8.5, 7, 8.5, 5.5, 3.5, 6.5, 9, 9, 8, 5.5], [3.2, 6.2, 6.5, 6.5, 6.5, 6.5, 4.8, 7, 7, 7, 4.8, 7.2, 7.2, 7.2, 7.2, 5.2], [3.2, 6, 5.8, 5.8, 5.8, 5.8, 3.2, 5.8, 5.8, 5.8, 3.2, 9.5, 9.5, 4.5, 12.3, 8.8], [3.167, 5.882, 4.977, 7.692, 7.692, 6.335, 7.692, 6.335, 7.692, 4.977, 3.167, 5.882, 8.145, 8.145, 7.24, 4.977], [3.226, 5.645, 5.242, 5.242, 5.242, 5.242, 3.024, 5.242, 5.242, 5.242, 3.024, 8.065, 8.065, 3.024, 17.137, 12.097], [10.315, 2.897, 8.088, 3.865, 8.793, 7.268, 8.088, 4.451, 2.897, 6.211, 2.897, 3.751, 10.081, 6.682, 8.322, 5.391], [10.68, 2.67, 8.375, 4.002, 9.105, 7.526, 8.375, 4.609, 2.67, 6.431, 0.119, 3.884, 10.438, 6.919, 8.617, 5.582]];
  return legacySets.some(legacy => legacy.every((legacyWidth, index) => Math.abs(Number(value[index]) - legacyWidth) < 0.02));
}
function normalizeTemplateBoundaryPositions(value) {
  const record = asRecord(value);
  return Object.entries(record).reduce((acc, [key, raw]) => {
    if (!key) return acc;
    const position = clampTemplateNumber(raw, Number.NaN, 2, 98);
    if (Number.isFinite(position)) acc[key] = Number(position.toFixed(3));
    return acc;
  }, {});
}
function normalizeTemplateTableLayout(key, value, fallback) {
  const record = asRecord(value);
  const defaultLayout = fallback ?? DEFAULT_TEMPLATE_TABLE_LAYOUTS[key];
  const defaultColumnWidths = defaultLayout.columnWidths ?? DEFAULT_TEMPLATE_TABLE_LAYOUTS[key].columnWidths;
  return {
    columnWidths: normalizeColumnWidths(record.columnWidths ?? record.column_widths, defaultColumnWidths),
    boundaryPositions: normalizeTemplateBoundaryPositions(record.boundaryPositions ?? record.boundary_positions)
  };
}
function normalizeTemplateTableLayouts(value, fallback) {
  const record = asRecord(value);
  return TEMPLATE_TABLE_OPTIONS.reduce((acc, option) => {
    acc[option.key] = normalizeTemplateTableLayout(option.key, record[option.key], fallback?.[option.key] ?? DEFAULT_TEMPLATE_TABLE_LAYOUTS[option.key]);
    return acc;
  }, {});
}
function textLayerTableLayout(draft, key) {
  return normalizeTemplateTableLayout(key, draft.tableLayouts?.[key], DEFAULT_TEMPLATE_TABLE_LAYOUTS[key]);
}
function templateBoundaryApiUnit(tableKey, boundaryIndex, segment) {
  const label = TEMPLATE_BOUNDARY_API_LABELS[tableKey]?.[boundaryIndex] ?? `${tableKey}.boundary.${boundaryIndex + 1}`;
  const segmentLabel = typeof segment?.rowIndex === 'number' && typeof segment?.cellIndex === 'number' ? `${label}.row${segment.rowIndex + 1}.cell${segment.cellIndex + 1}` : label;
  return {
    tableKey,
    boundaryIndex,
    rowIndex: segment?.rowIndex,
    cellIndex: segment?.cellIndex,
    segmentKey: segment?.segmentKey,
    apiUnitKey: `contractTemplate.${segmentLabel}`,
    label: segmentLabel
  };
}
function normalizeTemplateBoundarySegments(segments) {
  return segments.map(segment => ({
    top: Math.round(segment.top),
    height: Math.max(4, Math.round(segment.height)),
    rowIndex: segment.rowIndex,
    cellIndex: segment.cellIndex,
    boundaryIndex: segment.boundaryIndex,
    defaultLeftPct: Number(segment.defaultLeftPct.toFixed(3)),
    segmentKey: segment.segmentKey
  })).sort((a, b) => a.top - b.top || a.rowIndex - b.rowIndex || a.cellIndex - b.cellIndex).reduce((acc, segment) => {
    const duplicated = acc.some(previous => previous.rowIndex === segment.rowIndex && previous.cellIndex === segment.cellIndex && Math.abs(previous.top - segment.top) <= 1 && Math.abs(previous.height - segment.height) <= 1);
    if (!duplicated) acc.push(segment);
    return acc;
  }, []);
}
function calculateTemplateBoundarySegments(frame, widths) {
  const table = frame.querySelector('table');
  const frameRect = frame.getBoundingClientRect();
  const tableRect = table?.getBoundingClientRect();
  const next = {};
  Array.from({
    length: Math.max(0, widths.length - 1)
  }).forEach((_, index) => {
    next[index] = [];
  });
  if (!table || !tableRect || tableRect.width <= 0) return next;
  const tableLeft = tableRect.left - frameRect.left;
  const tableRight = tableRect.right - frameRect.left;
  Array.from(table.rows).forEach((row, rowIndex) => {
    let columnCursor = 0;
    Array.from(row.cells).forEach((cell, cellIndex) => {
      const span = Math.max(1, Number(cell.getAttribute('data-template-cell-span')) || cell.colSpan || 1);
      columnCursor += span;
      const boundaryIndex = columnCursor - 1;
      const cellRect = cell.getBoundingClientRect();
      if (cellRect.width <= 1 || cellRect.height <= 1) return;
      const cellRight = cellRect.right - frameRect.left;
      if (Math.abs(cellRight - tableRight) <= 2) return;
      if (boundaryIndex >= 0 && boundaryIndex < widths.length - 1) {
        next[boundaryIndex].push({
          top: cellRect.top - frameRect.top,
          height: cellRect.height,
          rowIndex,
          cellIndex,
          boundaryIndex,
          defaultLeftPct: (cellRight - tableLeft) / tableRect.width * 100,
          segmentKey: `${rowIndex}-${cellIndex}-${boundaryIndex}`
        });
      }
    });
  });
  Object.entries(next).forEach(([key, segments]) => {
    next[Number(key)] = normalizeTemplateBoundarySegments(segments);
  });
  return next;
}
function templateBoundaryLeftFromWidths(widths, boundaryIndex) {
  return Number(widths.slice(0, boundaryIndex + 1).reduce((total, width) => total + width, 0).toFixed(3));
}
function templateBoundarySegmentLeftPct(segment, boundaryPositions) {
  return boundaryPositions[segment.segmentKey] ?? segment.defaultLeftPct;
}
function templateBoundaryClampRange(segmentsByBoundary, boundaryPositions, activeSegment) {
  const sameRow = Object.values(segmentsByBoundary).flat().filter(segment => segment.rowIndex === activeSegment.rowIndex && segment.segmentKey !== activeSegment.segmentKey);
  const previous = sameRow.filter(segment => segment.boundaryIndex < activeSegment.boundaryIndex).map(segment => templateBoundarySegmentLeftPct(segment, boundaryPositions)).sort((a, b) => b - a)[0];
  const next = sameRow.filter(segment => segment.boundaryIndex > activeSegment.boundaryIndex).map(segment => templateBoundarySegmentLeftPct(segment, boundaryPositions)).sort((a, b) => a - b)[0];
  return {
    min: Math.max(2, (previous ?? 0) + 3),
    max: Math.min(98, (next ?? 100) - 3)
  };
}
function templateGridColumns(widths) {
  return widths.map(width => `minmax(0, ${Number(width.toFixed(3))}%)`).join(' ');
}
function templateRowColumnWidths(widths, boundaryPositions, rowIndex, spans) {
  const normalized = normalizeColumnWidths(widths, widths);
  const positions = normalized.reduce((acc, width, index) => {
    if (index < normalized.length - 1) acc.push((acc[index - 1] ?? 0) + width);
    return acc;
  }, []);
  let cursor = 0;
  spans.forEach((span, cellIndex) => {
    cursor += Math.max(1, Math.round(Number(span) || 1));
    const boundaryIndex = cursor - 1;
    if (boundaryIndex < 0 || boundaryIndex >= positions.length) return;
    const key = `${rowIndex}-${cellIndex}-${boundaryIndex}`;
    const customLeft = boundaryPositions[key];
    if (Number.isFinite(customLeft)) positions[boundaryIndex] = customLeft;
  });
  for (let index = 0; index < positions.length; index += 1) {
    const minimum = (index === 0 ? 0 : positions[index - 1]) + 3;
    const maximum = 100 - (positions.length - index) * 3;
    positions[index] = clampTemplateNumber(positions[index], normalized[index], minimum, maximum);
  }
  const nextWidths = normalized.map((_, index) => {
    const left = index === 0 ? 0 : positions[index - 1];
    const right = index === normalized.length - 1 ? 100 : positions[index];
    return Number((right - left).toFixed(3));
  });
  return normalizeColumnWidths(nextWidths, normalized);
}
function findTemplateBoundaryAlignmentGuide(segmentsByBoundary, boundaryPositions, boundaryIndex, activeSegment, activeLeftPct) {
  const activeTop = activeSegment.top;
  const xTolerancePct = 0.45;
  const aligned = (segmentsByBoundary[boundaryIndex] ?? []).filter(segment => segment.segmentKey !== activeSegment.segmentKey && segment.rowIndex !== activeSegment.rowIndex).map(segment => {
    const leftPct = templateBoundarySegmentLeftPct(segment, boundaryPositions);
    return {
      segment,
      leftPct,
      distance: Math.abs(leftPct - activeLeftPct)
    };
  }).filter(item => item.distance <= xTolerancePct).sort((a, b) => a.distance - b.distance || a.segment.top - b.segment.top);
  if (!aligned.length) return null;
  const referenceLeftPct = aligned[0].leftPct;
  const comparisonSegments = [{
    leftPct: activeLeftPct,
    top: activeTop,
    height: activeSegment.height,
    kind: 'active'
  }, ...aligned.filter(item => Math.abs(item.leftPct - referenceLeftPct) <= xTolerancePct).map(item => ({
    leftPct: item.leftPct,
    top: item.segment.top,
    height: item.segment.height,
    kind: 'match'
  }))];
  const top = Math.min(...comparisonSegments.map(segment => segment.top));
  const bottom = Math.max(...comparisonSegments.map(segment => segment.top + segment.height));
  return {
    leftPct: Number(referenceLeftPct.toFixed(3)),
    top: Math.floor(top),
    height: Math.max(8, Math.ceil(bottom - top)),
    segments: comparisonSegments.map(segment => ({
      ...segment,
      top: Math.floor(segment.top),
      height: Math.max(4, Math.ceil(segment.height))
    })).sort((a, b) => a.top - b.top || (a.kind === 'active' ? -1 : 1))
  };
}
function updateTextLayerTableLayout(draft, key, patch) {
  return {
    ...draft,
    tableLayouts: {
      ...draft.tableLayouts,
      [key]: normalizeTemplateTableLayout(key, {
        ...textLayerTableLayout(draft, key),
        ...patch
      })
    }
  };
}
function sanitizeTemplateCustomText(key, value, fallback = '') {
  const text = String(value ?? fallback ?? '');
  const trimmed = text.trim();
  if (key === 'closingText' && (trimmed.includes('서명날인 후') || trimmed.includes('매장마다 간인'))) {
    return SIMPLIFIED_CONTRACT_CLOSING_TEXT;
  }
  if (key === 'labelSeal' && trimmed === '인') return '(인)';
  if (key === 'labelBroker' && trimmed === '중개업자') return '중\n개\n업\n자';
  return normalizeDocumentTextLayerCustomText(key, normalizeExplanationTextLayerCustomText(key, text));
}
function sanitizeTemplateFooterText(value) {
  const text = String(value ?? '');
  return isRemovedSaleFooterText(text) ? '' : text;
}
function stripSpecialTermsHeading(value) {
  return String(value ?? '').replace(/^\s*특약사항\s*[:：]?\s*(?:\r?\n)?/u, '');
}
function ExplanationOverlayTextInput({
  multiline,
  value,
  onChange,
  disabled,
  placeholder,
  ariaLabel,
  title,
  className,
  style,
  minFontSizePx
}) {
  const inputRef = useRef(null);
  const textareaRef = useRef(null);
  useAutoFitTextElement(textareaRef, value, style, {
    enabled: multiline,
    multiline: true,
    minFontSizePx: minFontSizePx ?? 4.2
  });
  useAutoFitTextElement(inputRef, value, style, {
    enabled: !multiline,
    multiline: false,
    minFontSizePx: minFontSizePx ?? 4.2
  });
  if (multiline) {
    return <textarea ref={textareaRef} value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} aria-label={ariaLabel} title={title} className={`${className} resize-none`} style={style} />;
  }
  return <input ref={inputRef} value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} aria-label={ariaLabel} title={title} className={className} style={style} />;
}
function TemplateGridRow({
  rowIndex,
  widths,
  boundaryPositions,
  spans,
  children
}) {
  const rowWidths = templateRowColumnWidths(widths, boundaryPositions, rowIndex, spans);
  return <tr className="grid" style={{
    gridTemplateColumns: templateGridColumns(rowWidths)
  }}>
      {Children.map(children, (child, index) => {
      const span = Math.max(1, Math.round(Number(spans[index]) || 1));
      if (!isValidElement(child)) return child;
      return cloneElement(child, {
        style: {
          ...(child.props.style ?? {}),
          gridColumn: `span ${span}`,
          minWidth: 0,
          width: 'auto'
        },
        'data-template-cell-span': span
      });
    })}
    </tr>;
}
function TemplateResizableTableFrame({
  tableKey,
  activeTableKey,
  widths,
  boundaryPositions,
  onBoundaryPositionChange,
  onWidthsChange,
  onActivate,
  onBoundarySelect,
  children
}) {
  const frameRef = useRef(null);
  const active = activeTableKey === tableKey;
  const [draggingBoundarySegmentKey, setDraggingBoundarySegmentKey] = useState(null);
  const [hoveredBoundarySegmentKey, setHoveredBoundarySegmentKey] = useState(null);
  const [boundarySegments, setBoundarySegments] = useState({});
  const [alignmentGuide, setAlignmentGuide] = useState(null);
  const effectiveBoundaryPositions = boundaryPositions ?? {};
  const cumulative = widths.reduce((acc, width, index) => {
    if (index < widths.length - 1) acc.push((acc[index - 1] ?? 0) + width);
    return acc;
  }, []);
  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return undefined;
    let animationFrame = 0;
    const updateSegments = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        const next = calculateTemplateBoundarySegments(frame, widths);
        setBoundarySegments(current => JSON.stringify(current) === JSON.stringify(next) ? current : next);
      });
    };
    updateSegments();
    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateSegments) : null;
    resizeObserver?.observe(frame);
    window.addEventListener('resize', updateSegments);
    return () => {
      window.cancelAnimationFrame(animationFrame);
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateSegments);
    };
  });
  const handlePointerDown = (event, boundaryIndex, segment) => {
    event.preventDefault();
    event.stopPropagation();
    onActivate(tableKey);
    onBoundarySelect?.(templateBoundaryApiUnit(tableKey, boundaryIndex, segment));
    const startX = event.clientX;
    const frame = frameRef.current;
    const frameWidth = frame?.getBoundingClientRect().width || 1;
    const startLeftPct = boundaryPositions ? templateBoundarySegmentLeftPct(segment, effectiveBoundaryPositions) : templateBoundaryLeftFromWidths(widths, boundaryIndex);
    const clampRange = boundaryPositions ? templateBoundaryClampRange(boundarySegments, effectiveBoundaryPositions, segment) : {
      min: 2,
      max: 98
    };
    const startWidths = [...widths];
    setDraggingBoundarySegmentKey(segment.segmentKey);
    const handleMove = moveEvent => {
      const deltaPct = (moveEvent.clientX - startX) / frameWidth * 100;
      const leftPct = Number(clampTemplateNumber(startLeftPct + deltaPct, startLeftPct, clampRange.min, clampRange.max).toFixed(3));
      if (onBoundaryPositionChange) {
        onBoundaryPositionChange(segment.segmentKey, leftPct, boundaryIndex);
      } else if (onWidthsChange) {
        const next = [...startWidths];
        const left = startWidths[boundaryIndex] + deltaPct;
        const right = startWidths[boundaryIndex + 1] - deltaPct;
        if (left < 3 || right < 3) return;
        next[boundaryIndex] = left;
        next[boundaryIndex + 1] = right;
        onWidthsChange(normalizeColumnWidths(next, startWidths));
      }
      setAlignmentGuide(findTemplateBoundaryAlignmentGuide(boundarySegments, effectiveBoundaryPositions, boundaryIndex, segment, leftPct));
    };
    const handleUp = () => {
      setDraggingBoundarySegmentKey(null);
      setAlignmentGuide(null);
      window.removeEventListener('pointermove', handleMove);
      window.removeEventListener('pointerup', handleUp);
    };
    window.addEventListener('pointermove', handleMove);
    window.addEventListener('pointerup', handleUp, {
      once: true
    });
  };
  return <div ref={frameRef} className={`group relative ${active ? 'outline outline-1 outline-offset-2 outline-blue-300' : ''}`} onMouseDown={() => onActivate(tableKey)} data-template-table-frame={tableKey}>
      {children}
      <div className="pointer-events-none absolute inset-y-0 left-0 right-0 print:hidden">
        {alignmentGuide ? <>
            <span className="pointer-events-none absolute w-[2px] -translate-x-1/2 rounded-full bg-red-500 shadow-[0_0_0_1px_rgba(255,255,255,0.9)]" style={{
          left: `${alignmentGuide.leftPct}%`,
          top: alignmentGuide.top,
          height: alignmentGuide.height
        }} data-template-boundary-align-guide />
            {alignmentGuide.segments.map((segment, index) => <span key={`${segment.kind}-${segment.top}-${segment.height}-${index}`} className={`pointer-events-none absolute w-4 -translate-x-1/2 rounded-sm border-y ${segment.kind === 'active' ? 'border-red-600 bg-red-500/25' : 'border-red-500/80 bg-red-400/15'}`} style={{
          left: `${segment.leftPct}%`,
          top: segment.top,
          height: segment.height
        }} data-template-boundary-align-guide-segment={segment.kind} />)}
          </> : null}
        {Object.entries(boundarySegments).flatMap(([boundaryIndexText, segments]) => segments.map(segment => {
        const index = Number(boundaryIndexText);
        const segmentLeft = boundaryPositions ? templateBoundarySegmentLeftPct(segment, effectiveBoundaryPositions) : cumulative[index] ?? segment.defaultLeftPct;
        const unit = templateBoundaryApiUnit(tableKey, index, segment);
        const highlighted = draggingBoundarySegmentKey === segment.segmentKey || hoveredBoundarySegmentKey === segment.segmentKey;
        return <button key={`${tableKey}-${index}-${segment.segmentKey}`} type="button" data-template-boundary-api-unit={unit.apiUnitKey} data-template-table-key={tableKey} data-template-boundary-index={index} data-template-boundary-row-index={segment.rowIndex} data-template-boundary-cell-index={segment.cellIndex} data-template-boundary-segment-key={segment.segmentKey} aria-label={`${TEMPLATE_TABLE_OPTIONS.find(option => option.key === tableKey)?.label ?? tableKey} ${index + 1}번 칸막이 조절`} className="pointer-events-auto absolute w-3 -translate-x-1/2 cursor-col-resize bg-transparent focus-visible:outline-none" style={{
          left: `${segmentLeft}%`,
          top: segment.top,
          height: segment.height
        }} onMouseEnter={() => setHoveredBoundarySegmentKey(segment.segmentKey)} onMouseLeave={() => setHoveredBoundarySegmentKey(current => current === segment.segmentKey ? null : current)} onPointerDown={event => handlePointerDown(event, index, segment)}>
            <span className={`pointer-events-none absolute left-1/2 top-1/2 h-4 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/90 shadow-sm transition-all ${highlighted ? 'bg-blue-600 opacity-95' : 'bg-slate-500 opacity-0'}`} />
          </button>;
      }))}
      </div>
    </div>;
}
function TemplateColGroup({
  widths
}) {
  return <colgroup>
      {widths.map((width, index) => <col key={`${index}-${width}`} style={{
      width: `${width}%`
    }} />)}
    </colgroup>;
}
function mobileViewerFitZoom(baseWidthPx, horizontalPaddingPx = 24) {
  if (typeof window === 'undefined') return 1;
  const viewportWidth = window.visualViewport?.width || window.innerWidth || baseWidthPx;
  if (viewportWidth > 768) return 1;
  const usableWidth = Math.max(240, viewportWidth - horizontalPaddingPx);
  return Number(Math.min(1, Math.max(0.32, usableWidth / baseWidthPx)).toFixed(2));
}
function LegalExplanationFormPanel({
  draft,
  onDraftChange,
  form,
  contract: contractInput,
  automationSnapshot,
  officialDocuments,
  realtorProfile,
  disabled,
  viewerMode = false,
  embeddedViewer = false,
  viewerZoom
}) {
  const directEditSectionRef = useRef(null);
  const contract = useMemo(() => automationSnapshot ? contractWithDocumentSnapshotAutomation(contractInput, automationSnapshot) : contractInput, [automationSnapshot, contractInput]);
  const explanationPropertyType = explanationDocumentPropertyType(form, contract);
  const explanationContractType = explanationDocumentContractType(form, contract);
  const selectedForm = explanationLegalFormForSelection({
    propertyType: explanationPropertyType
  });
  const legalFormOptions = EXPLANATION_LEGAL_FORMS.filter(item => item.currentScope);
  const pageImages = legalFormRenderedPageImages(selectedForm.key);
  const [selectedPreviewPage, setSelectedPreviewPage] = useState(1);
  const [explanationPreviewZoom, setExplanationPreviewZoom] = useState(1);
  useEffect(() => {
    if (viewerMode && embeddedViewer && typeof viewerZoom === 'number') {
      setExplanationPreviewZoom(viewerZoom);
    }
  }, [embeddedViewer, viewerMode, viewerZoom]);
  const [confirmedDirectBundleIds, setConfirmedDirectBundleIds] = useState({});
  const [confirmedStandaloneDirectCheckKeys, setConfirmedStandaloneDirectCheckKeys] = useState({});
  const [pendingManagementFeeSelections, setPendingManagementFeeSelections] = useState({});
  const explanationMainUse = explanationAutomationFieldValue(contract, 'mainUse', '용도/주용도');
  const selectedKey = explanationLegalFormKeyForSelection(draft.explanationFormKey, {
    propertyType: explanationPropertyType
  });
  const effectiveForm = legalFormOptions.find(item => item.key === selectedKey) ?? selectedForm;
  useEffect(() => {
    setConfirmedDirectBundleIds({});
    setConfirmedStandaloneDirectCheckKeys({});
    setPendingManagementFeeSelections({});
  }, [contract?.id, effectiveForm.key]);
  const effectivePageImages = legalFormRenderedPageImages(effectiveForm.key);
  const activeFormCheckOverlays = EXPLANATION_FORM_CHECK_OVERLAYS.filter(field => explanationCheckOverlayBelongsToForm(field, effectiveForm.key));
  const checks = mergeExplanationOverlayChecks(normalizeExplanationChecks(draft.explanationChecks ?? DEFAULT_EXPLANATION_CHECK_ITEMS), activeFormCheckOverlays, {
    contractTypeOption: explanationContractTypeOptionForSelection({
      contractType: explanationContractType
    }),
    residentialBuildingTypeOption: explanationResidentialBuildingTypeOptionForSelection({
      propertyType: explanationPropertyType,
      mainUse: explanationMainUse
    }),
    nonResidentialUseTypeOption: explanationNonResidentialUseTypeOptionForSelection({
      propertyType: explanationPropertyType,
      mainUse: explanationMainUse
    })
  });
  const previewPageCount = effectivePageImages.length || pageImages.length;
  const previewPage = Math.min(Math.max(selectedPreviewPage, 1), Math.max(previewPageCount, 1));
  const clampExplanationPreviewZoom = value => Math.min(2, Math.max(viewerMode ? 0.32 : 0.55, Number(value.toFixed(2))));
  const changeExplanationPreviewZoom = useCallback(delta => {
    setExplanationPreviewZoom(value => clampExplanationPreviewZoom(value + delta));
  }, [viewerMode]);
  const explanationPreviewZoomPercent = Math.round(explanationPreviewZoom * 100);
  useEffect(() => {
    if (!viewerMode || typeof window === 'undefined') return undefined;
    const applyMobileFitZoom = () => {
      setExplanationPreviewZoom(clampExplanationPreviewZoom(mobileViewerFitZoom(EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX)));
    };
    applyMobileFitZoom();
    window.addEventListener('resize', applyMobileFitZoom);
    window.visualViewport?.addEventListener('resize', applyMobileFitZoom);
    return () => {
      window.removeEventListener('resize', applyMobileFitZoom);
      window.visualViewport?.removeEventListener('resize', applyMobileFitZoom);
    };
  }, [effectiveForm.key, viewerMode]);
  const handleExplanationPreviewWheel = event => {
    if (!(event.ctrlKey || event.metaKey)) return;
    event.preventDefault();
    changeExplanationPreviewZoom(event.deltaY < 0 ? 0.1 : -0.1);
  };
  const scrollToDirectEditSection = () => {
    directEditSectionRef.current?.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  };
  const resetDirectConfirmationCompletionForKey = key => {
    setConfirmedStandaloneDirectCheckKeys(current => current[key] ? {
      ...current,
      [key]: false
    } : current);
    const bundleIds = directConfirmationBundleIdsForCheckKey(key);
    if (!bundleIds.length) return;
    setConfirmedDirectBundleIds(current => {
      let changed = false;
      const next = {
        ...current
      };
      for (const bundleId of bundleIds) {
        if (next[bundleId]) {
          next[bundleId] = false;
          changed = true;
        }
      }
      return changed ? next : current;
    });
  };
  const updateStatus = (key, status) => {
    const manualConfirmedAt = new Date().toISOString();
    resetDirectConfirmationCompletionForKey(key);
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(item => item.key === key ? {
        ...item,
        status,
        source: 'MANUAL',
        manualConfirmedAt
      } : item),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
  };
  const updateOption = (key, selectedOption) => {
    const manualConfirmedAt = new Date().toISOString();
    const requiresConfirmation = DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(key);
    resetDirectConfirmationCompletionForKey(key);
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(item => item.key === key ? {
        ...item,
        selectedOption,
        status: selectedOption ? requiresConfirmation ? 'NEEDS_CHECK' : 'OK' : 'NOT_APPLICABLE',
        source: 'MANUAL',
        manualConfirmedAt
      } : item),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
  };
  const toggleSourceDocumentType = documentType => {
    const item = checkItemByKey.get('source-documents');
    const selectedTypes = explanationSourceDocumentTypeSelectedSet(item);
    if (selectedTypes.has(documentType)) {
      selectedTypes.delete(documentType);
    } else {
      selectedTypes.add(documentType);
    }
    const selectedOption = explanationSourceDocumentTypeSelectedText(selectedTypes);
    const manualConfirmedAt = new Date().toISOString();
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(checkItem => checkItem.key === 'source-documents' ? {
        ...checkItem,
        selectedOption,
        status: selectedOption ? 'OK' : 'NOT_APPLICABLE',
        source: 'MANUAL',
        manualConfirmedAt
      } : checkItem),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
  };
  const updateCustomText = (key, value) => {
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      customTexts: {
        ...(draft.customTexts ?? {}),
        [key]: normalizeExplanationTextLayerCustomText(key, value)
      },
      explanationChecks: checks,
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
  };
  const selectLegalForm = key => {
    const next = legalFormOptions.find(item => item.key === key) ?? selectedForm;
    onDraftChange({
      ...draft,
      explanationFormKey: next.key,
      explanationChecks: checks,
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
  };
  const statusOptions = [{
    value: 'OK',
    label: EXPLANATION_CHECK_STATUS_LABELS.OK
  }, {
    value: 'NEEDS_CHECK',
    label: EXPLANATION_CHECK_STATUS_LABELS.NEEDS_CHECK
  }, {
    value: 'NOT_APPLICABLE',
    label: EXPLANATION_CHECK_STATUS_LABELS.NOT_APPLICABLE
  }];
  const textOverlays = EXPLANATION_FORM_TEXT_OVERLAYS.filter(field => explanationTextOverlayBelongsToForm(field, effectiveForm.key) && field.page === previewPage);
  const checkOverlays = activeFormCheckOverlays.filter(field => field.page === previewPage);
  const checkItemByKey = new Map(checks.map(item => [item.key, item]));
  const transitWalkSelectedForAccessibility = () => ['location-bus-mode', 'location-subway-mode'].some(key => {
    const item = checkItemByKey.get(key);
    if (item?.source === 'MANUAL' && item.selectedOption) return item.selectedOption === 'walk';
    return explanationAutoOptionForCheck(contract, key) === 'walk';
  });
  const needsDirectConfirmationInEditor = item => {
    if (item?.key === 'location-accessibility' && transitWalkSelectedForAccessibility()) return false;
    return needsDirectConfirmationCheck(item, contract);
  };
  const inferredSemanticCheckOption = key => {
    if (key === 'explanation-contract-type') {
      return explanationContractTypeOptionForSelection({
        contractType: explanationContractType
      });
    }
    if (key === 'explanation-residential-building-type') {
      return explanationResidentialBuildingTypeOptionForSelection({
        propertyType: explanationPropertyType,
        mainUse: explanationMainUse
      });
    }
    if (key === 'explanation-nonresidential-use-type') {
      return explanationNonResidentialUseTypeOptionForSelection({
        propertyType: explanationPropertyType,
        mainUse: explanationMainUse
      });
    }
    return '';
  };
  const effectiveCheckStatus = key => {
    const item = checkItemByKey.get(key);
    const semanticOption = inferredSemanticCheckOption(key);
    if (semanticOption) return 'OK';
    if (key === 'explanation-contract-type' || key === 'explanation-residential-building-type' || key === 'explanation-nonresidential-use-type') {
      return item?.source === 'MANUAL' && item.selectedOption ? item.status : 'NEEDS_CHECK';
    }
    if (key === 'location-road') {
      if (item?.source === 'MANUAL') return item.status;
      return 'NEEDS_CHECK';
    }
    if (key === 'location-accessibility' && transitWalkSelectedForAccessibility()) return 'OK';
    const apiStatus = managementAutomationStatusForCheck(contract, key);
    if (apiStatus) return apiStatus;
    if (LAND_USE_REGULATION_CHECK_KEYS.has(key)) {
      if (item?.source === 'MANUAL' && item.manualConfirmedAt) return item.status;
      return explanationLandUseRegulationAutoStatusForCheck(contract, key) || 'NOT_APPLICABLE';
    }
    const autoOption = explanationAutoOptionForCheck(contract, key);
    if (autoOption) return 'OK';
    if (isManagementApiCheckKey(key)) return item?.source === 'MANUAL' ? item.status : 'NEEDS_CHECK';
    if (DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(key)) {
      if (item && isDirectConfirmedCheckItem(item)) return item.status;
      if (item?.source === 'MANUAL') return item.status;
      return 'NEEDS_CHECK';
    }
    return item?.status ?? 'NOT_APPLICABLE';
  };
  const effectiveCheckOption = key => {
    const item = checkItemByKey.get(key);
    if (item?.source === 'MANUAL' && item.selectedOption) return item.selectedOption;
    const semanticOption = inferredSemanticCheckOption(key);
    if (semanticOption) return semanticOption;
    if (key === 'location-accessibility' && transitWalkSelectedForAccessibility()) return 'easy';
    const apiOption = managementAutomationOptionForCheck(contract, key);
    if (apiOption) return apiOption;
    const autoOption = explanationAutoOptionForCheck(contract, key);
    if (autoOption) return autoOption;
    if (isManagementApiCheckKey(key)) return item?.source === 'MANUAL' ? item.selectedOption ?? '' : '';
    return item?.selectedOption ?? '';
  };
  const directBundleDefaultOption = preset => {
    if (preset.key === 'floor-state' || preset.key === 'papering-state') {
      return explanationIsNewerThanYears(contract, 3) ? 'clean' : 'normal';
    }
    return preset.defaultOption ?? LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY[preset.key] ?? '';
  };
  const effectiveBundleOption = preset => {
    const item = checkItemByKey.get(preset.key);
    const currentOption = effectiveCheckOption(preset.key);
    if (item?.source === 'MANUAL') return currentOption;
    return currentOption || directBundleDefaultOption(preset);
  };
  const effectiveBundleStatus = preset => {
    const item = checkItemByKey.get(preset.key);
    if (item?.source === 'MANUAL') return effectiveCheckStatus(preset.key);
    return 'OK';
  };
  const directCheckDefaultOption = item => {
    const currentOption = effectiveCheckOption(item.key);
    if (currentOption) return currentOption;
    return LEGACY_IMPLICIT_EXPLANATION_OPTION_BY_KEY[item.key] ?? item.options?.[0]?.value ?? '';
  };
  const isDirectCheckItemGroupConfirmed = items => items.length > 0 && items.every(item => item.source === 'MANUAL' && item.status !== 'NEEDS_CHECK' && (!item.options?.length || Boolean(item.selectedOption)));
  const isDirectCheckBundleConfirmed = bundleItems => bundleItems.every(preset => {
    const item = checkItemByKey.get(preset.key);
    if (!item || item.source !== 'MANUAL' || item.status !== 'OK') return false;
    return !item.options?.length || Boolean(item.selectedOption || directBundleDefaultOption(preset));
  });
  const confirmDirectCheckBundle = (bundleItems, bundleId) => {
    const bundleByKey = new Map(bundleItems.map(item => [item.key, item]));
    const manualConfirmedAt = new Date().toISOString();
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(item => {
        const preset = bundleByKey.get(item.key);
        if (!preset) return item;
        const defaultOption = item.options?.length ? directBundleDefaultOption(preset) : '';
        return {
          ...item,
          selectedOption: item.options?.length ? defaultOption : item.selectedOption,
          status: 'OK',
          source: 'MANUAL',
          manualConfirmedAt
        };
      }),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
    setConfirmedDirectBundleIds(current => ({
      ...current,
      [bundleId]: true
    }));
  };
  const confirmDirectCheckItems = (targetItems, bundleId) => {
    const targetKeys = new Set(targetItems.map(item => item.key));
    const selectedOptionByKey = new Map(targetItems.map(item => [item.key, directCheckDefaultOption(item)]));
    const siteGuideRequiresNotice = selectedOptionByKey.get('site-guide') === 'assistant' && checkItemByKey.has('site-guide-notice');
    const manualConfirmedAt = new Date().toISOString();
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(item => {
        if (!targetKeys.has(item.key) && !(siteGuideRequiresNotice && item.key === 'site-guide-notice')) return item;
        const selectedOption = item.options?.length ? selectedOptionByKey.get(item.key) ?? directCheckDefaultOption(item) : item.selectedOption;
        return {
          ...item,
          selectedOption,
          status: selectedOption || !item.options?.length ? 'OK' : 'NOT_APPLICABLE',
          source: 'MANUAL',
          manualConfirmedAt
        };
      }),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
    setConfirmedStandaloneDirectCheckKeys(current => {
      const next = {
        ...current
      };
      for (const key of targetKeys) next[key] = true;
      if (siteGuideRequiresNotice) next['site-guide-notice'] = true;
      return next;
    });
    setConfirmedDirectBundleIds(current => ({
      ...current,
      [bundleId]: true
    }));
  };
  const allManagementFeeDirectChecks = MANAGEMENT_FEE_DIRECT_CHECK_ORDER.map(key => checkItemByKey.get(key)).filter(item => Boolean(item));
  const managementFeeDirectChecks = allManagementFeeDirectChecks.filter(item => needsDirectConfirmationCheck(item, contract));
  const managementFeeDefaultChecked = key => DEFAULT_MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(key) || effectiveCheckStatus(key) === 'OK';
  const managementFeeChecked = key => Object.prototype.hasOwnProperty.call(pendingManagementFeeSelections, key) ? pendingManagementFeeSelections[key] : managementFeeDefaultChecked(key);
  const managementFeeConfirmed = confirmedDirectBundleIds['management-fee'] || allManagementFeeDirectChecks.length > 0 && allManagementFeeDirectChecks.every(item => item.source === 'MANUAL' && item.status !== 'NEEDS_CHECK');
  const togglePendingManagementFeeCheck = key => {
    setPendingManagementFeeSelections(current => ({
      ...current,
      [key]: !managementFeeChecked(key)
    }));
    setConfirmedDirectBundleIds(current => ({
      ...current,
      'management-fee': false
    }));
  };
  const confirmManagementFeeDirectChecks = () => {
    const selectedByKey = new Map(allManagementFeeDirectChecks.map(item => [item.key, managementFeeChecked(item.key)]));
    const manualConfirmedAt = new Date().toISOString();
    onDraftChange({
      ...draft,
      explanationFormKey: effectiveForm.key,
      explanationChecks: checks.map(item => MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(item.key) ? {
        ...item,
        status: selectedByKey.get(item.key) ? 'OK' : 'NOT_APPLICABLE',
        source: 'MANUAL',
        manualConfirmedAt
      } : item),
      languageBackups: normalizeLanguageBackups(draft.languageBackups)
    });
    setConfirmedDirectBundleIds(current => ({
      ...current,
      'management-fee': true
    }));
  };
  const allRemainingDirectConfirmationChecks = checks.filter(item => DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(item.key) && !MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(item.key) && !GROUPED_DIRECT_CONFIRMATION_KEYS.has(item.key) && !SITE_GUIDE_DIRECT_CONFIRMATION_KEYS.has(item.key));
  const remainingDirectConfirmationChecks = allRemainingDirectConfirmationChecks.filter(item => needsDirectConfirmationCheck(item, contract));
  const siteGuideDirectConfirmationItem = checkItemByKey.get('site-guide');
  const siteGuideNoticeItem = checkItemByKey.get('site-guide-notice');
  const siteGuideSelectedOption = siteGuideDirectConfirmationItem ? directCheckDefaultOption(siteGuideDirectConfirmationItem) : '';
  const siteGuideNoticeRequired = siteGuideSelectedOption === 'assistant' && Boolean(siteGuideNoticeItem);
  const siteGuideNoticeSelectedOption = siteGuideNoticeItem ? directCheckDefaultOption(siteGuideNoticeItem) : '';
  const allSiteGuideDirectConfirmationChecks = siteGuideDirectConfirmationItem ? [siteGuideDirectConfirmationItem] : [];
  const siteGuideNeedsDirectConfirmation = siteGuideDirectConfirmationItem ? needsDirectConfirmationCheck(siteGuideDirectConfirmationItem, contract) : false;
  const siteGuideNoticeNeedsDirectConfirmation = siteGuideNoticeRequired && siteGuideNoticeItem ? needsDirectConfirmationCheck(siteGuideNoticeItem, contract) : false;
  const siteGuideDirectConfirmationChecks = siteGuideDirectConfirmationItem && (siteGuideNeedsDirectConfirmation || siteGuideNoticeNeedsDirectConfirmation) ? [siteGuideDirectConfirmationItem] : [];
  const visibleSiteGuideDirectConfirmationItem = siteGuideDirectConfirmationChecks[0] ?? null;
  const siteGuideDirectConfirmationItemsForConfirm = [siteGuideNeedsDirectConfirmation ? siteGuideDirectConfirmationItem : null, siteGuideNoticeNeedsDirectConfirmation ? siteGuideNoticeItem : null].filter(item => Boolean(item));
  const siteGuideDirectConfirmationConfirmed = confirmedDirectBundleIds[SITE_GUIDE_DIRECT_CONFIRMATION_BUNDLE_ID] || allSiteGuideDirectConfirmationChecks.length > 0 && isDirectCheckItemGroupConfirmed(allSiteGuideDirectConfirmationChecks) && (!siteGuideNoticeRequired || (siteGuideNoticeItem ? isDirectCheckItemGroupConfirmed([siteGuideNoticeItem]) : false));
  const remainingDirectConfirmationConfirmed = confirmedDirectBundleIds[REMAINING_DIRECT_CONFIRMATION_BUNDLE_ID] || isDirectCheckItemGroupConfirmed(allRemainingDirectConfirmationChecks) || allRemainingDirectConfirmationChecks.length > 0 && allRemainingDirectConfirmationChecks.every(item => confirmedStandaloneDirectCheckKeys[item.key]);
  const directConfirmationGroups = [{
    id: 'lease-confirmation',
    title: '묶음 1. 임대차 확인사항',
    description: '확정일자, 국세ㆍ지방세, 전입세대, 민간임대, 보증, 계약갱신 확인사항을 한 번에 정리합니다.',
    items: LEASE_CONFIRMATION_BUNDLE_ITEMS
  }, {
    id: 'facility-basic',
    title: '묶음 2. 기본 시설 상태',
    description: '수도 파손 없음, 용수량 정상, 전기 정상, 난방 정상, 배수 정상 기본값을 한 번에 확인합니다.',
    items: BASIC_FACILITY_BUNDLE_ITEMS
  }, {
    id: 'wall-environment',
    title: '묶음 3. 벽면ㆍ마감ㆍ환경조건',
    description: '벽면 균열/누수 없음과 마감상태, 일조량, 소음, 진동 기본값을 한 번에 확인합니다.',
    items: WALL_ENVIRONMENT_BUNDLE_ITEMS
  }].map(group => ({
    ...group,
    rows: group.items.map(preset => {
      const item = checkItemByKey.get(preset.key);
      return item && needsDirectConfirmationCheck(item, contract) ? {
        preset,
        item
      } : null;
    }).filter(row => Boolean(row))
  })).filter(group => group.rows.length);
  const directConfirmationPanelVisible = directConfirmationGroups.length > 0 || managementFeeDirectChecks.length > 0 || siteGuideDirectConfirmationChecks.length > 0 || remainingDirectConfirmationChecks.length > 0;
  const directConfirmationPanelCount = directConfirmationGroups.reduce((sum, group) => sum + group.rows.length, 0) + managementFeeDirectChecks.length + siteGuideDirectConfirmationChecks.length + (siteGuideNoticeNeedsDirectConfirmation ? 1 : 0) + remainingDirectConfirmationChecks.length;
  const regularExplanationCheckRows = checks.filter(item => !DIRECT_CONFIRMATION_EXPLANATION_CHECK_KEYS.has(item.key) && !GROUPED_DIRECT_CONFIRMATION_KEYS.has(item.key) && !MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(item.key));
  const autoTextDefaults = useMemo(() => buildExplanationFormAutoTextDefaults({
    form,
    contract,
    realtorProfile
  }), [contract, form, realtorProfile]);
  const autoTextRepairs = useMemo(() => buildExplanationFormAutoTextRepairs({
    form,
    contract,
    realtorProfile
  }), [contract, form, realtorProfile]);
  const overlayTextValue = key => resolveExplanationFormOverlayTextValue(draft, autoTextDefaults, key, autoTextRepairs);
  const clickOverlayCheck = field => {
    const sourceDocumentType = explanationSourceDocumentType(field);
    if (sourceDocumentType) {
      toggleSourceDocumentType(sourceDocumentType);
      return;
    }
    const active = isOverlayCheckActive(field);
    const manualConfirmedAt = new Date().toISOString();
    if (field.optionValue) {
      resetDirectConfirmationCompletionForKey(field.checkKey);
      onDraftChange({
        ...draft,
        explanationFormKey: effectiveForm.key,
        explanationChecks: checks.map(item => item.key === field.checkKey ? {
          ...item,
          selectedOption: active ? '' : field.optionValue,
          status: active ? 'NOT_APPLICABLE' : 'OK',
          source: 'MANUAL',
          manualConfirmedAt
        } : field.checkKey === 'site-guide-notice' && item.key === 'site-guide' ? active ? item : {
          ...item,
          selectedOption: 'assistant',
          status: 'OK',
          source: 'MANUAL',
          manualConfirmedAt
        } : item),
        languageBackups: normalizeLanguageBackups(draft.languageBackups)
      });
      return;
    }
    updateStatus(field.checkKey, active ? 'NOT_APPLICABLE' : field.status ?? 'OK');
  };
  const isOverlayCheckActive = field => {
    const sourceDocumentType = explanationSourceDocumentType(field);
    if (sourceDocumentType) return explanationSourceDocumentTypeIsActive(field, checkItemByKey.get('source-documents'), officialDocuments, contract);
    const item = checkItemByKey.get(field.checkKey);
    if (!item) return false;
    if (field.checkKey === 'site-guide-notice') {
      const siteGuide = checkItemByKey.get('site-guide');
      if (effectiveCheckOption('site-guide') !== 'assistant' && siteGuide?.selectedOption !== 'assistant') return false;
    }
    const groupedPreset = GROUPED_DIRECT_CONFIRMATION_KEYS.has(field.checkKey) ? {
      key: field.checkKey
    } : null;
    const status = groupedPreset ? effectiveBundleStatus(groupedPreset) : MANAGEMENT_FEE_DIRECT_CHECK_KEYS.has(field.checkKey) ? managementFeeChecked(field.checkKey) ? 'OK' : 'NOT_APPLICABLE' : effectiveCheckStatus(field.checkKey);
    const selectedOption = groupedPreset ? effectiveBundleOption(groupedPreset) : effectiveCheckOption(field.checkKey);
    return explanationCheckOverlayMatchesState(field, status, selectedOption);
  };
  const renderReadOnlyExplanationPreviewPage = pageNumber => {
    const pageTextOverlays = EXPLANATION_FORM_TEXT_OVERLAYS.filter(field => explanationTextOverlayBelongsToForm(field, effectiveForm.key) && field.page === pageNumber);
    const pageCheckOverlays = activeFormCheckOverlays.filter(field => field.page === pageNumber);
    return <div key={pageNumber} className="relative mx-auto" style={{
      width: `${Math.round(EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX * explanationPreviewZoom)}px`,
      minWidth: `${Math.round(EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX * explanationPreviewZoom)}px`
    }} data-explanation-print-page-source data-explanation-print-page={pageNumber}>
        <img src={effectivePageImages[pageNumber - 1]} alt={`${effectiveForm.title} ${pageNumber}`} className="w-full rounded border border-slate-200 bg-white" />
        {pageTextOverlays.map(field => {
        const rawOverlayValue = overlayTextValue(field.key);
        const overlayValue = formatPreviewExplanationOverlayValue(field, rawOverlayValue, explanationPreviewZoom);
        const multilineOverlay = explanationOverlayTextIsMultiline(field, overlayValue);
        const overlayHeight = field.height;
        const overlayTop = field.top;
        const overlayFontSizePt = explanationOverlayTextFontSizePt(field, overlayValue);
        const overlayFontSize = overlayFontSizePt * EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom;
        const overlayHeightValuePx = explanationOverlayHeightPx(overlayHeight, explanationPreviewZoom);
        const overlayHeightValuePt = overlayHeightValuePx / (EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom);
        const overlayLineHeight = explanationOverlayTextLineHeightPt(field, overlayValue, overlayFontSizePt, overlayHeightValuePt) * EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom;
        const overlayTextLineCount = Math.max(1, overlayValue.split(/\r?\n/u).length);
        const overlayVerticalPadding = multilineOverlay ? Math.max(0, (overlayHeightValuePx - overlayLineHeight * overlayTextLineCount) / 2) : 0;
        const overlayHorizontalPadding = explanationOverlayNeedsWideInset(field, overlayValue) ? EXPLANATION_FORM_LEFT_TEXT_INSET_PX * explanationPreviewZoom : 2;
        const overlayStyle = {
          left: `${field.left}%`,
          top: `${overlayTop}%`,
          width: `${field.width}%`,
          height: `${overlayHeight}%`,
          textAlign: field.align ?? 'center',
          fontSize: `${overlayFontSize}px`,
          lineHeight: `${overlayLineHeight}px`,
          paddingLeft: `${overlayHorizontalPadding}px`,
          paddingRight: `${overlayHorizontalPadding}px`,
          paddingTop: `${overlayVerticalPadding}px`,
          paddingBottom: `${overlayVerticalPadding}px`,
          overflowWrap: multilineOverlay ? 'anywhere' : undefined,
          wordBreak: multilineOverlay ? 'keep-all' : undefined
        };
        return <div key={`${pageNumber}-${field.key}`} className="absolute overflow-hidden px-[2px] font-semibold text-blue-950" title={field.label} aria-label={`${field.label} preview`} style={overlayStyle}>
              {overlayValue.split(/\r?\n/u).map((line, index) => <Fragment key={`${field.key}-${index}`}>
                  {index > 0 ? <br /> : null}
                  {line}
                </Fragment>)}
            </div>;
      })}
        {pageCheckOverlays.map(field => {
        const overlayItem = checkItemByKey.get(field.checkKey);
        const active = isOverlayCheckActive(field);
        const directConfirmationRequired = needsDirectConfirmationInEditor(overlayItem);
        const selectedOption = effectiveCheckOption(field.checkKey);
        const directConfirmationSelected = directConfirmationRequired && (field.activeOptionValues?.length ? field.activeOptionValues.includes(selectedOption) : Boolean(field.optionValue && selectedOption === field.optionValue));
        if (!active && !directConfirmationSelected) return null;
        const checkMarkSize = explanationCheckMarkSizePx(explanationPreviewZoom);
        return <span key={`${pageNumber}-${field.id}`} title={explanationCheckOverlayTitle(field, overlayItem)} className="absolute flex items-center justify-center overflow-visible text-blue-800" style={{
          left: `${field.left}%`,
          top: `${field.top}%`,
          width: `${field.width ?? EXPLANATION_FORM_CHECK_HIT_WIDTH}%`,
          height: `${field.height ?? EXPLANATION_FORM_CHECK_HIT_HEIGHT}%`,
          transform: 'translate(-50%, -50%)'
        }}>
              <Check className="pointer-events-none" aria-hidden style={{
            width: `${checkMarkSize}px`,
            height: `${checkMarkSize}px`,
            strokeWidth: 3.6
          }} />
            </span>;
      })}
      </div>;
  };
  return <div className={viewerMode ? 'flex min-h-0 flex-1 flex-col bg-slate-950' : 'space-y-4'} data-explanation-legal-form-panel>
      {!viewerMode ? <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <div className="text-sm font-black text-blue-950">법정 원본 PDF 양식 사용</div>
            <p className="mt-1 text-xs leading-5 text-blue-800">
              확인설명서는 디자인 템플릿으로 다시 만들지 않고, 첨부한 별지 원본을 그대로 자동첨부합니다.
            </p>
          </div>
          {!viewerMode && effectivePageImages.length ? <button type="button" onClick={scrollToDirectEditSection} disabled={disabled} className="inline-flex h-9 items-center gap-2 rounded-lg border border-blue-200 bg-white px-3 text-xs font-black text-blue-800 hover:border-blue-400 disabled:cursor-not-allowed disabled:opacity-50" data-explanation-direct-edit-button>
              <Pencil className="h-4 w-4" aria-hidden />
              직접편집
            </button> : null}
        </div>
        <div className="mt-3 rounded-lg border border-blue-100 bg-white p-3">
          <div className="text-xs font-black text-slate-500">현재 자동첨부</div>
          <div className="mt-1 text-base font-black text-slate-950">{effectiveForm.title}</div>
          <div className="mt-2 text-xs leading-5 text-slate-500">
            적용 상품: {effectiveForm.appliesTo} · 기준: {effectiveForm.autoRule}
          </div>
        </div>
      </div> : null}

      {!viewerMode ? <div className="grid gap-2 md:grid-cols-2">
          {legalFormOptions.map(item => {
        const selected = item.key === effectiveForm.key;
        return <button key={item.key} type="button" onClick={() => selectLegalForm(item.key)} disabled={disabled} className={`rounded-lg border p-3 text-left transition ${selected ? 'border-blue-400 bg-blue-50 text-blue-950' : 'border-slate-200 bg-white text-slate-600 hover:border-blue-200'} disabled:cursor-not-allowed disabled:opacity-60`}>
                <div className="flex items-center justify-between gap-2">
                  <span className="text-sm font-black">{item.label}</span>
                  <span className={`rounded-full px-2 py-1 text-[11px] font-black ${item.currentScope ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}>
                    {item.currentScope ? '자동첨부 대상' : '보관만'}
                  </span>
                </div>
                <div className="mt-2 text-xs leading-5 text-slate-500">{item.appliesTo}</div>
              </button>;
      })}
        </div> : null}

      <RealtorAutoExplanationDirectCheckPanel visible={!viewerMode && directConfirmationPanelVisible} count={directConfirmationPanelCount}>
            {directConfirmationGroups.map(group => {
        const bundleConfirmed = confirmedDirectBundleIds[group.id] || isDirectCheckBundleConfirmed(group.items);
        return <div key={group.id} className="rounded-lg border border-amber-200 bg-white p-3 md:col-span-2">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-[11px] font-black text-amber-700">{group.title}</div>
                    <div className="mt-1 text-xs leading-5 text-slate-600">{group.description}</div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${bundleConfirmed ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
                    {bundleConfirmed ? '묶음 확인 완료' : '묶음 확인'}
                  </span>
                </div>
                {!bundleConfirmed ? <>
                <div className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
                  {group.rows.map(({
                item,
                preset
              }) => {
                const selectedOption = effectiveBundleOption(preset);
                const itemStatus = effectiveBundleStatus(preset);
                return <div key={item.key} className="rounded-lg border border-amber-200 bg-amber-50/60 p-2">
                        <div className="text-[11px] font-black text-amber-700">{item.formSection || item.section}</div>
                        <div className="mt-1 text-xs font-black text-slate-950">{item.label}</div>
                        <div className="mt-2 flex flex-wrap gap-1.5">
                          {item.options?.length ? item.options.map(option => {
                      const checked = selectedOption === option.value;
                      return <label key={option.value} className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${checked ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-amber-200 bg-white text-amber-800 hover:border-amber-400'} disabled:cursor-not-allowed disabled:opacity-60`}>
                                  <input type="checkbox" checked={checked} onChange={() => updateOption(item.key, checked ? '' : option.value)} disabled={disabled} className="h-4 w-4 rounded border-amber-300 text-blue-700 focus:ring-blue-200" />
                                  {option.label}
                                </label>;
                    }) : <label className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${itemStatus === 'OK' ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-amber-300 bg-white text-amber-900 hover:border-amber-500'} disabled:cursor-not-allowed disabled:opacity-60`}>
                              <input type="checkbox" checked={itemStatus === 'OK'} onChange={() => updateStatus(item.key, itemStatus === 'OK' ? 'NEEDS_CHECK' : 'OK')} disabled={disabled} className="h-4 w-4 rounded border-amber-300 text-blue-700 focus:ring-blue-200" />
                              확인 완료
                            </label>}
                        </div>
                      </div>;
              })}
                </div>
                <div className="mt-3 flex justify-end">
                  <button type="button" onClick={() => confirmDirectCheckBundle(group.rows.map(({
                preset
              }) => preset), group.id)} disabled={disabled} className={`inline-flex h-9 items-center rounded-lg border px-3 text-xs font-black disabled:cursor-not-allowed disabled:opacity-50 ${bundleConfirmed ? 'border-emerald-200 bg-emerald-600 text-white hover:bg-emerald-700' : 'border-blue-200 bg-blue-600 text-white hover:bg-blue-700'}`} aria-pressed={bundleConfirmed}>
                    {bundleConfirmed ? '확인됨' : '확인 완료'}
                  </button>
                </div>
                </> : null}
              </div>;
      })}
            {managementFeeDirectChecks.length ? <div className="rounded-lg border border-amber-200 bg-white p-3 md:col-span-2">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-[11px] font-black text-amber-700">⑥ 관리에 관한 사항 &gt; 관리비 포함 비목</div>
                    <div className="mt-1 text-sm font-black text-slate-950">관리비 관련항목</div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${managementFeeConfirmed ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
                    {managementFeeConfirmed ? '묶음 확인 완료' : '여러 항목 선택 후 확인'}
                  </span>
                </div>
                {!managementFeeConfirmed ? <>
                <div className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
                  {managementFeeDirectChecks.map(item => {
              const checked = managementFeeChecked(item.key);
              const otherFeeItem = item.key === 'management-fee-other';
              return <div key={item.key} className="space-y-1">
                        <label className={`inline-flex h-9 w-full items-center gap-2 rounded-lg border px-3 text-xs font-black transition ${checked ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-amber-300 bg-amber-100 text-amber-900 hover:border-amber-500'} disabled:cursor-not-allowed disabled:opacity-60`}>
                          <input type="checkbox" checked={checked} onChange={() => togglePendingManagementFeeCheck(item.key)} disabled={disabled} className="h-4 w-4 rounded border-amber-300 text-blue-700 focus:ring-blue-200" />
                          {item.label.replace(/^관리비 포함 비목:\s*/u, '')}
                        </label>
                        {otherFeeItem && checked ? <input type="text" value={overlayTextValue('ef_p2_management_fee_other_item_detail')} onChange={event => updateCustomText('ef_p2_management_fee_other_item_detail', event.target.value)} disabled={disabled} placeholder="그 밖의 항목명을 입력하세요" className="h-8 w-full rounded-lg border border-slate-300 bg-white px-2 text-xs font-bold text-slate-950 outline-none placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100" /> : null}
                      </div>;
            })}
                </div>
                <div className="mt-3 flex justify-end">
                  <div className="flex flex-col items-end gap-2">
                    <label className="flex flex-col gap-1 text-xs font-black text-slate-700" htmlFor="explanation-management-fee-amount">
                      평균관리비
                      <div className="flex w-44 overflow-hidden rounded-lg border border-slate-300 bg-white focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100">
                        <input id="explanation-management-fee-amount" type="text" inputMode="numeric" value={overlayTextValue('ef_p2_management_fee_amount')} onChange={event => updateCustomText('ef_p2_management_fee_amount', event.target.value)} disabled={disabled} placeholder="금액" className="h-8 min-w-0 flex-1 bg-white px-2 text-right text-xs font-bold text-slate-950 outline-none placeholder:text-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100" />
                        <span className="inline-flex h-8 items-center border-l border-slate-200 bg-slate-50 px-2 text-[11px] font-black text-slate-600">
                          만원
                        </span>
                      </div>
                    </label>
                    <button type="button" onClick={confirmManagementFeeDirectChecks} disabled={disabled} className={`inline-flex h-9 items-center rounded-lg border px-3 text-xs font-black disabled:cursor-not-allowed disabled:opacity-50 ${managementFeeConfirmed ? 'border-emerald-200 bg-emerald-600 text-white hover:bg-emerald-700' : 'border-blue-200 bg-blue-600 text-white hover:bg-blue-700'}`} aria-pressed={managementFeeConfirmed}>
                      {managementFeeConfirmed ? '확인됨' : '확인 완료'}
                    </button>
                  </div>
                </div>
                </> : null}
              </div> : null}
            {visibleSiteGuideDirectConfirmationItem ? <div className="order-last rounded-lg border border-sky-200 bg-white p-3 md:col-span-2">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-[11px] font-black text-sky-700">현장안내자 확인</div>
                    <div className="mt-1 text-xs leading-5 text-slate-600">현장안내자는 기타 묶음과 분리해 안내자 유형과 신분고지 여부를 별도로 확인합니다.</div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${siteGuideDirectConfirmationConfirmed ? 'bg-emerald-100 text-emerald-800' : 'bg-sky-100 text-sky-800'}`}>
                    {siteGuideDirectConfirmationConfirmed ? '현장안내 확인 완료' : '현장안내 확인'}
                  </span>
                </div>
                {!siteGuideDirectConfirmationConfirmed ? <>
                    <div className="mt-3 rounded-lg border border-sky-200 bg-sky-50/70 p-2">
                      <div className="flex items-start justify-between gap-2">
                        <div className="min-w-0">
                          <div className="text-[11px] font-black text-sky-700">{visibleSiteGuideDirectConfirmationItem.formSection || visibleSiteGuideDirectConfirmationItem.section}</div>
                          <div className="mt-1 text-xs font-black text-slate-950">{visibleSiteGuideDirectConfirmationItem.label}</div>
                        </div>
                        <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${effectiveCheckStatus(visibleSiteGuideDirectConfirmationItem.key) === 'OK' ? 'bg-emerald-100 text-emerald-800' : effectiveCheckStatus(visibleSiteGuideDirectConfirmationItem.key) === 'NOT_APPLICABLE' ? 'bg-slate-100 text-slate-700' : 'bg-amber-100 text-amber-800'}`}>
                          {effectiveCheckStatus(visibleSiteGuideDirectConfirmationItem.key) === 'OK' ? '확인됨' : EXPLANATION_CHECK_STATUS_LABELS[effectiveCheckStatus(visibleSiteGuideDirectConfirmationItem.key)]}
                        </span>
                      </div>
                      <div className="mt-2 flex flex-wrap gap-1.5">
                        {visibleSiteGuideDirectConfirmationItem.options?.map(option => {
                const checked = siteGuideSelectedOption === option.value;
                return <label key={option.value} className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${checked ? 'border-blue-500 bg-white text-blue-800' : 'border-sky-200 bg-white/80 text-sky-800 hover:border-sky-400'} disabled:cursor-not-allowed disabled:opacity-60`}>
                              <input type="checkbox" checked={checked} onChange={() => updateOption(visibleSiteGuideDirectConfirmationItem.key, checked ? '' : option.value)} disabled={disabled} className="h-4 w-4 rounded border-sky-300 text-blue-700 focus:ring-blue-200" />
                              {option.label}
                            </label>;
              })}
                      </div>
                      {siteGuideNoticeNeedsDirectConfirmation && siteGuideNoticeItem ? <div className="mt-2 rounded-lg border border-blue-200 bg-white p-2">
                          <div className="text-[11px] font-black text-blue-700">중개보조원 선택 시 추가 확인</div>
                          <div className="mt-1 text-xs font-black text-slate-950">{siteGuideNoticeItem.label}</div>
                          <div className="mt-2 flex flex-wrap gap-2">
                            {siteGuideNoticeItem.options?.map(option => {
                  const checked = siteGuideNoticeSelectedOption === option.value;
                  return <label key={option.value} className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${checked ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-blue-200 bg-white text-blue-700 hover:border-blue-400'} disabled:cursor-not-allowed disabled:opacity-60`}>
                                  <input type="checkbox" checked={checked} onChange={() => updateOption(siteGuideNoticeItem.key, checked ? '' : option.value)} disabled={disabled} className="h-4 w-4 rounded border-blue-300 text-blue-700 focus:ring-blue-200" />
                                  {option.label}
                                </label>;
                })}
                          </div>
                        </div> : null}
                    </div>
                    <div className="mt-3 flex justify-end">
                      <button type="button" onClick={() => confirmDirectCheckItems(siteGuideDirectConfirmationItemsForConfirm, SITE_GUIDE_DIRECT_CONFIRMATION_BUNDLE_ID)} disabled={disabled || !siteGuideDirectConfirmationItemsForConfirm.length} className="inline-flex h-9 items-center rounded-lg border border-blue-200 bg-blue-600 px-3 text-xs font-black text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50" aria-pressed={siteGuideDirectConfirmationConfirmed}>
                        확인 완료
                      </button>
                    </div>
                  </> : null}
              </div> : null}
            {remainingDirectConfirmationChecks.length ? <div className="rounded-lg border border-amber-200 bg-white p-3 md:col-span-2">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-[11px] font-black text-amber-700">묶음 4. 기타 확인사항</div>
                    <div className="mt-1 text-xs leading-5 text-slate-600">도로, 접근성, 주차 등 나머지 직접확인 항목을 한 번에 확인합니다.</div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${remainingDirectConfirmationConfirmed ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
                    {remainingDirectConfirmationConfirmed ? '묶음 확인 완료' : '묶음 확인'}
                  </span>
                </div>
                {!remainingDirectConfirmationConfirmed ? <>
                    <div className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
                      {remainingDirectConfirmationChecks.map(item => {
              const selectedOption = effectiveCheckOption(item.key) || directCheckDefaultOption(item);
              const itemStatus = effectiveCheckStatus(item.key);
              const siteGuideNoticeItem = item.key === 'site-guide' ? checkItemByKey.get('site-guide-notice') : null;
              const siteGuideNoticeSelectedOption = siteGuideNoticeItem ? effectiveCheckOption('site-guide-notice') || directCheckDefaultOption(siteGuideNoticeItem) : '';
              return <div key={item.key} className="rounded-lg border border-amber-200 bg-amber-50/60 p-2">
                            <div className="flex items-start justify-between gap-2">
                              <div className="min-w-0">
                                <div className="text-[11px] font-black text-amber-700">{item.formSection || item.section}</div>
                                <div className="mt-1 text-xs font-black text-slate-950">{item.label}</div>
                              </div>
                              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-black ${itemStatus === 'OK' ? 'bg-emerald-100 text-emerald-800' : itemStatus === 'NOT_APPLICABLE' ? 'bg-slate-100 text-slate-700' : 'bg-amber-100 text-amber-800'}`}>
                                {itemStatus === 'OK' ? '확인됨' : EXPLANATION_CHECK_STATUS_LABELS[itemStatus]}
                              </span>
                            </div>
                            <div className="mt-2 flex flex-wrap gap-1.5">
                              {item.options?.length ? item.options.map(option => {
                    const checked = selectedOption === option.value;
                    return <label key={option.value} className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${checked ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-amber-200 bg-white text-amber-800 hover:border-amber-400'} disabled:cursor-not-allowed disabled:opacity-60`}>
                                      <input type="checkbox" checked={checked} onChange={() => updateOption(item.key, checked ? '' : option.value)} disabled={disabled} className="h-4 w-4 rounded border-amber-300 text-blue-700 focus:ring-blue-200" />
                                      {option.label}
                                    </label>;
                  }) : <label className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${itemStatus === 'OK' ? 'border-blue-500 bg-blue-50 text-blue-800' : 'border-amber-300 bg-white text-amber-900 hover:border-amber-500'} disabled:cursor-not-allowed disabled:opacity-60`}>
                                  <input type="checkbox" checked={itemStatus === 'OK'} onChange={() => updateStatus(item.key, itemStatus === 'OK' ? 'NEEDS_CHECK' : 'OK')} disabled={disabled} className="h-4 w-4 rounded border-amber-300 text-blue-700 focus:ring-blue-200" />
                                  직접확인 완료
                                </label>}
                            </div>
                            {siteGuideNoticeItem && selectedOption === 'assistant' ? <div className="mt-2 rounded-lg border border-blue-200 bg-blue-50 p-2">
                                <div className="text-[11px] font-black text-blue-700">중개보조원 선택 시 추가 확인</div>
                                <div className="mt-1 text-xs font-black text-slate-950">{siteGuideNoticeItem.label}</div>
                                <div className="mt-2 flex flex-wrap gap-2">
                                  {siteGuideNoticeItem.options?.map(option => {
                      const checked = siteGuideNoticeSelectedOption === option.value;
                      return <label key={option.value} className={`inline-flex h-8 items-center gap-2 rounded-lg border px-2.5 text-[11px] font-black transition ${checked ? 'border-blue-500 bg-white text-blue-800' : 'border-blue-200 bg-white/80 text-blue-700 hover:border-blue-400'} disabled:cursor-not-allowed disabled:opacity-60`}>
                                        <input type="checkbox" checked={checked} onChange={() => updateOption(siteGuideNoticeItem.key, checked ? '' : option.value)} disabled={disabled} className="h-4 w-4 rounded border-blue-300 text-blue-700 focus:ring-blue-200" />
                                        {option.label}
                                      </label>;
                    })}
                                </div>
                              </div> : null}
                          </div>;
            })}
                    </div>
                    <div className="mt-3 flex justify-end">
                      <button type="button" onClick={() => confirmDirectCheckItems(remainingDirectConfirmationChecks, REMAINING_DIRECT_CONFIRMATION_BUNDLE_ID)} disabled={disabled} className="inline-flex h-9 items-center rounded-lg border border-blue-200 bg-blue-600 px-3 text-xs font-black text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50" aria-pressed={remainingDirectConfirmationConfirmed}>
                        확인 완료
                      </button>
                    </div>
                  </> : null}
              </div> : null}
      </RealtorAutoExplanationDirectCheckPanel>

      {effectivePageImages.length ? <div ref={directEditSectionRef} className={viewerMode ? 'flex min-h-0 flex-1 flex-col bg-slate-950' : 'rounded-lg border border-slate-200 bg-white p-4'} data-explanation-direct-edit-section>
          <div className={viewerMode ? 'hidden' : 'flex flex-wrap items-start justify-between gap-3'}>
            {!viewerMode ? <div>
              <div className="text-sm font-black text-slate-950">{viewerMode ? '중개대상물 확인설명서' : '문서 위 직접 편집'}</div>
              <p className="mt-1 text-xs leading-5 text-slate-500">
                {viewerMode ? '현재 계약방 입력내용 기준으로 표시합니다. 확대/축소와 인쇄를 지원합니다.' : '입력칸은 확인설명서 텍스트 레이어로 저장되고, 체크박스는 문서 위에서 바로 선택됩니다. Ctrl+휠로 확대/축소할 수 있습니다.'}
              </p>
            </div> : <span className="sr-only">Explanation form viewer</span>}
            <div className={viewerMode ? 'flex items-center gap-1 rounded-lg border border-slate-700 bg-slate-900 p-1' : 'flex items-center gap-1 rounded-lg border border-slate-200 bg-slate-50 p-1'}>
              <button type="button" onClick={() => changeExplanationPreviewZoom(-0.1)} className={viewerMode ? 'inline-flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-slate-800 hover:text-blue-200' : 'inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-white hover:text-blue-700'} title="축소" aria-label="축소">
                <Minus className="h-4 w-4" aria-hidden />
              </button>
              <span className={viewerMode ? 'min-w-12 text-center text-xs font-black text-white' : 'min-w-12 text-center text-xs font-black text-slate-700'}>
                {explanationPreviewZoomPercent}%
              </span>
              <button type="button" onClick={() => changeExplanationPreviewZoom(0.1)} className={viewerMode ? 'inline-flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-slate-800 hover:text-blue-200' : 'inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-white hover:text-blue-700'} title="확대" aria-label="확대">
                <Plus className="h-4 w-4" aria-hidden />
              </button>
              <button type="button" onClick={() => {
            if (!printExplanationFormViewerPage() && typeof window !== 'undefined') {
              window.alert('인쇄할 확인설명서 페이지를 찾지 못했습니다.');
            }
          }} className={viewerMode ? 'inline-flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-slate-800 hover:text-blue-200' : 'inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-white hover:text-blue-700'} title="인쇄" aria-label="인쇄">
                <Printer className="h-4 w-4" aria-hidden />
              </button>
            </div>
          </div>
          {viewerMode ? embeddedViewer ? <div className="space-y-4 pb-4" data-ieum-embedded-explanation-viewer>
                {effectivePageImages.map((_, index) => renderReadOnlyExplanationPreviewPage(index + 1))}
              </div> : <IeumViewer kind="explanation" zoomLabel={`${explanationPreviewZoomPercent}%`} onZoomOut={() => changeExplanationPreviewZoom(-0.1)} onZoomIn={() => changeExplanationPreviewZoom(0.1)} onPrint={() => {
        if (!printExplanationFormViewerPage() && typeof window !== 'undefined') {
          window.alert('인쇄할 확인설명서 페이지를 찾지 못했습니다.');
        }
      }} onWheel={handleExplanationPreviewWheel} title="중개대상물 확인설명서">
              <div className="space-y-4 pb-4">
                {effectivePageImages.map((_, index) => renderReadOnlyExplanationPreviewPage(index + 1))}
              </div>
            </IeumViewer> : <div className="mt-3 grid gap-2 lg:grid-cols-[minmax(0,1fr)_54px]">
            <div className="max-h-[76vh] overflow-auto rounded-lg border border-slate-200 bg-slate-100 p-2" onWheel={handleExplanationPreviewWheel}>
              <div className="relative mx-auto" style={{
            width: `${Math.round(EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX * explanationPreviewZoom)}px`,
            minWidth: `${Math.round(EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX * explanationPreviewZoom)}px`
          }} data-explanation-print-page-source data-explanation-print-page={previewPage}>
                <img src={effectivePageImages[previewPage - 1]} alt={`${effectiveForm.title} ${previewPage}쪽`} className="w-full rounded border border-slate-200 bg-white" />
                {textOverlays.map(field => {
              const rawOverlayValue = overlayTextValue(field.key);
              const overlayValue = formatPreviewExplanationOverlayValue(field, rawOverlayValue, explanationPreviewZoom);
              const addressOverlay = explanationOverlayIsAddressField(field);
              const multilineOverlay = explanationOverlayTextIsMultiline(field, overlayValue);
              const overlayHeight = field.height;
              const overlayTop = field.top;
              const overlayFontSizePt = explanationOverlayTextFontSizePt(field, overlayValue);
              const overlayFontSize = overlayFontSizePt * EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom;
              const overlayHeightValuePx = explanationOverlayHeightPx(overlayHeight, explanationPreviewZoom);
              const overlayHeightValuePt = overlayHeightValuePx / (EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom);
              const overlayLineHeight = explanationOverlayTextLineHeightPt(field, overlayValue, overlayFontSizePt, overlayHeightValuePt) * EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom;
              const overlayTextLineCount = Math.max(1, overlayValue.split(/\r?\n/u).length);
              const overlayVerticalPadding = multilineOverlay ? Math.max(0, (overlayHeightValuePx - overlayLineHeight * overlayTextLineCount) / 2) : 0;
              const overlayHorizontalPadding = explanationOverlayNeedsWideInset(field, overlayValue) ? EXPLANATION_FORM_LEFT_TEXT_INSET_PX * explanationPreviewZoom : 2;
              const customTexts = draft.customTexts ?? {};
              const hasManualOverlayText = Object.prototype.hasOwnProperty.call(customTexts, field.key);
              const customOverlayValue = typeof customTexts[field.key] === 'string' ? customTexts[field.key] : '';
              const autoOverlayValue = autoTextDefaults[field.key] ?? '';
              const manualOverlayEdited = hasManualOverlayText && formatExplanationAddressOverlayValue(field, customOverlayValue) !== formatExplanationAddressOverlayValue(field, autoOverlayValue);
              const overlayInputClassName = ['absolute overflow-hidden rounded-[2px] border px-[2px] font-semibold text-blue-950 shadow-none outline-none placeholder:text-transparent disabled:cursor-not-allowed disabled:opacity-60', manualOverlayEdited ? 'border-rose-400/80 bg-rose-50/60 focus:border-rose-600 focus:bg-rose-50 focus:ring-1 focus:ring-rose-300' : 'border-sky-400/70 bg-sky-50/10 focus:border-blue-700 focus:bg-white/90 focus:ring-1 focus:ring-blue-400'].join(' ');
              const overlayStyle = {
                left: `${field.left}%`,
                top: `${overlayTop}%`,
                width: `${field.width}%`,
                height: `${overlayHeight}%`,
                textAlign: field.align ?? 'center',
                fontSize: `${overlayFontSize}px`,
                lineHeight: `${overlayLineHeight}px`,
                paddingLeft: `${overlayHorizontalPadding}px`,
                paddingRight: `${overlayHorizontalPadding}px`,
                paddingTop: `${overlayVerticalPadding}px`,
                paddingBottom: `${overlayVerticalPadding}px`,
                overflowWrap: multilineOverlay ? 'anywhere' : undefined,
                wordBreak: multilineOverlay ? 'keep-all' : undefined
              };
              return viewerMode ? <div key={field.key} className="absolute overflow-hidden px-[2px] font-semibold text-blue-950" title={field.label} aria-label={`${field.label} 표시`} style={overlayStyle}>
                      {overlayValue.split(/\r?\n/u).map((line, index) => <Fragment key={`${field.key}-${index}`}>
                          {index > 0 ? <br /> : null}
                          {line}
                        </Fragment>)}
                    </div> : <ExplanationOverlayTextInput key={field.key} multiline={multilineOverlay} value={overlayValue} onChange={event => updateCustomText(field.key, event.target.value)} disabled={disabled} placeholder="" ariaLabel={`${field.label} 입력`} title={field.label} className={overlayInputClassName} style={overlayStyle} minFontSizePx={explanationOverlayTextMinimumFontSizePt(field, overlayValue, multilineOverlay) * EXPLANATION_FORM_PREVIEW_PX_PER_PT * explanationPreviewZoom} />;
            })}
                {checkOverlays.map(field => {
              const overlayItem = checkItemByKey.get(field.checkKey);
              const active = isOverlayCheckActive(field);
              const directConfirmationRequired = needsDirectConfirmationInEditor(overlayItem);
              const selectedOption = effectiveCheckOption(field.checkKey);
              const directConfirmationSelected = directConfirmationRequired && (field.activeOptionValues?.length ? field.activeOptionValues.includes(selectedOption) : Boolean(field.optionValue && selectedOption === field.optionValue));
              const checkMarkSize = explanationCheckMarkSizePx(explanationPreviewZoom);
              if (viewerMode) {
                if (!active && !directConfirmationSelected) return null;
                return <span key={field.id} title={explanationCheckOverlayTitle(field, overlayItem)} className="absolute flex items-center justify-center overflow-visible text-blue-800" style={{
                  left: `${field.left}%`,
                  top: `${field.top}%`,
                  width: `${field.width ?? EXPLANATION_FORM_CHECK_HIT_WIDTH}%`,
                  height: `${field.height ?? EXPLANATION_FORM_CHECK_HIT_HEIGHT}%`,
                  transform: 'translate(-50%, -50%)'
                }}>
                        <Check className="pointer-events-none" aria-hidden style={{
                    width: `${checkMarkSize}px`,
                    height: `${checkMarkSize}px`,
                    strokeWidth: 3.6
                  }} />
                      </span>;
              }
              return <button key={field.id} type="button" onClick={() => clickOverlayCheck(field)} disabled={disabled} title={explanationCheckOverlayTitle(field, overlayItem)} aria-pressed={active || directConfirmationSelected} className={`absolute flex items-center justify-center overflow-visible rounded-[2px] border text-[0px] font-black leading-none shadow-none transition ${active ? 'border-blue-700 bg-blue-700 text-white' : directConfirmationSelected ? 'border-amber-600 bg-amber-100 text-amber-700 ring-1 ring-amber-300 hover:bg-amber-200' : directConfirmationRequired ? 'border-amber-500 bg-amber-100/85 text-amber-700 ring-1 ring-amber-300 hover:bg-amber-200/85' : 'border-blue-300 bg-white/35 text-transparent hover:bg-blue-50/75 hover:text-blue-600'} disabled:cursor-not-allowed disabled:opacity-60`} style={{
                left: `${field.left}%`,
                top: `${field.top}%`,
                width: `${field.width ?? EXPLANATION_FORM_CHECK_HIT_WIDTH}%`,
                height: `${field.height ?? EXPLANATION_FORM_CHECK_HIT_HEIGHT}%`,
                transform: 'translate(-50%, -50%)'
              }}>
                      {active || directConfirmationSelected ? <Check className="pointer-events-none" aria-hidden style={{
                  width: `${checkMarkSize}px`,
                  height: `${checkMarkSize}px`,
                  strokeWidth: 3.6
                }} /> : directConfirmationRequired ? <span className="pointer-events-none h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden /> : null}
                      ✓
                    </button>;
            })}
              </div>
            </div>
            <div className="lg:sticky lg:top-4 lg:self-start">
              <div className="flex gap-1 overflow-x-auto rounded-lg border border-slate-200 bg-slate-50 p-1 lg:flex-col lg:overflow-visible">
              {effectivePageImages.map((_, index) => <button key={index} type="button" onClick={() => setSelectedPreviewPage(index + 1)} className={`h-9 min-w-10 rounded-md border px-2 text-xs font-black lg:min-w-0 ${previewPage === index + 1 ? 'border-blue-400 bg-blue-50 text-blue-800' : 'border-slate-200 bg-white text-slate-500 hover:border-blue-200'}`}>
                  {index + 1}쪽
                </button>)}
              </div>
            </div>
          </div>}
        </div> : null}

      {!viewerMode ? <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div>
            <div className="text-sm font-black text-slate-950">자동/수동 체크값</div>
            <p className="mt-1 text-xs leading-5 text-slate-500">
              API 확정값은 자동 반영하고, API로 확정되지 않은 항목만 중개사가 직접 체크합니다.
            </p>
          </div>
          <span className="rounded-full bg-slate-100 px-2 py-1 text-[11px] font-black text-slate-500">
            한국어 원본 서식 기준
          </span>
        </div>
        <div className="mt-3 divide-y divide-slate-100">
          {regularExplanationCheckRows.map(item => {
          const itemStatus = effectiveCheckStatus(item.key);
          const selectedOption = effectiveCheckOption(item.key);
          const directConfirmationRequired = needsDirectConfirmationInEditor(item);
          const rawPdfCheckbox = isDetectedExplanationCheckKey(item.key);
          const rowStatusOptions = rawPdfCheckbox ? statusOptions.map(option => ({
            ...option,
            label: RAW_EXPLANATION_CHECK_STATUS_LABELS[option.value]
          })) : statusOptions;
          const connectionLabel = explanationCheckConnectionLabel(item);
          return <div key={item.key} className="grid gap-2 py-3 lg:grid-cols-[minmax(0,1fr)_320px]">
              <div>
                <div className={`text-xs font-black ${rawPdfCheckbox || directConfirmationRequired ? 'text-amber-700' : 'text-blue-700'}`}>{item.section}</div>
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <span className="text-sm font-black text-slate-950">{item.label}</span>
                  {rawPdfCheckbox ? <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-black text-slate-600">미연결</span> : directConfirmationRequired ? <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-black text-amber-800">직접확인</span> : null}
                </div>
                <div className={`mt-1 text-xs font-black ${rawPdfCheckbox ? 'text-amber-700' : 'text-blue-700'}`}>
                  연결 항목: {connectionLabel}
                </div>
                {item.formSection ? <div className="mt-1 text-xs font-black text-emerald-700">양식 위치: {item.formSection}</div> : null}
                <div className="mt-1 text-xs leading-5 text-slate-500">{item.automation}</div>
              </div>
              <div className="flex flex-wrap items-center gap-2 lg:justify-end">
                {item.key === 'source-documents' ? EXPLANATION_SOURCE_DOCUMENT_TYPES.map(sourceDocument => {
                const checked = hasOfficialDocumentType(officialDocuments, sourceDocument.type) || explanationSourceDocumentTypeUsedByAutomation(contract, sourceDocument.type) || explanationSourceDocumentTypeSelectedSet(item).has(sourceDocument.type);
                return <label key={sourceDocument.type} className={`inline-flex h-9 items-center gap-2 rounded-lg border px-3 text-xs font-black ${checked ? 'border-blue-300 bg-blue-50 text-blue-800' : 'border-slate-200 bg-white text-slate-600'}`}>
                        <input type="checkbox" checked={checked} onChange={() => toggleSourceDocumentType(sourceDocument.type)} disabled={disabled} className="h-4 w-4 rounded border-slate-300 text-blue-700" />
                        {sourceDocument.label}
                      </label>;
              }) : item.options?.length ? <select value={selectedOption} onChange={event => updateOption(item.key, event.target.value)} disabled={disabled} className={`h-9 min-w-[140px] rounded-lg border bg-white px-3 text-xs font-black text-slate-700 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:opacity-60 ${directConfirmationRequired ? 'border-amber-300 ring-1 ring-amber-100' : 'border-slate-200'}`}>
                    <option value="">선택 안함</option>
                    {item.options.map(option => <option key={option.value} value={option.value}>
                        {option.label}
                      </option>)}
                  </select> : null}
                {rowStatusOptions.map(option => <label key={option.value} className={`inline-flex h-9 items-center gap-2 rounded-lg border px-3 text-xs font-black ${itemStatus === option.value ? 'border-blue-300 bg-blue-50 text-blue-800' : directConfirmationRequired ? 'border-amber-200 bg-amber-50 text-amber-800' : 'border-slate-200 bg-white text-slate-600'}`}>
                    <input type="checkbox" checked={itemStatus === option.value} onChange={() => updateStatus(item.key, option.value)} disabled={disabled} className="h-4 w-4 rounded border-slate-300 text-blue-700" />
                    {option.label}
                  </label>)}
              </div>
            </div>;
        })}
        </div>
        </div> : null}
    </div>;
}
function PartyNoticeTemplatePanel({
  draft,
  onDraftChange,
  form,
  contract,
  disabled,
  showAutomationHints = false
}) {
  const metaRows = getContractPreviewMetaRows(form, contract);
  const metaValue = (label, fallback = showAutomationHints ? '계약방 저장값 자동입력' : '') => metaRows.find(row => row.label === label)?.value || fallback;
  const criticalNoticeRows = getContractCriticalNoticeRows(contract);
  const noticeItems = criticalNoticeRows.length ? criticalNoticeRows.map(row => [row.label, row.value]) : [['크리티컬 유의사항 없음', '소유주 불일치, 용도 불일치, 압류 등 즉시 확인할 필수 유의사항이 없습니다.']];
  return <div className="space-y-4" data-party-notice-template>
      <div className="rounded-lg border border-slate-200 bg-white p-5">
        <div className="border-b border-slate-200 pb-4">
          <div className="text-xs font-black text-blue-700">서명 전 당사자 확인 문서</div>
          <input value={draft.customTexts?.title || '전자계약 당사자 유의사항'} onChange={event => onDraftChange(updateTextLayerCustomText(draft, 'title', event.target.value))} disabled={disabled} className="mt-1 w-full border-0 bg-transparent text-2xl font-black text-slate-950 outline-none focus:bg-blue-50" />
          <div className="mt-2 text-sm font-semibold text-slate-500">
            {metaValue('계약 유형')} · {metaValue('계약 방식')}
          </div>
        </div>

        <div className="mt-4 grid gap-3 md:grid-cols-3">
          {[['물건지', metaValue('물건지')], ['임대인/매도인', metaValue('임대인', metaValue('매도인', ''))], ['임차인/매수인', metaValue('임차인', metaValue('매수인', ''))]].map(([label, value]) => <div key={label} className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <div className="text-[11px] font-black text-slate-500">{label}</div>
              <div className="mt-1 min-h-[20px] text-sm font-black text-slate-950">{value}</div>
            </div>)}
        </div>

        <div className="mt-4 grid gap-3">
          {noticeItems.map(([label, text], index) => <div key={label} className="grid gap-3 rounded-lg border border-slate-200 p-3 md:grid-cols-[36px_120px_minmax(0,1fr)]">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50 text-sm font-black text-blue-700">
                {index + 1}
              </div>
              <div className="self-center text-sm font-black text-slate-950">{label}</div>
              <div className="self-center text-sm leading-6 text-slate-600">{text}</div>
            </div>)}
        </div>

        <label className="mt-4 block text-xs font-black text-slate-500">
          당사자 안내 본문
          <textarea value={draft.bodyText} onChange={event => onDraftChange({
          ...draft,
          bodyText: event.target.value
        })} disabled={disabled} className="mt-2 h-28 w-full resize-none rounded-lg border border-slate-200 bg-white p-3 text-sm leading-6 text-slate-800 outline-none focus:border-blue-300" />
        </label>
        <label className="mt-3 block text-xs font-black text-slate-500">
          하단 고지
          <textarea value={draft.noticeText} onChange={event => onDraftChange({
          ...draft,
          noticeText: event.target.value
        })} disabled={disabled} className="mt-2 h-20 w-full resize-none rounded-lg border border-slate-200 bg-white p-3 text-sm leading-6 text-slate-800 outline-none focus:border-blue-300" />
        </label>
      </div>
    </div>;
}
function getContractPreviewMetaRows(form, contract) {
  const terms = asRecord(contract?.contractTerms);
  const metadata = asRecord(contract?.metadata);
  const partySummary = asRecord(contract?.partySummary);
  const partyInput = asRecord(metadata.partyInput);
  const lessorInput = asRecord(partyInput.lessorOrSeller);
  const lesseeInput = asRecord(partyInput.lesseeOrBuyer);
  const lessorSummary = asRecord(partySummary.lessorOrSeller);
  const lesseeSummary = asRecord(partySummary.lesseeOrBuyer);
  const automationFieldMap = asRecord(metadata.automationFieldMap);
  const automationSummary = asRecord(automationFieldMap.summary);
  const automationFields = asRecordArray(automationFieldMap.fields);
  const isSale = form ? isSaleContract(form) : String(contract?.contractType ?? terms.contractType ?? '').toUpperCase() === 'SALE';
  const isMonthly = form ? isMonthlyContract(form) : ['MONTHLY_RENT', 'COMMERCIAL_LEASE'].includes(String(contract?.contractType ?? terms.contractType ?? '').toUpperCase());
  const isCommercialMonthly = form ? isCommercialMonthlyContract(form) : String(contract?.propertyType ?? terms.propertyType ?? '').toUpperCase() === 'COMMERCIAL' && isMonthly;
  const address = form ? buildDisplayAddress(form) : getContractAddress(contract ?? {}) || readText(metadata, 'addressInput', '');
  const contractTypeLabel = form ? `${PROPERTY_TYPE_LABELS[form.propertyType] ?? form.propertyType} ${CONTRACT_TYPE_LABELS[form.contractType] ?? form.contractType}` : [contract?.propertyTypeLabel, contract?.contractTypeLabel || contract?.contractType].filter(Boolean).join(' ');
  const contractMethod = form ? CONTRACT_METHOD_LABELS[form.contractMethod] ?? form.contractMethod : readText(terms, 'contractMethodLabel', readText(metadata, 'contractMethodLabel', ''));
  const lessorOrSeller = form?.lessorOrSellerName || readText(lessorInput, 'name', '') || readText(lessorSummary, 'name', '');
  const lesseeOrBuyer = form?.lesseeOrBuyerName || readText(lesseeInput, 'name', '') || readText(lesseeSummary, 'name', '');
  const ownerLabel = isSale ? '매도인' : '임대인';
  const buyerLabel = isSale ? '매수인' : '임차인';
  const amountValue = (formValue, key, fallback) => previewValue(form ? amountToManwonDisplay(formValue || '') : readText(terms, key, ''), fallback);
  const directValue = (formValue, key, fallback = '') => previewValue(formValue || readText(terms, key, ''), fallback);
  const partyValue = (formValue, inputRecord, summaryRecord, key) => previewValue(formValue || readText(inputRecord, key, '') || readText(summaryRecord, key, ''), '');
  const automationValue = (...labelsOrKeys) => {
    for (const target of labelsOrKeys) {
      const normalizedTarget = target.trim();
      const field = automationFields.find(item => readText(item, 'label', '').trim() === normalizedTarget || readText(item, 'key', '').trim() === normalizedTarget);
      const value = readText(field ?? {}, 'value', '');
      if (value) return value;
    }
    for (const target of labelsOrKeys) {
      const normalizedTarget = target.trim();
      if (!normalizedTarget) continue;
      const value = firstExplanationAutoText(readExplanationAutoText(automationSummary, normalizedTarget), readExplanationAutoText(metadata, normalizedTarget), readExplanationAutoText(terms, normalizedTarget));
      if (value) return value;
    }
    return '';
  };
  const joinAutomationValues = (...values) => values.map(value => value.trim()).filter(Boolean).join(' / ');
  const labeledAutomationValue = (label, value) => value.trim() ? `${label} ${value.trim()}` : '';
  const displayLocationValue = automationValue('부동산 표시 소재지', 'displayLocation', 'objectLocation');
  const locationValue = displayLocationValue || address || automationValue('소재지', 'location', 'addressBase');
  const buildingName = automationValue('건물명', 'buildingName');
  const floorUnit = automationValue('층/호', 'floorUnit');
  const objectLocation = locationValue;
  const structureUse = joinAutomationValues(automationValue('구조', 'structure'), automationValue('주용도', 'mainUse'));
  const siteRightArea = automationValue('대지권면적', 'siteRightArea');
  const siteRightRatio = automationValue('대지권비율', 'siteRightRatio');
  const landRight = formatSiteRightDisplay(siteRightArea, siteRightRatio);
  const buildingArea = joinAutomationValues(labeledAutomationValue('전용', automationValue('전용면적', 'exclusiveArea')), labeledAutomationValue('공용', automationValue('공용면적', 'commonArea')), labeledAutomationValue('계약', automationValue('계약면적', 'contractArea')));
  const rows = [{
    label: '계약방',
    value: previewValue(contract ? getContractRoomName(contract) : '')
  }, {
    label: '물건지',
    value: previewValue(objectLocation || locationValue)
  }, {
    label: '소재지',
    value: previewValue(locationValue, '')
  }, {
    label: '부동산 표시 소재지',
    value: previewValue(objectLocation, '')
  }, {
    label: '건물명',
    value: previewValue(buildingName, '')
  }, {
    label: '층/호',
    value: previewValue(floorUnit, '')
  }, {
    label: '지목',
    value: previewValue(automationValue('토지 지목', 'landCategory'), '')
  }, {
    label: '대지권',
    value: previewValue(landRight || siteRightArea, '')
  }, {
    label: '대지권비율',
    value: previewValue(siteRightRatio, '')
  }, {
    label: '대지권 말소여부',
    value: previewValue(automationValue('대지권 말소여부', 'landRightClosedStatus'), '')
  }, {
    label: '토지면적',
    value: previewValue(automationValue('토지 면적', 'landArea'), '')
  }, {
    label: '대지면적',
    value: previewValue(automationValue('토지 면적', 'landArea'), '')
  }, {
    label: '구조용도',
    value: previewValue(structureUse, '')
  }, {
    label: '전용면적',
    value: previewValue(automationValue('전용면적', 'exclusiveArea'), '')
  }, {
    label: '공용면적',
    value: previewValue(automationValue('공용면적', 'commonArea'), '')
  }, {
    label: '계약면적',
    value: previewValue(automationValue('계약면적', 'contractArea'), '')
  }, {
    label: '건물면적',
    value: previewValue(buildingArea, '')
  }, {
    label: '총 주차대수',
    value: previewValue(automationValue('총 주차대수', 'parkingTotalCount'), '')
  }, {
    label: '주차 자주식/기계식',
    value: previewValue(automationValue('주차 자주식/기계식 요약', 'parkingTypeSummary'), '')
  }, {
    label: '주차 옥내/옥외',
    value: previewValue(automationValue('주차 옥내/옥외 요약', 'parkingLocationSummary'), '')
  }, {
    label: '주차지분 기준 전체면적',
    value: previewValue(automationValue('주차지분 기준 전체면적', 'parkingTotalArea'), '')
  }, {
    label: '주차지분 기준 내 면적',
    value: previewValue(automationValue('주차지분 기준 내 면적', 'parkingOwnArea'), '')
  }, {
    label: '예상 실사용 주차지분',
    value: previewValue(automationValue('예상 실사용 주차지분', 'parkingAreaShare'), '')
  }, {
    label: '주차 환산',
    value: previewValue(automationValue('주차 환산', 'parkingAreaShareConversion'), '')
  }, {
    label: '용도지역',
    value: previewValue(automationValue('토지이용계획 용도지역', 'landUsePlanRegion'), '')
  }, {
    label: '용도지구',
    value: previewValue(automationValue('토지이용계획 용도지구', 'landUsePlanDistrict'), '')
  }, {
    label: '용도구역',
    value: previewValue(automationValue('토지이용계획 용도구역', 'landUsePlanZone'), '')
  }, {
    label: '공법상 이용제한/거래규제',
    value: previewValue(automationValue('공법상 이용제한/거래규제', 'landUsePlanRestriction'), '')
  }, {
    label: '계약 유형',
    value: previewValue(contractTypeLabel)
  }, {
    label: '계약 방식',
    value: previewValue(contractMethod)
  }, {
    label: '계약일',
    value: previewValue(form?.contractDate || readText(terms, 'contractDate', ''), '계약일 입력')
  }, {
    label: '입주/인도일',
    value: previewValue(form?.moveInDate || readText(terms, 'moveInDate', ''), '입주일 입력')
  }, {
    label: '출력일',
    value: todayKoreanDateText()
  }, {
    label: '계약기간',
    value: directValue(form ? contractPeriodLabel(form.contractPeriodType, form.contractPeriodMonths, form.contractDate, form.contractStartDate, form.contractEndDate) : '', 'contractPeriodLabel', '계약기간 입력')
  }, {
    label: '월세 납입일',
    value: isMonthly ? directValue(form ? rentPaymentLabel(form.rentPaymentTiming, form.rentPaymentDay) : '', 'rentPaymentLabel', '월세 납입일 입력') : ''
  }, {
    label: '계약금',
    value: amountValue(form?.contractDepositAmount, 'contractDepositAmount', '계약금 입력')
  }, {
    label: '중도금',
    value: isSale ? amountValue(form?.interimPaymentAmount, 'interimPaymentAmount', '중도금 입력') : ''
  }, {
    label: '중도금일',
    value: isSale ? directValue(form?.interimPaymentDate, 'interimPaymentDate', '중도금일 입력') : ''
  }, {
    label: '잔금',
    value: amountValue(form?.balanceAmount, 'balanceAmount', '잔금 입력')
  }, {
    label: '잔금일',
    value: directValue(form ? balanceDatePaymentLabel(form.balanceDate) : '', 'balanceDate', '잔금일 입력')
  }];
  rows.push(isSale ? {
    label: '매매금액',
    value: amountValue(form?.salePriceAmount, 'salePriceAmount', '매매금액 입력')
  } : {
    label: '보증금',
    value: amountValue(form?.depositAmount, 'depositAmount', '보증금 입력')
  });
  if (isMonthly) {
    rows.push({
      label: '월세',
      value: amountValue(form?.monthlyRentAmount, 'monthlyRentAmount', '월세 입력')
    });
  }
  if (isCommercialMonthly) {
    rows.push({
      label: '권리금',
      value: amountValue(form?.premiumAmount, 'premiumAmount', '권리금 입력')
    });
  }
  rows.push({
    label: '거래예정금액',
    value: previewValue(automationValue('거래예정금액', 'expectedTransactionAmount'), '')
  }, {
    label: '취득세율',
    value: previewValue(automationValue('취득세율', 'acquisitionTaxRate'), '')
  }, {
    label: '지방교육세율',
    value: previewValue(automationValue('지방교육세율', 'localEducationTaxRate'), '')
  }, {
    label: '농어촌특별세율',
    value: previewValue(automationValue('농어촌특별세율', 'ruralSpecialTaxRate'), '')
  }, {
    label: '중개보수 상한요율',
    value: previewValue(automationValue('중개보수 상한요율', 'brokerageFeeRate'), '')
  }, {
    label: '중개보수 상한액',
    value: previewValue(automationValue('중개보수 상한액', 'brokerageFeeMax'), '')
  });
  rows.push({
    label: ownerLabel,
    value: previewValue(lessorOrSeller, '')
  }, {
    label: `${ownerLabel} 연락처`,
    value: partyValue(form?.lessorOrSellerPhone, lessorInput, lessorSummary, 'phone')
  }, {
    label: `${ownerLabel} 주소`,
    value: partyValue(form?.lessorOrSellerAddress, lessorInput, lessorSummary, 'address')
  }, {
    label: `${ownerLabel} 주민등록번호`,
    value: partyValue(form?.lessorOrSellerResidentNumber, lessorInput, lessorSummary, 'residentNumber')
  }, {
    label: `${ownerLabel} 대리인`,
    value: partyValue(form?.lessorOrSellerAgentName, lessorInput, lessorSummary, 'agentName')
  }, {
    label: `${ownerLabel} 대리인 연락처`,
    value: partyValue(form?.lessorOrSellerAgentPhone, lessorInput, lessorSummary, 'agentPhone')
  }, {
    label: `${ownerLabel} 대리인 주소`,
    value: partyValue(form?.lessorOrSellerAgentAddress, lessorInput, lessorSummary, 'agentAddress')
  }, {
    label: `${ownerLabel} 대리인 주민등록번호`,
    value: partyValue(form?.lessorOrSellerAgentResidentNumber, lessorInput, lessorSummary, 'agentResidentNumber')
  }, {
    label: buyerLabel,
    value: previewValue(lesseeOrBuyer, '')
  }, {
    label: `${buyerLabel} 연락처`,
    value: partyValue(form?.lesseeOrBuyerPhone, lesseeInput, lesseeSummary, 'phone')
  }, {
    label: `${buyerLabel} 주소`,
    value: partyValue(form?.lesseeOrBuyerAddress, lesseeInput, lesseeSummary, 'address')
  }, {
    label: `${buyerLabel} 주민등록번호`,
    value: partyValue(form?.lesseeOrBuyerResidentNumber, lesseeInput, lesseeSummary, 'residentNumber')
  }, {
    label: `${buyerLabel} 대리인`,
    value: partyValue(form?.lesseeOrBuyerAgentName, lesseeInput, lesseeSummary, 'agentName')
  }, {
    label: `${buyerLabel} 대리인 연락처`,
    value: partyValue(form?.lesseeOrBuyerAgentPhone, lesseeInput, lesseeSummary, 'agentPhone')
  }, {
    label: `${buyerLabel} 대리인 주소`,
    value: partyValue(form?.lesseeOrBuyerAgentAddress, lesseeInput, lesseeSummary, 'agentAddress')
  }, {
    label: `${buyerLabel} 대리인 주민등록번호`,
    value: partyValue(form?.lesseeOrBuyerAgentResidentNumber, lesseeInput, lesseeSummary, 'agentResidentNumber')
  });
  return rows;
}
function TemplateLivePreviewEditor({
  templateKey,
  title,
  templateLabel,
  layoutSummary,
  requiredSections,
  draft,
  onDraftChange,
  form,
  onAutoFieldChange,
  contract,
  officialDocuments,
  realtorId,
  realtorProfile: realtorProfileInput,
  disabled = false,
  viewerMode = false,
  embeddedViewer = false,
  viewerZoom,
  showAutomationHints = false,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onOpenLegalForm
}) {
  const [selectedTextFieldKey, setSelectedTextFieldKey] = useState('purposeClauseText');
  const [selectedTableKey, setSelectedTableKey] = useState('payment');
  const [selectedBoundaryUnit, setSelectedBoundaryUnit] = useState(() => templateBoundaryApiUnit('payment', 0));
  const [toolbarPreviewStyle, setToolbarPreviewStyle] = useState({});
  const [previewZoom, setPreviewZoom] = useState(1);
  const effectivePreviewZoom = viewerMode && embeddedViewer && typeof viewerZoom === 'number' ? viewerZoom : previewZoom;
  const [contractPreviewFullView, setContractPreviewFullView] = useState(false);
  const previewEditorRootRef = useRef(null);
  const selectedTextFieldKeyRef = useRef(selectedTextFieldKey);
  const selectedRangeRef = useRef(null);
  const selectedStyleTargetRef = useRef(null);
  const styleActionRef = useRef(null);
  const styleActionSeqRef = useRef(0);
  useEffect(() => {
    if (viewerMode) setContractPreviewFullView(false);
  }, [viewerMode]);
  useEffect(() => {
    selectedTextFieldKeyRef.current = selectedTextFieldKey;
  }, [selectedTextFieldKey]);
  const beginStyleAction = () => {
    if (styleActionRef.current) return;
    styleActionSeqRef.current += 1;
    styleActionRef.current = {
      id: `${templateKey || 'template'}-${Date.now()}-${styleActionSeqRef.current}`,
      baseDraft: draft
    };
  };
  const endStyleAction = () => {
    styleActionRef.current = null;
  };
  const styleActionOptions = () => styleActionRef.current ? {
    historyActionId: styleActionRef.current.id,
    historyBase: styleActionRef.current.baseDraft
  } : undefined;
  const applyRichStyleToElement = (element, patch) => {
    if (typeof patch.letterSpacingPx === 'number') element.style.letterSpacing = `${patch.letterSpacingPx}px`;
    if (typeof patch.fontSizePx === 'number') element.style.fontSize = `${patch.fontSizePx}px`;
    if (patch.color) element.style.color = patch.color;
    if (patch.backgroundColor) element.style.backgroundColor = patch.backgroundColor;
    if (typeof patch.bold === 'boolean') element.style.fontWeight = patch.bold ? '800' : '400';
    if (typeof patch.italic === 'boolean') element.style.fontStyle = patch.italic ? 'italic' : 'normal';
  };
  const isTextStylePatch = patch => typeof patch.letterSpacingPx === 'number' || typeof patch.fontSizePx === 'number' || typeof patch.color === 'string' || typeof patch.backgroundColor === 'string' || typeof patch.bold === 'boolean' || typeof patch.italic === 'boolean';
  const rangeInsideStyleTarget = activeRange => {
    const target = selectedStyleTargetRef.current;
    return Boolean(target && target.key === activeRange.key && target.element.isConnected && target.element.contains(activeRange.range.commonAncestorContainer));
  };
  const readActiveRichTextRange = () => {
    if (typeof window === 'undefined') return null;
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0 || selection.isCollapsed) return null;
    const range = selection.getRangeAt(0);
    const commonNode = range.commonAncestorContainer;
    const commonElement = commonNode.nodeType === Node.ELEMENT_NODE ? commonNode : commonNode.parentElement;
    const editor = commonElement?.closest?.('[data-template-rich-field]');
    const key = editor?.dataset.templateRichField;
    if (!editor || !key || !editor.contains(range.startContainer) || !editor.contains(range.endContainer)) return null;
    return {
      key,
      range: range.cloneRange()
    };
  };
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const captureCurrentSelection = () => {
      const activeRange = readActiveRichTextRange();
      if (!activeRange) return;
      const keepCurrentStyleTarget = rangeInsideStyleTarget(activeRange);
      selectedRangeRef.current = activeRange;
      if (!keepCurrentStyleTarget) selectedStyleTargetRef.current = null;
      if (!keepCurrentStyleTarget && !styleActionRef.current) resetToolbarPreviewStyle();
      setSelectedTextFieldKey(activeRange.key);
    };
    document.addEventListener('selectionchange', captureCurrentSelection);
    return () => document.removeEventListener('selectionchange', captureCurrentSelection);
  }, []);
  const metaRows = getContractPreviewMetaRows(form, contract);
  const metaValue = (...labels) => {
    for (const label of labels) {
      const found = metaRows.find(row => row.label === label);
      if (found?.value) return found.value;
    }
    return '';
  };
  const realtorProfile = normalizeRealtorAutoProfile(realtorId, realtorProfileInput);
  const hideSignatureReferenceValues = !form && !contract && !onAutoFieldChange;
  const signatureReferenceValue = value => hideSignatureReferenceValues ? '' : String(value ?? '').trim();
  const isSaleLike = Boolean(metaValue('매매금액')) || /매매/u.test(title);
  const ownerLabel = isSaleLike ? '매도인' : '임대인';
  const buyerLabel = isSaleLike ? '매수인' : '임차인';
  const ownerVerticalLabel = ownerLabel.split('').join('\n');
  const buyerVerticalLabel = buyerLabel.split('').join('\n');
  const ownerName = metaValue('매도인', '임대인');
  const buyerName = metaValue('매수인', '임차인');
  const ownerAgentName = firstExplanationAutoText(metaValue(`${ownerLabel} 대리인`), form?.lessorOrSellerAgentName);
  const buyerAgentName = firstExplanationAutoText(metaValue(`${buyerLabel} 대리인`), form?.lesseeOrBuyerAgentName);
  const primaryBrokerManagerName = firstExplanationAutoText(realtorProfile.licensedBrokerName, realtorProfile.representativeName);
  const coBrokerManagerName = firstExplanationAutoText(form?.coBrokerManagerName, form?.coBrokerRepresentativeName);
  const isJeonseLike = !isSaleLike && (/전세/u.test(title) || form?.contractType === 'JEONSE');
  const amountLabel = isSaleLike ? '매매 가격' : '보증금';
  const mainAmount = metaValue('매매금액', '보증금');
  const monthlyRent = metaValue('월세');
  const premiumAmount = metaValue('권리금');
  const showPaymentSideAmount = !isSaleLike && !isJeonseLike;
  const mainAmountFieldKey = isSaleLike ? 'salePriceAmount' : 'depositAmount';
  const sideAmountFieldKey = form?.propertyType === 'COMMERCIAL' && form.contractType === 'COMMERCIAL_LEASE' && premiumAmount && !monthlyRent ? 'premiumAmount' : 'monthlyRentAmount';
  const paymentSideLabel = premiumAmount && !monthlyRent ? '권리금' : '월세';
  const paymentSideDisplayLabel = textLayerCustomText(draft, 'paymentLabelFixedAmount') === '정액' ? paymentSideLabel : textLayerCustomText(draft, 'paymentLabelFixedAmount', paymentSideLabel);
  const specialTerms = stripSpecialTermsHeading(form?.specialTerms).trim();
  const noticeTextValue = stripSpecialTermsHeading(draft.noticeText || specialTerms);
  const pageTitle = textLayerCustomText(draft, 'title', title || '부동산 매매계약서') || title || '부동산 매매계약서';
  const introPrefix = textLayerCustomText(draft, 'introPrefix') || `${ownerLabel}과 ${buyerLabel}의 쌍방은 아래 표시 부동산에 관하여 다음 계약 내용과 같이 계약을 체결한다.`;
  const sectionProperty = textLayerCustomText(draft, 'sectionProperty');
  const sectionTerms = textLayerCustomText(draft, 'sectionTerms');
  const purposeClausePrefix = textLayerCustomText(draft, 'purposeClausePrefix');
  const purposeClauseSuffix = textLayerCustomText(draft, 'purposeClauseSuffix');
  const purposeClauseText = textLayerCustomText(draft, 'purposeClauseText') || `${purposeClausePrefix} ${ownerLabel}과 ${buyerLabel}${purposeClauseSuffix}`;
  const receiptText = textLayerCustomText(draft, 'receiptText');
  const closingText = textLayerCustomText(draft, 'closingText').replace('당사자 및 중개업자', `${ownerLabel}, ${buyerLabel} 및 중개업자`).replace(/\s*년\s*월\s*일\s*$/u, '');
  const closingDateTextRaw = textLayerCustomText(draft, 'closingDateText', todayKoreanDateText());
  const closingDateText = /년\s*월\s*일/u.test(closingDateTextRaw) ? todayKoreanDateText() : closingDateTextRaw;
  const promoText = textLayerCustomText(draft, 'promoText');
  const qrText = textLayerCustomText(draft, 'qrText');
  const selectedFieldOption = TEMPLATE_TEXT_FIELD_OPTIONS.find(option => option.key === selectedTextFieldKey) ?? TEMPLATE_TEXT_FIELD_OPTIONS[0];
  const selectedFieldStyle = textLayerFieldStyle(draft, selectedTextFieldKey);
  const toolbarStyle = {
    ...selectedFieldStyle,
    ...toolbarPreviewStyle
  };
  const resetToolbarPreviewStyle = () => setToolbarPreviewStyle({});
  const clampPreviewZoom = value => Math.min(2, Math.max(viewerMode ? 0.32 : 0.55, Number(value.toFixed(2))));
  const changePreviewZoom = useCallback(delta => {
    setPreviewZoom(value => clampPreviewZoom(value + delta));
  }, [viewerMode]);
  const previewZoomPercent = Math.round(effectivePreviewZoom * 100);
  useEffect(() => {
    if (!viewerMode || typeof window === 'undefined') return undefined;
    const applyMobileFitZoom = () => {
      setPreviewZoom(clampPreviewZoom(mobileViewerFitZoom(794)));
    };
    applyMobileFitZoom();
    window.addEventListener('resize', applyMobileFitZoom);
    window.visualViewport?.addEventListener('resize', applyMobileFitZoom);
    return () => {
      window.removeEventListener('resize', applyMobileFitZoom);
      window.visualViewport?.removeEventListener('resize', applyMobileFitZoom);
    };
  }, [viewerMode]);
  const enterContractPreviewFullView = () => {
    setContractPreviewFullView(true);
    setPreviewZoom(value => clampPreviewZoom(Math.min(value, 0.64)));
  };
  const handlePreviewWheel = event => {
    if (!event.ctrlKey) return;
    event.preventDefault();
    changePreviewZoom(event.deltaY < 0 ? 0.1 : -0.1);
  };
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handleDocumentZoomWheel = event => {
      if (!(event.ctrlKey || event.metaKey)) return;
      const root = previewEditorRootRef.current;
      const target = event.target;
      if (!root || !(target instanceof Node) || !root.contains(target)) return;
      event.preventDefault();
      event.stopPropagation();
      changePreviewZoom(event.deltaY < 0 ? 0.1 : -0.1);
    };
    window.addEventListener('wheel', handleDocumentZoomWheel, {
      capture: true,
      passive: false
    });
    return () => window.removeEventListener('wheel', handleDocumentZoomWheel, true);
  }, [changePreviewZoom]);
  const syncToolbarPreviewStyle = patch => {
    const targetKey = selectedStyleTargetRef.current?.key ?? selectedRangeRef.current?.key ?? selectedTextFieldKeyRef.current;
    setToolbarPreviewStyle(style => ({
      ...style,
      ...patch
    }));
    if (typeof window === 'undefined') return;
    window.requestAnimationFrame(() => {
      const currentKey = selectedStyleTargetRef.current?.key ?? selectedRangeRef.current?.key ?? selectedTextFieldKeyRef.current;
      if (currentKey !== targetKey) return;
      setToolbarPreviewStyle(style => ({
        ...style,
        ...patch
      }));
    });
  };
  const captureTextSelection = key => {
    setSelectedTextFieldKey(key);
    if (typeof window === 'undefined') return;
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      selectedRangeRef.current = null;
      selectedStyleTargetRef.current = null;
      return;
    }
    const range = selection.getRangeAt(0);
    const editor = document.querySelector(`[data-template-rich-field="${key}"]`);
    if (!editor || !editor.contains(range.commonAncestorContainer)) {
      selectedRangeRef.current = null;
      selectedStyleTargetRef.current = null;
      return;
    }
    if (range.collapsed) {
      selectedRangeRef.current = null;
      selectedStyleTargetRef.current = null;
      return;
    }
    selectedRangeRef.current = {
      key,
      range: range.cloneRange()
    };
    if (!rangeInsideStyleTarget({
      key,
      range
    })) {
      selectedStyleTargetRef.current = null;
      if (!styleActionRef.current) resetToolbarPreviewStyle();
    }
  };
  const applySelectionRichStyle = (patch, options) => {
    if (typeof window === 'undefined') return false;
    const existingTarget = selectedStyleTargetRef.current;
    if (existingTarget) {
      const targetEditor = document.querySelector(`[data-template-rich-field="${existingTarget.key}"]`);
      if (targetEditor?.contains(existingTarget.element)) {
        applyRichStyleToElement(existingTarget.element, patch);
        const next = normalizeTemplateRichHtmlFromElement(targetEditor, {
          preserveLineBreaks: true
        });
        onDraftChange(updateTextLayerRichText(draft, existingTarget.key, next.html, next.text), options);
        setSelectedTextFieldKey(existingTarget.key);
        return true;
      }
      selectedStyleTargetRef.current = null;
    }
    const saved = selectedRangeRef.current ?? readActiveRichTextRange();
    if (!saved || saved.range.collapsed) return false;
    const editor = document.querySelector(`[data-template-rich-field="${saved.key}"]`);
    if (!editor || !editor.contains(saved.range.commonAncestorContainer)) return false;
    setSelectedTextFieldKey(saved.key);
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(saved.range);
    const span = document.createElement('span');
    applyRichStyleToElement(span, patch);
    try {
      saved.range.surroundContents(span);
    } catch {
      const content = saved.range.extractContents();
      span.appendChild(content);
      saved.range.insertNode(span);
    }
    const next = normalizeTemplateRichHtmlFromElement(editor, {
      preserveLineBreaks: true
    });
    const nextRange = document.createRange();
    nextRange.selectNodeContents(span);
    selectedRangeRef.current = {
      key: saved.key,
      range: nextRange.cloneRange()
    };
    selectedStyleTargetRef.current = {
      key: saved.key,
      element: span
    };
    selection?.removeAllRanges();
    selection?.addRange(nextRange);
    onDraftChange(updateTextLayerRichText(draft, saved.key, next.html, next.text), options);
    return true;
  };
  const updateSelectedFieldStyle = (patch, options) => {
    if (isTextStylePatch(patch)) {
      return applySelectionRichStyle(patch, options);
    }
    onDraftChange(updateTextLayerFieldStyle(draft, selectedTextFieldKey, patch), options);
    return true;
  };
  const changeToolbarStyle = patch => {
    syncToolbarPreviewStyle(patch);
    beginStyleAction();
    const applied = updateSelectedFieldStyle(patch, styleActionOptions());
    if (!applied) endStyleAction();
  };
  const applyDiscreteToolbarStyle = patch => {
    syncToolbarPreviewStyle(patch);
    beginStyleAction();
    updateSelectedFieldStyle(patch, styleActionOptions());
    endStyleAction();
  };
  const selectTable = key => {
    resetToolbarPreviewStyle();
    setSelectedTableKey(key);
    setSelectedBoundaryUnit(templateBoundaryApiUnit(key, 0));
  };
  const editFieldProps = (key, includeWidth = true) => ({
    onFocus: () => {
      resetToolbarPreviewStyle();
      setSelectedTextFieldKey(key);
    },
    onSelectionCapture: () => captureTextSelection(key),
    style: templateFieldInlineStyle(textLayerFieldStyle(draft, key), includeWidth),
    htmlValue: textLayerRichText(draft, key),
    onHtmlChange: (html, text) => onDraftChange(updateTextLayerRichText(draft, key, html, text)),
    fieldKey: key
  });
  const propertyTableLayout = textLayerTableLayout(draft, 'property');
  const paymentTableLayout = textLayerTableLayout(draft, 'payment');
  const partyTableLayout = textLayerTableLayout(draft, 'party');
  const propertyColumnWidths = propertyTableLayout.columnWidths;
  const paymentColumnWidths = paymentTableLayout.columnWidths;
  const partyColumnWidths = partyTableLayout.columnWidths;
  const updateTableBoundaryPosition = (key, segmentKey, leftPct) => {
    const currentLayout = textLayerTableLayout(draft, key);
    onDraftChange(updateTextLayerTableLayout(draft, key, {
      boundaryPositions: {
        ...currentLayout.boundaryPositions,
        [segmentKey]: leftPct
      }
    }));
  };
  const updateTableWidths = (key, columnWidths) => {
    onDraftChange(updateTextLayerTableLayout(draft, key, {
      columnWidths
    }));
  };
  const defaultTextLayerDisplayText = (fallback, key) => {
    if (key === 'title') return title || '부동산 매매계약서';
    if (key === 'introPrefix') {
      return `${ownerLabel}과 ${buyerLabel}의 쌍방은 아래 표시 부동산에 관하여 다음 계약 내용과 같이 계약을 체결한다.`;
    }
    if (key === 'purposeClauseText') {
      return `${textLayerCustomText(fallback, 'purposeClausePrefix')} ${ownerLabel}과 ${buyerLabel}${textLayerCustomText(fallback, 'purposeClauseSuffix')}`;
    }
    if (key === 'closingText') {
      return textLayerCustomText(fallback, 'closingText').replace('당사자 및 중개업자', `${ownerLabel}, ${buyerLabel} 및 중개업자`).replace(/\s*년\s*월\s*일\s*$/u, '');
    }
    return textLayerCustomText(fallback, key);
  };
  const resetSelectedTemplateArea = () => {
    const fallback = normalizeTextLayerDraft(getTemplateDraftFallback(templateKey || ''), createEmptyTextLayerDraft());
    const defaultText = textLayerCustomText(fallback, selectedTextFieldKey);
    const defaultDisplayText = defaultTextLayerDisplayText(fallback, selectedTextFieldKey);
    const nextCustomTexts = {
      ...(draft.customTexts ?? {})
    };
    const nextRichTexts = {
      ...(draft.richTexts ?? {})
    };
    const nextFieldStyles = {
      ...(draft.fieldStyles ?? {})
    };
    const nextTableLayouts = {
      ...(draft.tableLayouts ?? {})
    };
    nextCustomTexts[selectedTextFieldKey] = defaultText;
    delete nextRichTexts[selectedTextFieldKey];
    nextFieldStyles[selectedTextFieldKey] = textLayerFieldStyle(fallback, selectedTextFieldKey);
    nextTableLayouts[selectedTableKey] = DEFAULT_TEMPLATE_TABLE_LAYOUTS[selectedTableKey];
    selectedRangeRef.current = null;
    selectedStyleTargetRef.current = null;
    resetToolbarPreviewStyle();
    if (typeof document !== 'undefined') {
      const editor = document.querySelector(`[data-template-rich-field="${selectedTextFieldKey}"]`);
      if (editor) editor.innerHTML = escapeTemplateRichText(defaultDisplayText);
      window.getSelection()?.removeAllRanges();
    }
    onDraftChange({
      ...draft,
      customTexts: nextCustomTexts,
      richTexts: nextRichTexts,
      fieldStyles: nextFieldStyles,
      tableLayouts: nextTableLayouts
    });
  };
  if (isExplanationTemplateKey(templateKey)) {
    return <LegalExplanationFormPanel draft={draft} onDraftChange={onDraftChange} form={form} contract={contract} officialDocuments={officialDocuments} realtorProfile={realtorProfile} disabled={disabled} onOpenLegalForm={onOpenLegalForm} />;
  }
  if (templateKey === 'PARTY_NOTICE') {
    return <PartyNoticeTemplatePanel draft={draft} onDraftChange={onDraftChange} form={form} contract={contract} disabled={disabled} showAutomationHints={showAutomationHints} />;
  }
  const memberQrRealtorId = String(realtorId || '').trim();
  const qrImageUrl = buildMemberQrImageUrl(memberQrRealtorId);
  const ieumLogoSrc = publicRealtorAutoRoute('/logo-ieum-header.png');
  const fieldClass = 'h-full min-h-[18px] w-full resize-none border-0 bg-transparent px-1 py-0.5 text-[10px] leading-[1.15] text-slate-950 outline-none placeholder:text-slate-300 focus:bg-blue-50';
  const inputClass = 'h-full min-h-[18px] w-full border-0 bg-transparent px-1 py-0.5 text-[10px] leading-[1.15] text-slate-950 outline-none placeholder:text-slate-300 focus:bg-blue-50';
  const amountInputClass = 'h-full min-h-[18px] w-full border-0 bg-transparent px-1 py-0.5 text-[12px] font-black leading-[1.15] text-slate-950 outline-none placeholder:text-slate-300 focus:bg-blue-50';
  const signatureInputClass = 'contract-signature-auto-value h-full min-h-0 w-full border-0 bg-transparent px-[2px] py-0 text-[6px] leading-none text-slate-950 outline-none placeholder:text-slate-300 focus:bg-blue-50';
  const syncableAutoFieldProps = (key, value, options) => ({
    value,
    onChange: onAutoFieldChange ? nextValue => {
      let normalized = nextValue;
      if (options?.amount) normalized = amountToManwonInput(normalized);
      if (options?.phone) normalized = formatPhoneNumber(normalized);
      if (options?.residentNumber) normalized = formatResidentNumber(normalized);
      if (key === 'rentPaymentDay') {
        const day = normalized.match(/\d{1,2}/u)?.[0] ?? '';
        if (/선불/u.test(normalized)) onAutoFieldChange('rentPaymentTiming', '선불');
        if (/후불/u.test(normalized)) onAutoFieldChange('rentPaymentTiming', '후불');
        normalized = day;
      }
      if (key === 'balanceDate') normalized = dateTextToInputValue(normalized);
      if (key === 'contractPeriodMonths') {
        const year = normalized.match(/\((\d+)\s*년\)/u)?.[1] ?? (/^\s*\d+\s*년\s*$/u.test(normalized) ? normalized.match(/(\d+)\s*년/u)?.[1] : undefined);
        const months = normalized.match(/\((\d+)\s*개월\)/u)?.[1] ?? normalized.match(/단기\s*(\d+)\s*개월/u)?.[1] ?? (/^\s*\d+\s*개월\s*$/u.test(normalized) ? normalized.match(/(\d+)\s*개월/u)?.[1] : undefined);
        const yearOption = CONTRACT_PERIOD_YEAR_OPTIONS.find(option => String(option.years) === year);
        if (yearOption) onAutoFieldChange('contractPeriodType', yearOption.value);else if (months) onAutoFieldChange('contractPeriodType', DIRECT_CONTRACT_PERIOD_TYPE);
        normalized = months ?? '';
      }
      onAutoFieldChange(key, normalized);
    } : undefined,
    fieldKey: `auto-${String(key)}`
  });
  const TemplateAutomationLockedField = props => <AutomationLockedField {...props} showHint={showAutomationHints} />;
  const tableCell = 'border border-black px-1 py-0.5 align-middle';
  const labelCell = `${tableCell} bg-[#dff7f7] text-center font-bold`;
  const signatureBaseCell = 'border border-black px-[2px] py-0 align-middle';
  const signatureLabelCell = `${signatureBaseCell} bg-[#dff7f7] text-center text-[6px] font-bold leading-none`;
  const signatureLongLabelCell = `${signatureLabelCell} whitespace-pre-line leading-[0.95]`;
  const signatureResidentLabelCell = `${signatureLongLabelCell} text-[8px]`;
  const signatureSmallLabelCell = `${signatureBaseCell} whitespace-nowrap text-center text-[6px] font-bold leading-none`;
  const signatureSealCell = `${signatureBaseCell} whitespace-nowrap text-center align-middle text-[6px] font-bold`;
  const brokerValueCell = `${signatureBaseCell} px-[2px] text-left`;
  const brokerSealCell = `${signatureBaseCell} whitespace-nowrap text-center align-middle text-[6px] font-bold`;
  const signatureAgentDividerRow = '[&>*]:border-t-2 [&>*]:border-t-black';
  const signatureOwnerRowClass = 'h-[23.2px]';
  const signatureBrokerRowClass = 'h-[22.4px]';
  const brokerVerticalClass = 'flex h-full w-full items-center justify-center whitespace-pre-line text-center text-[11px] font-bold leading-[1.65]';
  const signatureSealEditorClass = 'flex h-full w-full items-center justify-center text-center text-[6px] font-bold leading-none';
  const smallLabelEditorClass = 'h-full w-full !whitespace-nowrap text-center text-[6px] font-bold leading-none';
  const twoLineLabelEditorClass = 'flex h-full w-full items-center justify-center overflow-hidden whitespace-pre-line text-center text-[8px] font-bold leading-[0.95]';
  const brokerLongLabelEditorClass = twoLineLabelEditorClass;
  const brokerValueEditorClass = 'h-full w-full overflow-hidden text-ellipsis !whitespace-nowrap text-center text-[6px] font-bold leading-none';
  const sectionBar = 'border border-black bg-[#d6ffd2] px-1 py-0.5 text-[10px] font-bold leading-tight';
  const editStaticText = (key, fallback, className = 'h-[15px] w-full text-center text-[10px] font-bold leading-tight') => <TemplateInlineTextEditor value={textLayerCustomText(draft, key, fallback)} onChange={value => onDraftChange(updateTextLayerCustomText(draft, key, value))} htmlValue={textLayerRichText(draft, key, fallback)} onHtmlChange={(html, text) => onDraftChange(updateTextLayerRichText(draft, key, html, text))} disabled={disabled} className={className} onFocus={() => setSelectedTextFieldKey(key)} onSelectionCapture={() => captureTextSelection(key)} style={templateFieldInlineStyle(textLayerFieldStyle(draft, key), false)} fieldKey={key} />;
  const editVerticalStaticText = (key, fallback, className = brokerVerticalClass) => {
    const value = textLayerCustomText(draft, key, fallback);
    return <TemplateInlineTextEditor value={value.includes('\n') ? value : value.split('').join('\n')} onChange={nextValue => onDraftChange(updateTextLayerCustomText(draft, key, nextValue))} disabled={disabled} className={className} onFocus={() => setSelectedTextFieldKey(key)} onSelectionCapture={() => captureTextSelection(key)} style={templateFieldInlineStyle(textLayerFieldStyle(draft, key), false)} fieldKey={key} />;
  };
  const renderDynamicVerticalLabel = (key, value, className = brokerVerticalClass) => <TemplateInlineTextEditor value={value.includes('\n') ? value : value.split('').join('\n')} onChange={() => undefined} disabled className={className} style={templateFieldInlineStyle(textLayerFieldStyle(draft, key), false)} fieldKey={key} />;
  const handlePrint = () => {
    if (typeof window === 'undefined') return;
    if (!printContractTemplateSheet()) window.print();
  };
  const toolbarLetterSpacing = Number(toolbarStyle.letterSpacingPx ?? 0);
  const toolbarFontSize = Number(toolbarStyle.fontSizePx ?? 10);
  const toolbarColor = toolbarStyle.color || '#000000';
  const toolbarBackgroundColor = toolbarStyle.backgroundColor || '#ffffff';
  const toolbarBold = Boolean(toolbarStyle.bold);
  const toolbarItalic = Boolean(toolbarStyle.italic);
  const finishStyleSliderAction = () => endStyleAction();
  const contractPreviewViewerShell = viewerMode || contractPreviewFullView;
  const renderContractPreviewFrame = children => {
    if (viewerMode && embeddedViewer) {
      return <div className="relative z-10 overflow-visible bg-slate-950 print:overflow-visible print:bg-white" onWheel={undefined} data-ieum-embedded-contract-viewer>
          {children}
        </div>;
    }
    if (contractPreviewViewerShell) {
      return <IeumViewer kind="contract" zoomLabel={`${previewZoomPercent}%`} onZoomOut={() => changePreviewZoom(-0.1)} onZoomIn={() => changePreviewZoom(0.1)} onPrint={handlePrint} onWheel={handlePreviewWheel} onClose={!viewerMode ? () => setContractPreviewFullView(false) : undefined} modal={contractPreviewFullView && !viewerMode} title="계약서">
          {children}
        </IeumViewer>;
    }
    return <div className="relative z-50 overflow-auto rounded-lg border border-slate-200 bg-slate-100 p-3 print:overflow-visible print:border-0 print:bg-white print:p-0" onWheel={handlePreviewWheel} data-contract-preview-shell>
        {children}
      </div>;
  };
  return <div ref={previewEditorRootRef} className={viewerMode ? 'flex min-h-0 flex-1 flex-col' : 'space-y-3'} data-template-live-preview-editor>
      <style>{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          html, body {
            width: 210mm !important;
            min-height: 297mm !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            background: #fff !important;
          }
          body[data-realtorauto-print-mode="contract-template"] > *:not([data-contract-print-clone]) {
            display: none !important;
          }
          [data-contract-print-clone] {
            display: flex !important;
            position: relative !important;
            width: 210mm !important;
            min-width: 210mm !important;
            max-width: 210mm !important;
            min-height: 297mm !important;
            height: 297mm !important;
            max-height: 297mm !important;
            padding: 15mm 10mm !important;
            margin: 0 !important;
            overflow: hidden !important;
            box-shadow: none !important;
            transform: none !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          [data-contract-print-clone],
          [data-contract-print-clone] * {
            visibility: visible !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          [data-contract-print-clone] textarea,
          [data-contract-print-clone] input {
            overflow: hidden !important;
          }
        }
        [data-contract-print-sheet], [data-contract-print-sheet] *,
        [data-contract-print-clone], [data-contract-print-clone] * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        [data-contract-print-sheet] [data-ieum-contract-qr-slot],
        [data-contract-print-clone] [data-ieum-contract-qr-slot] {
          width: 66px !important;
          min-width: 66px !important;
          max-width: 66px !important;
          height: 66px !important;
          min-height: 66px !important;
          max-height: 66px !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }
        [data-contract-print-sheet] [data-member-qr-image],
        [data-contract-print-clone] [data-member-qr-image] {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          height: 100% !important;
          max-height: 100% !important;
          object-fit: contain !important;
        }
        [data-ieum-embedded-contract-viewer] [data-template-boundary-api-unit],
        [data-ieum-embedded-contract-viewer] [data-template-boundary-align-guide] {
          display: none !important;
        }
        [data-ieum-embedded-contract-viewer] input,
        [data-ieum-embedded-contract-viewer] textarea,
        [data-ieum-embedded-contract-viewer] select,
        [data-ieum-embedded-contract-viewer] button {
          pointer-events: none !important;
        }
      `}</style>
      {!viewerMode ? <div className="sticky top-0 z-40 rounded-lg border border-slate-200 bg-white/95 p-3 shadow-lg backdrop-blur print:hidden" data-template-document-toolbar>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <div className="text-sm font-black text-slate-950">문서 편집</div>
            <div className="mt-0.5 text-xs font-semibold text-slate-500">
              텍스트를 드래그해 선택한 뒤 글자 크기, 자간, 색상, 굵기, 기울임을 적용합니다.
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {onUndo ? <button type="button" onClick={onUndo} disabled={!canUndo || disabled} className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-40" title="실행 취소 (Ctrl+Z)">
                <Undo2 className="h-4 w-4" aria-hidden />
              </button> : null}
            {onRedo ? <button type="button" onClick={onRedo} disabled={!canRedo || disabled} className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-40" title="다시 실행 (Ctrl+Y / Ctrl+Shift+Z)">
                <Redo2 className="h-4 w-4" aria-hidden />
              </button> : null}
            <button type="button" onClick={() => applyDiscreteToolbarStyle({
            bold: !toolbarBold
          })} disabled={disabled} className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border text-sm font-black transition disabled:cursor-not-allowed disabled:opacity-40 ${toolbarBold ? 'border-blue-600 bg-blue-600 text-white shadow-sm' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-700'}`} title="굵게" aria-pressed={toolbarBold}>
              <Bold className="h-4 w-4" aria-hidden />
            </button>
            <button type="button" onClick={() => applyDiscreteToolbarStyle({
            italic: !toolbarItalic
          })} disabled={disabled} className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border text-sm font-black transition disabled:cursor-not-allowed disabled:opacity-40 ${toolbarItalic ? 'border-blue-600 bg-blue-600 text-white shadow-sm' : 'border-slate-300 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-700'}`} title="기울임" aria-pressed={toolbarItalic}>
              <Italic className="h-4 w-4" aria-hidden />
            </button>
            <button type="button" onClick={resetSelectedTemplateArea} disabled={disabled} className="inline-flex h-9 items-center justify-center rounded-lg border border-slate-300 bg-white px-3 text-xs font-black text-slate-700 hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-40" title="선택한 텍스트/표 영역을 템플릿 최초값으로 되돌립니다.">
              선택 초기화
            </button>
            <button type="button" onClick={handlePrint} className="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 text-xs font-black text-slate-700 hover:border-blue-300 hover:text-blue-700" title="현재 계약서를 인쇄합니다.">
              <Printer className="h-4 w-4" aria-hidden />
              인쇄
            </button>
            <button type="button" onClick={enterContractPreviewFullView} className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-700 hover:border-blue-300 hover:text-blue-700" title="전체보기" aria-label="전체보기">
              <Search className="h-4 w-4" aria-hidden />
            </button>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap items-end gap-3">
          <label className="min-w-[210px] flex-[1_1_230px] text-xs font-bold text-slate-600">
            선택 영역
            <div className="mt-1 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-black text-slate-900">
              {selectedFieldOption.label}
            </div>
          </label>
          <label className="min-w-[170px] flex-[1_1_190px] text-xs font-bold text-slate-600">
            자간 {toolbarLetterSpacing.toFixed(1)}px
            <input type="range" min="-3" max="3" step="0.1" value={toolbarLetterSpacing} onPointerDown={beginStyleAction} onPointerUp={finishStyleSliderAction} onMouseUp={finishStyleSliderAction} onTouchEnd={finishStyleSliderAction} onBlur={finishStyleSliderAction} onChange={event => changeToolbarStyle({
            letterSpacingPx: Number(event.currentTarget.value)
          })} disabled={disabled} className="mt-2 w-full accent-blue-600" />
          </label>
          <label className="min-w-[150px] flex-[1_1_170px] text-xs font-bold text-slate-600">
            글자 {toolbarFontSize}px
            <input type="range" min="7" max="24" step="1" value={toolbarFontSize} onPointerDown={beginStyleAction} onPointerUp={finishStyleSliderAction} onMouseUp={finishStyleSliderAction} onTouchEnd={finishStyleSliderAction} onBlur={finishStyleSliderAction} onChange={event => changeToolbarStyle({
            fontSizePx: Number(event.currentTarget.value)
          })} disabled={disabled} className="mt-2 w-full accent-blue-600" />
          </label>
          <div className="grid min-w-[170px] flex-[0.8_1_180px] grid-cols-2 gap-2">
            <label className="text-xs font-bold text-slate-600">
              글자색
              <input type="color" value={toolbarColor} onChange={event => applyDiscreteToolbarStyle({
              color: event.currentTarget.value
            })} disabled={disabled} className="mt-1 h-9 w-full rounded-lg border border-slate-300 bg-white p-1" />
            </label>
            <label className="text-xs font-bold text-slate-600">
              배경색
              <input type="color" value={toolbarBackgroundColor} onChange={event => applyDiscreteToolbarStyle({
              backgroundColor: event.currentTarget.value
            })} disabled={disabled} className="mt-1 h-9 w-full rounded-lg border border-slate-300 bg-white p-1" />
            </label>
          </div>
          <div className="min-w-[150px] flex-[0_0_150px] text-xs font-bold text-slate-600">
            확대
            <div className="mt-1 flex h-9 items-center justify-between rounded-lg border border-slate-300 bg-white px-1 text-slate-700">
              <button type="button" onClick={() => changePreviewZoom(-0.1)} className="inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-slate-100 hover:text-blue-700" title="축소" aria-label="축소">
                <Minus className="h-4 w-4" aria-hidden />
              </button>
              <span className="min-w-12 text-center text-xs font-black text-slate-700">{previewZoomPercent}%</span>
              <button type="button" onClick={() => changePreviewZoom(0.1)} className="inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-slate-100 hover:text-blue-700" title="확대" aria-label="확대">
                <Plus className="h-4 w-4" aria-hidden />
              </button>
            </div>
          </div>
        </div>
        </div> : null}

      {renderContractPreviewFrame(<div className="mx-auto" style={{
        width: `${794 * effectivePreviewZoom}px`,
        height: `${1123 * effectivePreviewZoom}px`
      }}>
          <div className="relative flex w-[794px] origin-top-left flex-col overflow-hidden bg-white px-[38px] py-[57px] text-black shadow-sm ring-1 ring-slate-200" style={{
          height: 1123,
          minHeight: 1123,
          fontFamily: 'Dotum, Gulim, Arial, sans-serif',
          fontSize: 10,
          lineHeight: 1.12,
          transform: `scale(${effectivePreviewZoom})`
        }} data-contract-print-sheet>
        <TemplateInlineTextEditor value={pageTitle.replace(/\s+/g, ' ')} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'title', value))} disabled={disabled} className="mb-2 h-8 w-full text-center text-[23px] font-black tracking-[0.42em]" placeholder={title} {...editFieldProps('title', false)} />

        <div className={sectionBar}>
          <TemplateInlineTextEditor value={introPrefix} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'introPrefix', value))} disabled={disabled} className="block h-[15px] text-[10px] font-bold leading-tight" {...editFieldProps('introPrefix')} />
        </div>
        <div className={sectionBar}>
          <TemplateInlineTextEditor value={sectionProperty} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'sectionProperty', value))} disabled={disabled} className="h-[15px] w-full text-[10px] font-bold leading-tight" {...editFieldProps('sectionProperty', false)} />
        </div>
        <TemplateResizableTableFrame tableKey="property" activeTableKey={selectedTableKey} widths={propertyColumnWidths} boundaryPositions={propertyTableLayout.boundaryPositions} onBoundaryPositionChange={(segmentKey, leftPct) => updateTableBoundaryPosition('property', segmentKey, leftPct)} onActivate={selectTable} onBoundarySelect={setSelectedBoundaryUnit}>
        <table className="block w-full border-collapse text-[10px] leading-[1.12]">
          <tbody className="block">
            <TemplateGridRow rowIndex={0} widths={propertyColumnWidths} boundaryPositions={propertyTableLayout.boundaryPositions} spans={[1, 7]}>
              <td className={`${labelCell} w-[62px]`}>{editStaticText('propertyLabelAddress', '소재지')}</td>
              <td className={`${tableCell} h-[44px]`} colSpan={7}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('address', form ? buildDisplayAddress(form) : metaValue('부동산 표시 소재지', '물건지'))} className={fieldClass} placeholder="주소 / 건물명 / 층·호" title="소재지, 건물명, 층/호" multiline />
              </td>
            </TemplateGridRow>
            <TemplateGridRow rowIndex={1} widths={propertyColumnWidths} boundaryPositions={propertyTableLayout.boundaryPositions} spans={[1, 1, 2, 1, 1, 1, 1]}>
              <td className={labelCell}>{editStaticText('propertyLabelLand', '토지')}</td>
              <td className={`${tableCell} w-[64px] text-center`}>{editStaticText('propertyLabelLandCategory', '지목')}</td>
              <td className={tableCell} colSpan={2}>
                <TemplateAutomationLockedField value={metaValue('지목')} className={inputClass} placeholder="지목" title="토지 지목" />
              </td>
              <td className={`${tableCell} w-[64px] text-center`}>{editStaticText('propertyLabelLandRight', '대지권')}</td>
              <td className={tableCell}>
                <TemplateAutomationLockedField value={metaValue('대지권')} className={inputClass} placeholder="대지권면적/비율/상태" title="대지권면적, 대지권비율, 말소여부" />
              </td>
              <td className={`${tableCell} w-[54px] text-center`}>{editStaticText('propertyLabelLandArea', '면적')}</td>
              <td className={tableCell}>
                <TemplateAutomationLockedField value={metaValue('토지면적', '대지면적')} className={inputClass} placeholder="m²" title="토지/대지면적" />
              </td>
            </TemplateGridRow>
            <TemplateGridRow rowIndex={2} widths={propertyColumnWidths} boundaryPositions={propertyTableLayout.boundaryPositions} spans={[1, 1, 3, 1, 2]}>
              <td className={labelCell}>{editStaticText('propertyLabelBuilding', '건물')}</td>
              <td className={`${tableCell} text-center`}>{editStaticText('propertyLabelStructureUsage', '구조용도')}</td>
              <td className={tableCell} colSpan={3}>
                <TemplateAutomationLockedField value={metaValue('구조용도')} className={inputClass} placeholder="구조/용도" title="건물 구조/용도" />
              </td>
              <td className={`${tableCell} text-center`}>{editStaticText('propertyLabelBuildingArea', '면적')}</td>
              <td className={tableCell} colSpan={2}>
                <TemplateAutomationLockedField value={metaValue('건물면적', '전용면적', '계약면적')} className={inputClass} placeholder="전용/공용/계약면적" title="전용면적, 공용면적, 계약면적" />
              </td>
            </TemplateGridRow>
          </tbody>
        </table>
        </TemplateResizableTableFrame>

        <div className={sectionBar}>
          <TemplateInlineTextEditor value={sectionTerms} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'sectionTerms', value))} disabled={disabled} className="h-[15px] w-full text-[10px] font-bold leading-tight" {...editFieldProps('sectionTerms', false)} />
        </div>
        <div className={sectionBar}>
          <TemplateInlineTextEditor value={purposeClauseText} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'purposeClauseText', value))} disabled={disabled} className="block h-[15px] text-[10px] font-bold leading-tight" {...editFieldProps('purposeClauseText')} />
        </div>
        <TemplateResizableTableFrame tableKey="payment" activeTableKey={selectedTableKey} widths={paymentColumnWidths} boundaryPositions={paymentTableLayout.boundaryPositions} onBoundaryPositionChange={(segmentKey, leftPct) => updateTableBoundaryPosition('payment', segmentKey, leftPct)} onActivate={selectTable} onBoundarySelect={setSelectedBoundaryUnit}>
        <table className="block w-full border-collapse text-[10px] leading-[1.12]">
          <tbody className="block">
            <TemplateGridRow rowIndex={0} widths={paymentColumnWidths} boundaryPositions={paymentTableLayout.boundaryPositions} spans={showPaymentSideAmount ? [1, 1, 3, 1, 2] : [1, 1, 6]}>
              <td className={`${labelCell} w-[72px]`}>{editStaticText('paymentLabelAmount', amountLabel)}</td>
              <td className={`${tableCell} w-[26px] text-center`}>{editStaticText('paymentLabelMainMoney', '금')}</td>
              <td className={tableCell} colSpan={showPaymentSideAmount ? 3 : 6}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps(mainAmountFieldKey, mainAmount, {
                      amount: true
                    })} className={amountInputClass} placeholder={`자동입력: ${amountLabel}`} title="매매 가격/보증금" />
              </td>
              {showPaymentSideAmount ? <td className={`${tableCell} w-[44px] text-center`}>
                  <TemplateInlineTextEditor value={paymentSideDisplayLabel} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'paymentLabelFixedAmount', value))} disabled={disabled} className="h-[15px] w-full text-center text-[10px] font-bold leading-tight" {...editFieldProps('paymentLabelFixedAmount', false)} />
                </td> : null}
              {showPaymentSideAmount ? <td className={tableCell} colSpan={2}>
                  <TemplateAutomationLockedField {...syncableAutoFieldProps(sideAmountFieldKey, monthlyRent || premiumAmount, {
                      amount: true
                    })} className={amountInputClass} placeholder={`자동입력: ${paymentSideDisplayLabel}`} plainReadOnly title="월차임/권리금" />
                </td> : null}
            </TemplateGridRow>
            <TemplateGridRow rowIndex={1} widths={paymentColumnWidths} boundaryPositions={paymentTableLayout.boundaryPositions} spans={[1, 1, 2, 4]}>
              <td className={labelCell}>{editStaticText('paymentLabelContractDeposit', '계약금')}</td>
              <td className={`${tableCell} text-center`}>{editStaticText('paymentLabelDepositMoney', '금')}</td>
              <td className={tableCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('contractDepositAmount', metaValue('계약금'), {
                      amount: true
                    })} className={amountInputClass} placeholder="자동입력: 계약금" title="계약금" />
              </td>
              <td className={tableCell} colSpan={4}>
                <TemplateInlineTextEditor value={receiptText} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'receiptText', value))} disabled={disabled} className="h-[18px] w-full px-1 text-[10px] leading-tight" {...editFieldProps('receiptText')} />
              </td>
            </TemplateGridRow>
            <TemplateGridRow rowIndex={2} widths={paymentColumnWidths} boundaryPositions={paymentTableLayout.boundaryPositions} spans={isSaleLike || showPaymentSideAmount ? [1, 1, 2, 4] : [1, 1, 6]}>
              <td className={labelCell}>{editStaticText('paymentLabelInterimPayment', isSaleLike ? '중도금' : '계약기간')}</td>
              <td className={`${tableCell} text-center`}>{editStaticText('paymentLabelInterimMoney', isSaleLike ? '금' : '기간')}</td>
              <td className={tableCell} colSpan={isSaleLike || showPaymentSideAmount ? 2 : 6}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps(isSaleLike ? 'interimPaymentAmount' : 'contractPeriodMonths', isSaleLike ? metaValue('중도금') : metaValue('계약기간'), isSaleLike ? {
                      amount: true
                    } : undefined)} className={isSaleLike ? amountInputClass : inputClass} placeholder={`자동입력: ${isSaleLike ? '중도금' : '계약기간'}`} title={isSaleLike ? '중도금' : '계약기간'} />
              </td>
              {isSaleLike || showPaymentSideAmount ? <td className={tableCell} colSpan={4}>
                  {isSaleLike ? <TemplateAutomationLockedField {...syncableAutoFieldProps('interimPaymentDate', metaValue('중도금일'))} className={inputClass} placeholder="자동입력: 중도금일" title="중도금일" /> : <TemplateAutomationLockedField {...syncableAutoFieldProps('rentPaymentDay', metaValue('월세 납입일'))} className={inputClass} placeholder="자동입력: 월세 납입일" title="월세 납입일" />}
                </td> : null}
            </TemplateGridRow>
            <TemplateGridRow rowIndex={3} widths={paymentColumnWidths} boundaryPositions={paymentTableLayout.boundaryPositions} spans={[1, 1, 2, 4]}>
              <td className={labelCell}>{editStaticText('paymentLabelBalance', '잔금')}</td>
              <td className={`${tableCell} text-center`}>{editStaticText('paymentLabelBalanceMoney', '금')}</td>
              <td className={tableCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('balanceAmount', metaValue('잔금'), {
                      amount: true
                    })} className={amountInputClass} placeholder="자동입력: 잔금" title="잔금" />
              </td>
              <td className={tableCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('balanceDate', metaValue('잔금일', '입주/인도일'))} className={inputClass} placeholder="자동입력: 잔금일" title="잔금일" />
              </td>
            </TemplateGridRow>
          </tbody>
        </table>
        </TemplateResizableTableFrame>

        <TemplateInlineTextEditor value={draft.bodyText} onChange={value => onDraftChange({
            ...draft,
            bodyText: value
          })} htmlValue={textLayerRichText(draft, 'bodyText', draft.bodyText)} onHtmlChange={(html, text) => onDraftChange(updateTextLayerRichText(draft, 'bodyText', html, text))} onFocus={() => setSelectedTextFieldKey('bodyText')} onSelectionCapture={() => captureTextSelection('bodyText')} disabled={disabled} className="mt-1 h-[190px] w-full overflow-hidden bg-[repeating-linear-gradient(to_bottom,transparent_0,transparent_13px,#777_14px)] px-0 py-0 text-[9px] leading-[14px] placeholder:text-slate-300" style={templateFieldInlineStyle(textLayerFieldStyle(draft, 'bodyText'))} multiline richMultiline placeholder="계약 조항을 입력합니다. 원본 예시문은 저장하지 않고 텍스트 레이어만 저장됩니다." fieldKey="bodyText" />

        <div className="mt-1 text-[10px] font-bold">특약사항</div>
        <TemplateInlineTextEditor value={noticeTextValue} onChange={value => onDraftChange({
            ...draft,
            noticeText: stripSpecialTermsHeading(value)
          })} htmlValue={textLayerRichText(draft, 'noticeText', noticeTextValue)} onHtmlChange={(html, text) => onDraftChange(updateTextLayerRichText(draft, 'noticeText', html, text))} onFocus={() => setSelectedTextFieldKey('noticeText')} onSelectionCapture={() => captureTextSelection('noticeText')} disabled={disabled} className="h-[126px] w-full overflow-hidden bg-[repeating-linear-gradient(to_bottom,transparent_0,transparent_13px,#777_14px)] px-0 py-0 text-[9px] leading-[14px] placeholder:text-slate-300" style={templateFieldInlineStyle(textLayerFieldStyle(draft, 'noticeText'))} multiline richMultiline placeholder="특약사항 및 필수 안내문구를 입력합니다." fieldKey="noticeText" />

        <div className="mt-1 flex h-[15px] w-full items-center gap-3">
          <TemplateInlineTextEditor value={closingText} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'closingText', value))} disabled={disabled} className="h-full flex-1 text-[10px] leading-tight" {...editFieldProps('closingText', false)} />
          <TemplateInlineTextEditor value={closingDateText} onChange={value => onDraftChange(updateTextLayerCustomText(draft, 'closingDateText', value))} disabled={disabled} className="h-full w-[180px] text-center text-[10px] font-bold leading-tight" {...editFieldProps('closingDateText', false)} />
        </div>
        <TemplateResizableTableFrame tableKey="party" activeTableKey={selectedTableKey} widths={partyColumnWidths} onWidthsChange={widths => updateTableWidths('party', widths)} onActivate={selectTable} onBoundarySelect={setSelectedBoundaryUnit}>
        <table className="mt-1 w-full table-fixed border-collapse text-[6px] leading-none">
          <TemplateColGroup widths={partyColumnWidths} />
          <tbody>
            <tr className={signatureOwnerRowClass}>
              <td className={`${signatureLabelCell} p-0`} rowSpan={3}>{renderDynamicVerticalLabel('partyOwnerRoleLabel', ownerVerticalLabel)}</td>
              <td className={signatureLabelCell}>{editStaticText('partyOwnerLabelAddress', '주소', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={12}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerAddress', signatureReferenceValue(metaValue(`${ownerLabel} 주소`)))} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 주소`} title={`${ownerLabel} 주소`} />
              </td>
              <td className={signatureSealCell} rowSpan={2}>{editStaticText('partyOwnerLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
            <tr className={signatureOwnerRowClass}>
              <td className={signatureResidentLabelCell}>{editStaticText('partyOwnerLabelResidentNumber', '주민등록\n번호', twoLineLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={3}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerResidentNumber', signatureReferenceValue(metaValue(`${ownerLabel} 주민등록번호`)), {
                      residentNumber: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 주민등록번호(생년월일)`} title={`${ownerLabel} 주민등록번호`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyOwnerLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerPhone', signatureReferenceValue(metaValue(`${ownerLabel} 연락처`)), {
                      phone: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 전화`} title={`${ownerLabel} 연락처`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyOwnerLabelName', '성명', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={3}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerName', signatureReferenceValue(ownerName))} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 성명`} title={`${ownerLabel} 성명`} />
              </td>
            </tr>
            <tr className={`${signatureOwnerRowClass} ${signatureAgentDividerRow}`}>
              <td className={signatureLabelCell}>{editStaticText('partyOwnerAgentLabel', '대리인', smallLabelEditorClass)}</td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyOwnerAgentLabelAddress', '주소', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerAgentAddress', signatureReferenceValue(metaValue(`${ownerLabel} 대리인 주소`)))} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 대리인 주소`} title={`${ownerLabel} 대리인 주소`} />
              </td>
              <td className={signatureResidentLabelCell}>{editStaticText('partyOwnerAgentLabelResidentNumber', '주민등록\n번호', twoLineLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerAgentResidentNumber', signatureReferenceValue(metaValue(`${ownerLabel} 대리인 주민등록번호`)), {
                      residentNumber: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 대리인 주민등록번호(생년월일)`} title={`${ownerLabel} 대리인 주민등록번호`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyOwnerAgentLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerAgentPhone', signatureReferenceValue(metaValue(`${ownerLabel} 대리인 연락처`)), {
                      phone: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 대리인 전화`} title={`${ownerLabel} 대리인 전화`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyOwnerAgentLabelName', '성명', smallLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lessorOrSellerAgentName', signatureReferenceValue(ownerAgentName))} className={signatureInputClass} placeholder={`자동입력: ${ownerLabel} 대리인 성명`} title={`${ownerLabel} 대리인 성명`} />
              </td>
              <td className={signatureSealCell}>{editStaticText('partyOwnerAgentLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
            <tr className={`${signatureOwnerRowClass} ${signatureAgentDividerRow}`}>
              <td className={`${signatureLabelCell} p-0`} rowSpan={3}>{renderDynamicVerticalLabel('partyBuyerRoleLabel', buyerVerticalLabel)}</td>
              <td className={signatureLabelCell}>{editStaticText('partyBuyerLabelAddress', '주소', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={12}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerAddress', signatureReferenceValue(metaValue(`${buyerLabel} 주소`)))} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 주소`} title={`${buyerLabel} 주소`} />
              </td>
              <td className={signatureSealCell} rowSpan={2}>{editStaticText('partyBuyerLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
            <tr className={signatureOwnerRowClass}>
              <td className={signatureResidentLabelCell}>{editStaticText('partyBuyerLabelResidentNumber', '주민등록\n번호', twoLineLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={3}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerResidentNumber', signatureReferenceValue(metaValue(`${buyerLabel} 주민등록번호`)), {
                      residentNumber: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 주민등록번호(생년월일)`} title={`${buyerLabel} 주민등록번호`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyBuyerLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerPhone', signatureReferenceValue(metaValue(`${buyerLabel} 연락처`)), {
                      phone: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 전화`} title={`${buyerLabel} 연락처`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyBuyerLabelName', '성명', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={3}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerName', signatureReferenceValue(buyerName))} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 성명`} title={`${buyerLabel} 성명`} />
              </td>
            </tr>
            <tr className={`${signatureOwnerRowClass} ${signatureAgentDividerRow}`}>
              <td className={signatureLabelCell}>{editStaticText('partyBuyerAgentLabel', '대리인', smallLabelEditorClass)}</td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyBuyerAgentLabelAddress', '주소', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerAgentAddress', signatureReferenceValue(metaValue(`${buyerLabel} 대리인 주소`)))} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 대리인 주소`} title={`${buyerLabel} 대리인 주소`} />
              </td>
              <td className={signatureResidentLabelCell}>{editStaticText('partyBuyerAgentLabelResidentNumber', '주민등록\n번호', twoLineLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerAgentResidentNumber', signatureReferenceValue(metaValue(`${buyerLabel} 대리인 주민등록번호`)), {
                      residentNumber: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 대리인 주민등록번호(생년월일)`} title={`${buyerLabel} 대리인 주민등록번호`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyBuyerAgentLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerAgentPhone', signatureReferenceValue(metaValue(`${buyerLabel} 대리인 연락처`)), {
                      phone: true
                    })} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 대리인 전화`} title={`${buyerLabel} 대리인 전화`} />
              </td>
              <td className={signatureSmallLabelCell}>{editStaticText('partyBuyerAgentLabelName', '성명', smallLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('lesseeOrBuyerAgentName', signatureReferenceValue(buyerAgentName))} className={signatureInputClass} placeholder={`자동입력: ${buyerLabel} 대리인 성명`} title={`${buyerLabel} 대리인 성명`} />
              </td>
              <td className={signatureSealCell}>{editStaticText('partyBuyerAgentLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
            <tr className={`${signatureBrokerRowClass} ${signatureAgentDividerRow}`}>
              <td className={`${signatureLabelCell} p-0`} rowSpan={4}>
                {editVerticalStaticText('labelBroker', '중\n개\n업\n자')}
              </td>
              <td className={signatureLabelCell}>{editStaticText('brokerPrimaryLabelOfficeNameV2', '소속', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField value={signatureReferenceValue(realtorProfile.officeName)} className={signatureInputClass} placeholder="자동입력: 중개업자 소속" title="중개업자 소속" fieldKey="auto-primaryBrokerOfficeName" />
              </td>
              <td className={signatureLongLabelCell}>{editStaticText('brokerPrimaryLabelRegistrationNo', '등록번호', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField value={signatureReferenceValue(realtorProfile.registrationNo)} className={signatureInputClass} placeholder="자동입력: 중개업자 등록번호" title="중개업자 등록번호" fieldKey="auto-primaryBrokerRegistrationNo" />
              </td>
              <td className={`${signatureLabelCell} border-l-2 border-l-black p-0`} rowSpan={4}>
                {editVerticalStaticText('labelCoBroker', '공\n동\n중\n개\n인')}
              </td>
              <td className={signatureLabelCell} colSpan={2}>{editStaticText('brokerCoLabelOfficeNameV2', '소속', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerOfficeName', signatureReferenceValue(form?.coBrokerOfficeName ?? ''))} className={signatureInputClass} placeholder="자동입력: 공동중개인 소속" title="공동중개인 소속" />
              </td>
              <td className={signatureLongLabelCell}>{editStaticText('brokerCoLabelRegistrationNo', '등록번호', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerRegistrationNo', signatureReferenceValue(form?.coBrokerRegistrationNo ?? ''))} className={signatureInputClass} placeholder="자동입력: 공동중개인 등록번호" title="공동중개인 등록번호" />
              </td>
            </tr>
            <tr className={signatureBrokerRowClass}>
              <td className={signatureLabelCell}>{editStaticText('brokerPrimaryLabelOfficeAddressV2', '소재지', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={5}>
                <TemplateAutomationLockedField value={signatureReferenceValue(realtorProfile.officeAddress)} className={signatureInputClass} placeholder="자동입력: 중개업자 소재지" title="중개업자 소재지" fieldKey="auto-primaryBrokerOfficeAddress" />
              </td>
              <td className={signatureLabelCell} colSpan={2}>{editStaticText('brokerCoLabelOfficeAddressV2', '소재지', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={5}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerOfficeAddress', signatureReferenceValue(form?.coBrokerOfficeAddress ?? ''))} className={signatureInputClass} placeholder="자동입력: 공동중개인 소재지" title="공동중개인 소재지" />
              </td>
            </tr>
            <tr className={signatureBrokerRowClass}>
              <td className={signatureLabelCell}>{editStaticText('brokerPrimaryLabelRepresentative', '대표', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField value={signatureReferenceValue(realtorProfile.representativeName)} className={signatureInputClass} placeholder="자동입력: 중개업자 대표" title="중개업자 대표" fieldKey="auto-primaryBrokerRepresentativeName" />
              </td>
              <td className={brokerSealCell}>{editStaticText('brokerPrimaryLabelSeal', '(인)', signatureSealEditorClass)}</td>
              <td className={signatureLabelCell} colSpan={2}>{editStaticText('brokerCoLabelRepresentative', '대표', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={4}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerRepresentativeName', signatureReferenceValue(form?.coBrokerRepresentativeName ?? ''))} className={signatureInputClass} placeholder="자동입력: 공동중개인 대표" title="공동중개인 대표" />
              </td>
              <td className={brokerSealCell}>{editStaticText('brokerCoLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
            <tr className={signatureBrokerRowClass}>
              <td className={signatureLabelCell}>{editStaticText('brokerPrimaryLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField value={signatureReferenceValue(realtorProfile.phone)} className={signatureInputClass} placeholder="자동입력: 중개업자 전화" title="중개업자 전화" fieldKey="auto-primaryBrokerPhone" />
              </td>
              <td className={signatureLongLabelCell}>{editStaticText('brokerPrimaryLabelLicensedBroker', '소속\n중개사', brokerLongLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField value={signatureReferenceValue(primaryBrokerManagerName)} className={signatureInputClass} placeholder="자동입력: 중개업자 담당자" title="중개업자 담당자" fieldKey="auto-primaryBrokerManagerName" />
              </td>
              <td className={brokerSealCell}>{editStaticText('brokerPrimaryLicensedLabelSeal', '(인)', signatureSealEditorClass)}</td>
              <td className={signatureLabelCell} colSpan={2}>{editStaticText('brokerCoLabelPhone', '전화', smallLabelEditorClass)}</td>
              <td className={brokerValueCell} colSpan={2}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerPhone', signatureReferenceValue(form?.coBrokerPhone ?? ''), {
                      phone: true
                    })} className={signatureInputClass} placeholder="자동입력: 공동중개인 전화" title="공동중개인 전화" />
              </td>
              <td className={signatureLongLabelCell}>{editStaticText('brokerCoLabelLicensedBroker', '소속\n중개사', brokerLongLabelEditorClass)}</td>
              <td className={brokerValueCell}>
                <TemplateAutomationLockedField {...syncableAutoFieldProps('coBrokerManagerName', signatureReferenceValue(coBrokerManagerName))} className={signatureInputClass} placeholder="자동입력: 공동중개인 담당자" title="공동중개인 담당자" />
              </td>
              <td className={brokerSealCell}>{editStaticText('brokerCoLicensedLabelSeal', '(인)', signatureSealEditorClass)}</td>
            </tr>
          </tbody>
        </table>
        </TemplateResizableTableFrame>

        <input value={draft.footerText} onChange={event => onDraftChange({
            ...draft,
            footerText: event.target.value
          })} onFocus={() => setSelectedTextFieldKey('footerText')} disabled={disabled} className="mt-1 h-3 w-full border-0 text-[8px] text-slate-300 outline-none placeholder:text-slate-200 focus:bg-blue-50" style={templateFieldInlineStyle(textLayerFieldStyle(draft, 'footerText'))} data-template-edit-field="footerText" placeholder={templateLabel || requiredSections.join(' · ')} />
        <div className="mt-auto flex min-h-[74px] items-center justify-between gap-3 border-t border-black pt-3" data-ieum-contract-footer>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-3">
              <img src={ieumLogoSrc} alt="이음" className="h-9 w-auto object-contain" />
              <TemplateAutomationLockedField value={promoText} className="h-7 min-w-[410px] text-[16px] font-black leading-tight tracking-tight" placeholder="이사, 청소, 인터넷 이전은 한방에 이음하세요" title="하단 이음 신청 안내 문구" {...editFieldProps('promoText')} />
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-2" data-ieum-contract-qr-group>
            <TemplateAutomationLockedField value={qrText} className="h-[38px] w-[124px] overflow-hidden whitespace-pre text-right text-[11px] font-black leading-[1.35]" placeholder="QR코드 스캔으로&#10;간편신청하기 →" title="하단 이음 QR 안내 문구" multiline {...editFieldProps('qrText')} />
            {qrImageUrl ? <span className="flex h-[66px] w-[66px] shrink-0 items-center justify-center overflow-hidden border border-black bg-white p-0.5" data-ieum-contract-qr-slot>
                <img src={qrImageUrl} alt="이음 고객신청 QR코드" title="공인중개사 ID별 저장 QR 이미지" data-member-qr-image={memberQrRealtorId} loading="eager" decoding="sync" fetchPriority="high" className="block h-full max-h-full w-full max-w-full object-contain" />
              </span> : <div title="공인중개사 ID별 저장 QR 이미지가 필요합니다" data-member-qr-image="" className="flex h-[66px] w-[66px] items-center justify-center border border-black bg-white p-1 text-center text-[8px] font-bold leading-tight text-slate-500">
                전용 QR
                <br />
                필요
              </div>}
          </div>
        </div>
        </div>
        </div>)}
    </div>;
}
function createEmptyTextLayerDraft() {
  return {
    bodyText: '',
    noticeText: '',
    footerText: '',
    reason: '',
    customTexts: {
      ...DEFAULT_TEMPLATE_CUSTOM_TEXTS
    },
    richTexts: {},
    fieldStyles: normalizeTemplateFieldStyles(null),
    tableLayouts: normalizeTemplateTableLayouts(null),
    explanationFormKey: 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING',
    explanationChecks: normalizeExplanationChecks(DEFAULT_EXPLANATION_CHECK_ITEMS),
    languageBackups: normalizeLanguageBackups(null)
  };
}
function normalizeTextLayerDraft(value, fallback) {
  const record = asRecord(value);
  const fallbackCustomTexts = fallback?.customTexts ?? DEFAULT_TEMPLATE_CUSTOM_TEXTS;
  const rawCustomTexts = asRecord(record.customTexts ?? record.custom_texts);
  const rawRichTexts = asRecord(record.richTexts ?? record.rich_texts);
  const rawFieldStyles = asRecord(record.fieldStyles ?? record.field_styles);
  const customTextSource = {
    ...DEFAULT_TEMPLATE_CUSTOM_TEXTS,
    ...fallbackCustomTexts,
    ...rawCustomTexts
  };
  const customTexts = Object.entries(customTextSource).reduce((acc, [key, defaultValue]) => {
    const hasRawCustomText = Object.prototype.hasOwnProperty.call(rawCustomTexts, key);
    const rawCustomText = hasRawCustomText ? rawCustomTexts[key] : undefined;
    const fallbackText = readText(fallbackCustomTexts, key, String(defaultValue ?? ''));
    acc[key] = sanitizeTemplateCustomText(key, hasRawCustomText ? String(rawCustomText ?? '') : fallbackText);
    return acc;
  }, {});
  const noticeSource = Array.isArray(record.noticeLines) ? record.noticeLines.join('\n') : readText(record, 'noticeText', readText(record, 'notice_text', fallback?.noticeText ?? ''));
  return {
    bodyText: readText(record, 'bodyText', readText(record, 'body_text', fallback?.bodyText ?? '')).replace(/^-$/u, ''),
    noticeText: stripSpecialTermsHeading(String(noticeSource).replace(/^-$/u, '')),
    footerText: sanitizeTemplateFooterText(readText(record, 'footerText', readText(record, 'footer_text', fallback?.footerText ?? ''))).replace(/^-$/u, ''),
    reason: readText(record, 'reason', fallback?.reason ?? '').replace(/^-$/u, ''),
    customTexts,
    richTexts: Object.entries({
      ...(fallback?.richTexts ?? {}),
      ...rawRichTexts
    }).reduce((acc, [key, value]) => {
      acc[key] = String(value ?? '');
      return acc;
    }, {}),
    fieldStyles: normalizeTemplateFieldStyles(rawFieldStyles, fallback?.fieldStyles),
    tableLayouts: normalizeTemplateTableLayouts(record.tableLayouts ?? record.table_layouts, fallback?.tableLayouts),
    explanationFormKey: readText(record, 'explanationFormKey', readText(record, 'explanation_form_key', fallback?.explanationFormKey ?? 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING')),
    explanationChecks: normalizeExplanationChecks(record.explanationChecks ?? record.explanation_checks, fallback?.explanationChecks ?? DEFAULT_EXPLANATION_CHECK_ITEMS),
    languageBackups: normalizeLanguageBackups(record.languageBackups ?? record.language_backups ?? fallback?.languageBackups)
  };
}
function resolveDocumentTypeLabel(value) {
  const key = String(value ?? '').trim().toUpperCase();
  return DOCUMENT_TYPE_LABELS[key] ?? (key || '문서');
}
function getDocumentFileReference(document) {
  return asRecord(document.fileReference ?? document.file_reference);
}
function getDocumentDownloadPath(document) {
  const directPath = readText(document, 'downloadPath', '') || readText(document, 'download_path', '');
  if (directPath) return normalizeDocumentDownloadPath(directPath);
  const fileReferenceId = readText(document, 'fileReferenceId', '') || readText(document, 'file_reference_id', '');
  return fileReferenceId ? normalizeDocumentDownloadPath(`/api/files/${fileReferenceId}/download/`) : '';
}
function prepareContractTemplatePrintClone() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  const source = document.querySelector('[data-contract-print-sheet]');
  if (!source) return false;
  document.querySelectorAll('[data-contract-print-clone]').forEach(node => node.remove());
  const clone = source.cloneNode(true);
  clone.setAttribute('data-contract-print-clone', 'true');
  clone.removeAttribute('data-contract-print-sheet');
  const sourceFields = source.querySelectorAll('input, textarea');
  const cloneFields = clone.querySelectorAll('input, textarea');
  sourceFields.forEach((field, index) => {
    const cloneField = cloneFields[index];
    if (cloneField) cloneField.value = field.value;
  });
  document.body.appendChild(clone);
  document.body.setAttribute('data-realtorauto-print-mode', 'contract-template');
  document.body.setAttribute('data-realtorauto-contract-print-ready', 'true');
  return true;
}
function cleanupContractTemplatePrintClone() {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-contract-print-clone]').forEach(node => node.remove());
  document.body.removeAttribute('data-realtorauto-print-mode');
  document.body.removeAttribute('data-realtorauto-contract-print-ready');
}
function printContractTemplateSheet() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  if (!prepareContractTemplatePrintClone()) return false;
  let cleanupTimer = null;
  const cleanup = () => {
    if (cleanupTimer) window.clearTimeout(cleanupTimer);
    cleanupContractTemplatePrintClone();
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup, {
    once: true
  });
  window.print();
  cleanupTimer = window.setTimeout(cleanup, 60_000);
  return true;
}
function ensureExplanationFormPrintStyle() {
  if (typeof document === 'undefined') return;
  if (document.querySelector('[data-explanation-print-style]')) return;
  const style = document.createElement('style');
  style.setAttribute('data-explanation-print-style', 'true');
  style.textContent = `
    @media print {
      @page {
        size: A4 portrait;
        margin: 0;
      }
      body[data-realtorauto-print-mode="explanation-form"] {
        width: 210mm !important;
        min-width: 210mm !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: #fff !important;
      }
      body[data-realtorauto-print-mode="explanation-form"] > *:not([data-explanation-print-clone]) {
        display: none !important;
      }
      [data-explanation-print-clone] {
        display: block !important;
        position: relative !important;
        width: 210mm !important;
        min-width: 210mm !important;
        max-width: 210mm !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: #fff !important;
        box-shadow: none !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      [data-explanation-print-clone],
      [data-explanation-print-clone] * {
        visibility: visible !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      [data-explanation-print-clone] img {
        width: 100% !important;
        border: 0 !important;
        border-radius: 0 !important;
      }
    }
  `;
  document.head.appendChild(style);
}
function prepareExplanationFormPrintClone() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  const sources = Array.from(document.querySelectorAll('[data-explanation-print-page-source]'));
  if (!sources.length) return false;
  cleanupExplanationFormPrintClone();
  ensureExplanationFormPrintStyle();
  sources.forEach((source, index) => {
    const clone = source.cloneNode(true);
    clone.setAttribute('data-explanation-print-clone', 'true');
    clone.removeAttribute('data-explanation-print-page-source');
    clone.style.width = '210mm';
    clone.style.minWidth = '210mm';
    clone.style.maxWidth = '210mm';
    clone.style.margin = '0';
    clone.style.padding = '0';
    if (index < sources.length - 1) {
      clone.style.breakAfter = 'page';
      clone.style.pageBreakAfter = 'always';
    }
    document.body.appendChild(clone);
  });
  document.body.setAttribute('data-realtorauto-print-mode', 'explanation-form');
  return true;
}
function cleanupExplanationFormPrintClone() {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-explanation-print-clone]').forEach(node => node.remove());
  document.body.removeAttribute('data-realtorauto-print-mode');
}
function printExplanationFormViewerPage() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  if (!prepareExplanationFormPrintClone()) return false;
  let cleanupTimer = null;
  const cleanup = () => {
    if (cleanupTimer) window.clearTimeout(cleanupTimer);
    cleanupExplanationFormPrintClone();
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup, {
    once: true
  });
  window.print();
  cleanupTimer = window.setTimeout(cleanup, 60_000);
  return true;
}
function documentHasReadyReference(document) {
  const fileReference = getDocumentFileReference(document);
  const fileReferenceStatus = String(readText(fileReference, 'status', '')).trim().toLowerCase();
  const fileReferenceId = readText(document, 'fileReferenceId', '') || readText(document, 'file_reference_id', '');
  const fileHash = readText(document, 'fileHashSha256', '') || readText(document, 'file_hash_sha256', '');
  return Boolean(fileReferenceId && fileHash && getDocumentDownloadPath(document) && (!fileReferenceStatus || fileReferenceStatus === 'active'));
}
function documentIsReadable(document) {
  const status = String(readText(document, 'status', '')).trim().toUpperCase();
  return DOCUMENT_READY_STATUSES.has(status) && documentHasReadyReference(document);
}
function isInvalidAutomationApiChipValue(value) {
  const text = value.normalize('NFKC').replace(/\s+/gu, ' ').trim();
  if (!text) return false;
  if (/\[object\s+(?:Object|Array)\]/iu.test(text)) return true;
  if (/^(?:undefined|null)$/iu.test(text)) return true;
  return /(?:조회\s*(?:실패|오류)|인증키|오류|실패|직접\s*확인\s*필요|확인\s*필요)/iu.test(text);
}
export { TemplateLivePreviewEditor, DEFAULT_TEMPLATE_DRAFTS, TEMPLATE_EDITOR_CATEGORIES, TEMPLATE_EDITOR_ITEMS, getTemplateDraftFallback, normalizeTextLayerDraft, resolveTemplateEditorLabel, isExplanationTemplateKey };
